import { makeApi, Zodios, type ZodiosOptions } from "@zodios/core";
import { z } from "zod";

const github_com_falqondev_cidade360_backend_service_ActionPlanUserView = z
  .object({
    instID: z.string(),
    inusID: z.number(),
    userAvatar: z.string().nullish(),
    userEmail: z.string().nullish(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanView = z
  .object({
    acplID: z.string(),
    actionCount: z.number(),
    actionPlanUsers: z.array(
      github_com_falqondev_cidade360_backend_service_ActionPlanUserView
    ),
    attachment: z.string().nullish(),
    comments: z.number().nullish(),
    content: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    doneActionCount: z.number(),
    doneMilestoneCount: z.number(),
    instID: z.string(),
    institutionAbbreviation: z.string(),
    institutionName: z.string(),
    institutionUserAvatar: z.string().nullish(),
    institutionUserEmail: z.string().nullish(),
    institutionUserName: z.string(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    milestoneCount: z.number(),
    mostID: z.number().nullish(),
    mostOrderIndex: z.number(),
    name: z.string(),
    period: z
      .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
      .passthrough(),
    progID: z.string().nullish(),
    projID: z.string(),
    projectInfo: z
      .object({
        displayOptions: z.object({ color: z.string() }).passthrough().nullish(),
        name: z.string(),
        projID: z.string(),
      })
      .passthrough(),
    revision: z
      .object({
        apbrID: z.number(),
        approvedBy: z.string().nullish(),
        approverName: z.string().nullish(),
        budgets: z.array(
          z
            .object({
              actual: z.string(),
              attachments: z.array(z.string()),
              brtyID: z.number().nullish(),
              budgID: z.string(),
              busoID: z.number(),
              butyID: z.number().nullish(),
              predicted: z.string(),
              rationale: z.string().nullish(),
              received: z.string(),
              referenceYear: z.string().nullish(),
            })
            .passthrough()
        ),
        createdAt: z.string(),
        deletedAt: z.string().nullish(),
        reviewMessage: z.string(),
        userID: z.string(),
        userName: z.string(),
      })
      .passthrough()
      .nullish(),
    status: z
      .object({
        acplID: z.string(),
        approvedBy: z.string().nullish(),
        approverName: z.string().nullish(),
        apstID: z.number(),
        attachments: z.array(z.string()),
        deletedAt: z.string().nullish(),
        info: z
          .object({
            displayOptions: z
              .object({ color: z.string() })
              .passthrough()
              .nullable(),
          })
          .partial()
          .passthrough(),
        message: z.string(),
        orderIndex: z.number(),
        referenceDate: z.string(),
        requestReview: z.boolean(),
        reviewMessage: z.string(),
        statID: z.number(),
        state: z.string(),
        status: z.string(),
        userID: z.string(),
        userName: z.string(),
      })
      .passthrough(),
    thematicAxisInfo: z.array(
      z
        .object({
          displayOptions: z
            .object({ color: z.string() })
            .passthrough()
            .nullish(),
          thaxID: z.number(),
        })
        .passthrough()
    ),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanBudgetForm = z
  .object({
    actual: z.string(),
    attachments: z.array(z.string()),
    brtyID: z.number().nullish(),
    busoID: z.number(),
    butyID: z.number().nullish(),
    predicted: z.string(),
    rationale: z.string().nullish(),
    received: z.string(),
    referenceYear: z.string().nullish(),
  })
  .passthrough();
const actionPlanCreate_Body = z
  .object({
    actionPlanUsers: z.array(z.number()),
    attachment: z.string().nullish(),
    budgets: z.array(
      github_com_falqondev_cidade360_backend_service_ActionPlanBudgetForm
    ),
    content: z.string(),
    description: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    projID: z.string(),
    status: z
      .object({
        attachments: z.array(z.string()),
        message: z.string(),
        nextResourceID: z.string().nullish(),
        nextResourceType: z.string().nullish(),
        previousResourceID: z.string().nullish(),
        previousResourceType: z.string().nullish(),
        referenceDate: z.string(),
        statID: z.number(),
      })
      .passthrough(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanStatusView = z
  .object({
    acplID: z.string(),
    actionPlanName: z.string(),
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    apstID: z.number(),
    attachments: z.array(z.string()),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    message: z.string(),
    orderIndex: z.number(),
    referenceDate: z.string(),
    requestReview: z.boolean(),
    reviewMessage: z.string(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const actionPlanUpdate_Body = z
  .object({
    actionPlanUsers: z.array(z.number()),
    attachment: z.string().nullish(),
    budgets: z.array(
      github_com_falqondev_cidade360_backend_service_ActionPlanBudgetForm
    ),
    content: z.string(),
    description: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    projID: z.string(),
    type: z.string(),
  })
  .passthrough();
const actionPlanBudgetApprove_Body = z
  .object({ apbrID: z.number(), approve: z.boolean(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanCommentView = z
  .object({
    acplID: z.string(),
    attachment: z.string().nullish(),
    commID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    message: z.string(),
    userAvatar: z.string().nullish(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const actionPlanCommentCreate_Body = z
  .object({ attachment: z.string().nullish(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory = z
  .object({
    acplID: z.string(),
    actionPlanName: z.string(),
    apbrID: z.number(),
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    budgets: z.array(
      z
        .object({
          actual: z.string(),
          attachments: z.array(z.string()),
          brtyID: z.number().nullish(),
          budgID: z.string(),
          busoID: z.number(),
          butyID: z.number().nullish(),
          predicted: z.string(),
          rationale: z.string().nullish(),
          received: z.string(),
          referenceYear: z.string().nullish(),
        })
        .passthrough()
    ),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    reviewMessage: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory = z
  .object({
    acplID: z.string(),
    createdAt: z.string(),
    endAt: z.string(),
    oppeID: z.number(),
    startAt: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const actionPlanStatusUpdate_Body = z
  .object({
    attachments: z.array(z.string()),
    message: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
    referenceDate: z.string(),
    statID: z.number(),
  })
  .passthrough();
const actionPlanStatusApprove_Body = z
  .object({ approve: z.boolean(), apstID: z.number(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionCommentView = z
  .object({
    actiID: z.string(),
    attachment: z.string().nullish(),
    commID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    message: z.string(),
    userAvatar: z.string().nullish(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionView = z
  .object({
    acplID: z.string(),
    actiID: z.string(),
    actionPlanName: z.string(),
    comments: z.number().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string(),
    institutionAbbreviation: z.string(),
    institutionName: z.string(),
    inusID: z.number(),
    milestone: z.boolean(),
    mostID: z.number().nullish(),
    mostOrderIndex: z.number(),
    name: z.string(),
    parentID: z.string().nullish(),
    period: z
      .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
      .passthrough(),
    progID: z.string().nullish(),
    projID: z.string(),
    projectInfo: z
      .object({
        displayOptions: z.object({ color: z.string() }).passthrough().nullish(),
        name: z.string(),
        projID: z.string(),
      })
      .passthrough(),
    status: z
      .object({
        acstID: z.number(),
        actiID: z.string(),
        approvedBy: z.string().nullish(),
        approverName: z.string().nullish(),
        attachments: z.array(z.string()),
        createdAt: z.string(),
        deletedAt: z.string().nullish(),
        info: z
          .object({
            displayOptions: z
              .object({ color: z.string() })
              .passthrough()
              .nullable(),
          })
          .partial()
          .passthrough(),
        message: z.string(),
        orderIndex: z.number(),
        referenceDate: z.string(),
        requestReview: z.boolean(),
        reviewMessage: z.string(),
        statID: z.number(),
        state: z.string(),
        status: z.string(),
        userID: z.string(),
        userName: z.string(),
      })
      .passthrough(),
    userAvatar: z.string().nullish(),
    userEmail: z.string().nullish(),
    userName: z.string().nullish(),
  })
  .passthrough();
const actionCreate_Body = z
  .object({
    acplID: z.string(),
    instID: z.string().nullish(),
    inusID: z.number(),
    milestone: z.boolean(),
    name: z.string(),
    parentID: z.string().nullish(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    status: z
      .object({
        attachments: z.array(z.string()),
        message: z.string(),
        nextResourceID: z.string().nullish(),
        nextResourceType: z.string().nullish(),
        previousResourceID: z.string().nullish(),
        previousResourceType: z.string().nullish(),
        referenceDate: z.string(),
        statID: z.number(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionStatusView = z
  .object({
    acstID: z.number(),
    actiID: z.string(),
    actionName: z.string(),
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    attachments: z.array(z.string()),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    message: z.string(),
    orderIndex: z.number(),
    referenceDate: z.string(),
    requestReview: z.boolean(),
    reviewMessage: z.string(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const actionUpdate_Body = z
  .object({
    acplID: z.string(),
    instID: z.string().nullish(),
    inusID: z.number(),
    milestone: z.boolean(),
    name: z.string(),
    parentID: z.string().nullish(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPeriodHistory = z
  .object({
    acpeID: z.number(),
    actiID: z.string(),
    createdAt: z.string(),
    endAt: z.string(),
    oppeID: z.number(),
    startAt: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const actionStatusApprove_Body = z
  .object({ acstID: z.number(), approve: z.boolean(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_aiChatMessage =
  z.object({ content: z.string(), role: z.string() }).passthrough();
const aiChatCompletions_Body = z
  .object({
    messages: z.array(
      github_com_falqondev_cidade360_backend_api_http_admin_server_aiChatMessage
    ),
    model: z.string(),
    stream: z.boolean().nullish(),
  })
  .passthrough();
const aiResponses_Body = z
  .object({
    input: z.string(),
    model: z.string(),
    stream: z.boolean().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails = z
  .object({
    aproID: z.string(),
    assignmentRules: z.array(z.string()),
    description: z.string(),
    name: z.string(),
    roles: z.array(z.string()),
  })
  .passthrough();
const applicationRoleCreate_Body = z
  .object({
    assignmentRules: z.array(z.string()),
    description: z.string(),
    name: z.string(),
    roles: z.array(z.string()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractDate = z
  .object({
    acdaID: z.string(),
    arcoID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    occursAt: z.string(),
    updatedAt: z.string(),
    venue: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractLog = z
  .object({
    acloID: z.string(),
    arcoID: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    eventType: z.string(),
    message: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractView = z
  .object({
    agency: z.string(),
    arcoID: z.string(),
    attrID: z.string(),
    attractionName: z.string().nullish(),
    attractionStatus: z.string().nullish(),
    blockingItems: z.array(z.string()).nullish(),
    cievID: z.string(),
    code: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    dates: z
      .array(
        github_com_falqondev_cidade360_backend_service_ArtisticContractDate
      )
      .nullish(),
    deadlineExpired: z.boolean(),
    deletedAt: z.string().nullish(),
    eventName: z.string().nullish(),
    finalizationDeadline: z.string(),
    logs: z
      .array(github_com_falqondev_cidade360_backend_service_ArtisticContractLog)
      .nullish(),
    requestedAmount: z.string(),
    spplID: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusID: z.string().nullish(),
    supplierDocument: z.string().nullish(),
    supplierName: z.string().nullish(),
    supplierStatus: z.string().nullish(),
    updatedAt: z.string(),
    venue: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractDateForm =
  z.object({ occursAt: z.string(), venue: z.string().nullish() }).passthrough();
const artisticContractCreate_Body = z
  .object({
    agency: z.string(),
    attrID: z.string(),
    cievID: z.string(),
    code: z.string(),
    dates: z.array(
      github_com_falqondev_cidade360_backend_service_ArtisticContractDateForm
    ),
    finalizationDeadline: z.string(),
    requestedAmount: z.string(),
    venue: z.string(),
  })
  .passthrough();
const artisticContractCancel_Body = z
  .object({ expectedStatusID: z.string(), reason: z.string() })
  .passthrough();
const artisticContractProposalDecision_Body = z
  .object({
    approved: z.boolean(),
    detail: z.string(),
    expectedStatusID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionClippingLink = z
  .object({
    acliID: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    label: z.string().nullish(),
    orderIndex: z.number(),
    updatedAt: z.string(),
    url: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionDocument = z
  .object({
    atdoID: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documentType: z.string(),
    filePath: z.string(),
    updatedAt: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionFiscalValue = z
  .object({
    afvaID: z.string(),
    amount: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    position: z.number(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionView = z
  .object({
    attrID: z.string(),
    attractionType: z.string(),
    clippingLinks: z
      .array(
        github_com_falqondev_cidade360_backend_service_AttractionClippingLink
      )
      .nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documents: z
      .array(github_com_falqondev_cidade360_backend_service_AttractionDocument)
      .nullish(),
    fiscalAverage: z.string(),
    fiscalValues: z
      .array(
        github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
      )
      .nullish(),
    missingDocumentTypes: z.array(z.string()).nullish(),
    name: z.string(),
    registryStatus: z.string().nullish(),
    spplID: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusID: z.string().nullish(),
    supplierDocument: z.string().nullish(),
    supplierName: z.string().nullish(),
    updatedAt: z.string(),
    videoUrl: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionDocumentView = z
  .object({
    atdoID: z.string(),
    attrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documentType: z.string(),
    filePath: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusID: z.string().nullish(),
    updatedAt: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const attractionUpdateDocumentStatus_Body = z
  .object({
    detail: z.string(),
    expectedStatusID: z.string(),
    status: z.string(),
  })
  .passthrough();
const attractionUpdateStatus_Body = z
  .object({
    detail: z.string(),
    expectedStatusID: z.string().nullish(),
    status: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AuditLogView = z
  .object({
    action: z.string(),
    auloID: z.number(),
    createdAt: z.string(),
    createdBy: z.string(),
    resourceMetadata: z.unknown(),
    resourceName: z.string(),
    userInfo: z
      .object({
        avatar: z.string().nullable(),
        email: z.string().nullable(),
        name: z.string().nullable(),
      })
      .partial()
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetResourceType = z
  .object({
    brtyID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetSource = z
  .object({
    busoID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetType = z
  .object({
    butyID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricChild = z
  .object({ bumeID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram =
  z.object({ name: z.string(), progID: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject =
  z.object({ name: z.string(), projID: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_RuleCustomKPIValue = z
  .object({ targetAt: z.string(), value: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ReferenceValue = z
  .object({ numValue: z.string(), referenceDate: z.string().nullish() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Rule = z
  .object({
    baselinePeriodEnd: z.string().nullish(),
    baselinePeriodStart: z.string().nullish(),
    baselineValue: z.string(),
    calc: z.string(),
    cukpID: z.number().nullish(),
    customKPIName: z.string().nullish(),
    customKPIValues: z
      .array(github_com_falqondev_cidade360_backend_service_RuleCustomKPIValue)
      .nullish(),
    displayOption: z.string(),
    kpi: z.string(),
    name: z.string(),
    operation: z.string(),
    referenceValues: z
      .array(github_com_falqondev_cidade360_backend_service_ReferenceValue)
      .nullish(),
    source: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricUserView = z
  .object({
    inusID: z.number(),
    userAvatar: z.string().nullish(),
    userEmail: z.string().nullish(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricView = z
  .object({
    bumeID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    instID: z.string().nullish(),
    institutionAbbreviation: z.string().nullish(),
    institutionName: z.string().nullish(),
    kpiProgress: z
      .object({
        actual: z.string(),
        baselinePeriodEnd: z.string().nullish(),
        baselinePeriodStart: z.string().nullish(),
        baselineValue: z.string(),
        displayOption: z.string(),
        offTrack: z.string(),
        onTrack: z.string(),
        referenceDate: z.string().nullish(),
        referenceValue: z.string(),
      })
      .passthrough(),
    metricType: z.string(),
    metrics: z.array(
      github_com_falqondev_cidade360_backend_service_BusinessMetricChild
    ),
    name: z.string(),
    periodValueInDays: z.number().nullish(),
    planID: z.string(),
    programs: z.array(
      github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
    ),
    progressLink: z
      .object({
        acplID: z.string().nullable(),
        actiID: z.string().nullable(),
        actionName: z.string().nullable(),
        actionPlanName: z.string().nullable(),
        progID: z.string().nullable(),
        programName: z.string().nullable(),
        projID: z.string().nullable(),
        projectName: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    projects: z.array(
      github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
    ),
    rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
    status: z.string(),
    users: z.array(
      github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
    ),
  })
  .passthrough();
const businessMetricCreate_Body = z
  .object({
    acplID: z.string().nullish(),
    actiID: z.string().nullish(),
    description: z.string().nullish(),
    instID: z.string(),
    inusIDs: z.array(z.number()),
    metricType: z.string(),
    metrics: z.array(z.number()),
    name: z.string(),
    planID: z.string(),
    progID: z.string().nullish(),
    programs: z.array(z.string()),
    projID: z.string().nullish(),
    projects: z.array(z.string()),
    rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
    status: z.string(),
  })
  .passthrough();
const businessMetricKpiCreate_Body = z
  .object({
    businessMetric: z
      .object({
        acplID: z.string().nullish(),
        actiID: z.string().nullish(),
        description: z.string().nullish(),
        instID: z.string(),
        inusIDs: z.array(z.number()),
        metricType: z.string(),
        metrics: z.array(z.number()),
        name: z.string(),
        planID: z.string(),
        progID: z.string().nullish(),
        programs: z.array(z.string()),
        projID: z.string().nullish(),
        projects: z.array(z.string()),
        rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
        status: z.string(),
      })
      .passthrough(),
    customKPI: z
      .object({
        acplID: z.string().nullish(),
        actiID: z.string().nullish(),
        description: z.string().nullish(),
        kpiType: z.string(),
        meunID: z.number().nullish(),
        name: z.string(),
        periodValueDisplay: z.string().nullish(),
        periodValueInDays: z.number().nullish(),
        progID: z.string().nullish(),
        projID: z.string().nullish(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessType = z
  .object({
    bstpID: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    isFisicaDefault: z.boolean(),
    label: z.string(),
  })
  .passthrough();
const businessTypeCreate_Body = z
  .object({ description: z.string(), label: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType =
  z
    .object({ bstpID: z.string(), doctID: z.string(), sbtdID: z.string() })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_CityEvent = z
  .object({
    cievID: z.string(),
    contractingMethods: z.array(z.string()),
    createdAt: z.string(),
    createdBy: z.string(),
    deletedAt: z.string().nullish(),
    endsAt: z.string(),
    evclID: z.string(),
    eventYear: z.number(),
    name: z.string(),
    parentCievID: z.string().nullish(),
    participatesInRegistration: z.boolean(),
    startsAt: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const cityEventCreate_Body = z
  .object({
    contractingMethods: z.array(z.string()),
    endsAt: z.string(),
    evclID: z.string(),
    eventYear: z.number(),
    name: z.string(),
    parentCievID: z.string().nullish(),
    participatesInRegistration: z.boolean(),
    startsAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ContractTerminationStatus =
  z
    .object({
      changedBy: z.string(),
      coteID: z.string(),
      createdAt: z.string(),
      ctstID: z.string(),
      current: z.boolean(),
      detail: z.string().nullish(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_ContractTerminationView = z
  .object({
    arcoID: z.string(),
    attractionName: z.string().nullish(),
    code: z.string(),
    contractCode: z.string(),
    coteID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    eventName: z.string().nullish(),
    requestedBy: z.string(),
    requesterName: z.string().nullish(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    statusDetail: z.string().nullish(),
    statusHistory: z
      .array(
        github_com_falqondev_cidade360_backend_service_ContractTerminationStatus
      )
      .nullish(),
    statusID: z.string().nullish(),
    supplierName: z.string().nullish(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_CustomKPIView = z
  .object({
    acplID: z.string().nullish(),
    actiID: z.string().nullish(),
    actionName: z.string().nullish(),
    actionPlanName: z.string().nullish(),
    createdAt: z.string(),
    cukpID: z.number(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    kpiType: z.string(),
    meunID: z.number().nullish(),
    name: z.string(),
    periodValueDisplay: z.string().nullish(),
    periodValueInDays: z.number().nullish(),
    progID: z.string().nullish(),
    programName: z.string().nullish(),
    projID: z.string().nullish(),
    projectName: z.string().nullish(),
    updatedAt: z.string(),
  })
  .passthrough();
const customKPICreate_Body = z
  .object({
    acplID: z.string().nullish(),
    actiID: z.string().nullish(),
    description: z.string().nullish(),
    kpiType: z.string(),
    meunID: z.number().nullish(),
    name: z.string(),
    periodValueDisplay: z.string().nullish(),
    periodValueInDays: z.number().nullish(),
    progID: z.string().nullish(),
    projID: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_CustomKPIValueView = z
  .object({
    approved: z.boolean(),
    approverName: z.string().nullish(),
    attachments: z.array(z.string()),
    ckreID: z.number().nullish(),
    cpvaID: z.number(),
    createdAt: z.string(),
    cukpID: z.number(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    message: z.string().nullish(),
    reviewedAt: z.string().nullish(),
    reviewedBy: z.string().nullish(),
    targetAt: z.string(),
    userID: z.string(),
    userName: z.string(),
    value: z.string(),
    valueOmitted: z.boolean(),
  })
  .passthrough();
const customKPIApprove_Body = z
  .object({ approved: z.boolean(), cpvaID: z.number(), message: z.string() })
  .passthrough();
const customKPIValuesCreate_Body = z
  .object({
    attachments: z.array(z.string()),
    description: z.string(),
    targetAt: z.string(),
    value: z.string(),
    valueOmitted: z.boolean(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature =
  z
    .object({
      innaID: z.number(),
      natureName: z.string(),
      securityIncidents: z
        .object({ inciIDs: z.array(z.string()), total: z.number() })
        .passthrough(),
      serviceIncidents: z
        .object({ inciIDs: z.array(z.string()), total: z.number() })
        .passthrough(),
      total: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood =
  z
    .object({
      neighborhood: z.string(),
      securityIncidents: z
        .object({ inciIDs: z.array(z.string()), total: z.number() })
        .passthrough(),
      serviceIncidents: z
        .object({ inciIDs: z.array(z.string()), total: z.number() })
        .passthrough(),
      total: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetSummary = z
  .object({
    axisName: z.string(),
    sumActual: z.number(),
    sumPredicted: z.number(),
    sumReceived: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanLatestComments = z
  .object({
    acplID: z.string(),
    actiID: z.string().nullish(),
    avatar: z.string().nullish(),
    createdAt: z.string(),
    message: z.string(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanNextTask = z
  .object({
    acplID: z.string(),
    actiID: z.string(),
    finishDate: z.string(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Resource = z
  .object({ name: z.string(), totalCount: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ResourceCount = z
  .object({
    createdDate: z.string().nullish(),
    resourceCount: z.number(),
    resourceType: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardSurveyResponse = z
  .object({ answers: z.number(), date: z.string().nullish() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderByProgram = z
  .object({
    status: z.string(),
    total: z.number(),
    woorIDs: z.array(z.string()),
    wostID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram =
  z
    .object({
      programName: z.string(),
      total: z.number(),
      woprID: z.number(),
      workOrders: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderByProgram
      ),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderByStatus = z
  .object({ date: z.string(), total: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus =
  z
    .object({
      status: z.string(),
      statusInfo: z
        .object({
          displayOptions: z
            .object({ color: z.string() })
            .passthrough()
            .nullable(),
        })
        .partial()
        .passthrough(),
      total: z.number(),
      workOrders: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderByStatus
      ),
      wostID: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView =
  z
    .object({
      createdAt: z.string(),
      ddteID: z.number(),
      deletedAt: z.string().nullish(),
      description: z.string(),
      formField: z.string(),
      formName: z.string(),
      instID: z.string(),
      institutionName: z.string(),
      name: z.string(),
      placeholder: z.boolean(),
    })
    .passthrough();
const defaultDescriptionTextCreate_Body = z
  .object({
    description: z.string(),
    formField: z.string(),
    formName: z.string(),
    instID: z.string(),
    name: z.string(),
    placeholder: z.boolean(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchNatureView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    dinaID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const dispatchNatureCreate_Body = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchStatusView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    distID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchSubnatureView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    dinaID: z.number(),
    disuID: z.number(),
    name: z.string(),
  })
  .passthrough();
const dispatchSubnatureCreate_Body = z
  .object({ dinaID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchUnitView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    diunID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DocumentTemplate = z
  .object({
    createdAt: z.string(),
    defaultData: z.unknown(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
    updatedAt: z.string(),
  })
  .passthrough();
const documentTemplateCreate_Body = z
  .object({
    defaultData: z.unknown(),
    description: z.string().nullish(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField =
  z
    .object({
      description: z.string(),
      name: z.string(),
      validation: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentType = z
  .object({
    deletedAt: z.string().nullish(),
    doctID: z.string(),
    extractionFields: z.array(
      github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
    ),
    label: z.string(),
    validationPrompt: z.string(),
  })
  .passthrough();
const documentTypeCreate_Body = z
  .object({
    extractionFields: z.array(
      github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
    ),
    label: z.string(),
    validationPrompt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DocumentationView = z
  .object({
    content: z.string(),
    createdAt: z.string(),
    docuID: z.number(),
    tags: z.array(z.string()),
    title: z.string(),
    videoURL: z.string(),
  })
  .passthrough();
const documentationCreate_Body = z
  .object({
    content: z.string(),
    tags: z.array(z.string()).nullish(),
    title: z.string(),
    videoURL: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Document = z
  .object({
    createdAt: z.string(),
    data: z.unknown(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    docuID: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
    updatedAt: z.string(),
  })
  .passthrough();
const documentCreate_Body = z
  .object({
    data: z.unknown(),
    description: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_EventClassification = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    evclID: z.string(),
    name: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FleetVehicleView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    details: z
      .object({
        carrying_capacity: z.string(),
        color: z.string(),
        dimensions: z
          .object({ height: z.number(), length: z.number(), width: z.number() })
          .passthrough(),
        engine: z
          .object({ capacity: z.string(), type: z.string() })
          .passthrough(),
        features: z.array(z.string()),
        mileage_km: z.number(),
        purchase_date: z.string(),
        seat_numbers: z.number(),
        serial_number: z.string(),
        type: z.string(),
        warranty: z
          .object({ details: z.string().nullish(), expiry_date: z.string() })
          .passthrough(),
      })
      .passthrough(),
    flveID: z.number(),
    instID: z.string(),
    institutionName: z.string().nullish(),
    licensePlate: z.string(),
    make: z.string(),
    model: z.string(),
    registrationNumber: z.string(),
    updatedAt: z.string(),
    year: z.number(),
  })
  .passthrough();
const fleetVehicleCreate_Body = z
  .object({
    details: z
      .object({
        carrying_capacity: z.string(),
        color: z.string(),
        dimensions: z
          .object({ height: z.number(), length: z.number(), width: z.number() })
          .passthrough(),
        engine: z
          .object({ capacity: z.string(), type: z.string() })
          .passthrough(),
        features: z.array(z.string()),
        mileage_km: z.number(),
        purchase_date: z.string(),
        seat_numbers: z.number(),
        serial_number: z.string(),
        type: z.string(),
        warranty: z
          .object({ details: z.string().nullish(), expiry_date: z.string() })
          .passthrough(),
      })
      .passthrough(),
    instID: z.string(),
    licensePlate: z.string(),
    make: z.string(),
    model: z.string(),
    registrationNumber: z.string(),
    year: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      doteID: z.string(),
      fodtID: z.number(),
      formName: z.string(),
      instID: z.string(),
      institutionName: z.string(),
    })
    .passthrough();
const formDocumentTemplateCreate_Body = z
  .object({
    documentTemplate: z
      .object({
        defaultData: z.unknown(),
        description: z.string().nullish(),
        formSchema: z.unknown(),
        permissionMode: z.string(),
        printSchema: z.unknown(),
        title: z.string(),
        uiSchema: z.unknown(),
      })
      .passthrough(),
    formName: z.string(),
    instID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FormValidationView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    formName: z.string(),
    fovaID: z.number(),
    instID: z.string(),
    institutionName: z.string(),
    validationSchema: z.unknown(),
  })
  .passthrough();
const formValidationCreate_Body = z
  .object({
    formName: z.string(),
    instID: z.string(),
    validationSchema: z.unknown(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_GuicheView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    guicID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentActionTypeView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    iatyID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentDispatcherView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    indiID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    inenID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      inesID: z.number(),
      instID: z.string().nullish(),
      institutionName: z.string().nullish(),
      name: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentNatureView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    innaID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentOriginView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    inorID: z.number(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentProgramView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    inprID: z.number(),
    instID: z.string(),
    institutionName: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const incidentProgramCreate_Body = z
  .object({ instID: z.string(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      instID: z.string().nullish(),
      institutionName: z.string().nullish(),
      irloID: z.number(),
      name: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentStatus = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string().nullable() })
          .partial()
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    istaID: z.number(),
    name: z.string(),
    reasons: z.array(z.string()).nullish(),
    requiredReason: z.boolean().nullish(),
  })
  .passthrough();
const incidentStatusCreate_Body = z
  .object({
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string().nullable() })
          .partial()
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    reasons: z.array(z.string()).nullish(),
    requiredReason: z.boolean().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentSubnatureView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    inbnID: z.number(),
    innaID: z.number(),
    name: z.string(),
  })
  .passthrough();
const incidentSubnatureCreate_Body = z
  .object({ innaID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentSubprogramView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    inprID: z.number(),
    insuID: z.number(),
    name: z.string(),
  })
  .passthrough();
const incidentSubprogramCreate_Body = z
  .object({ inprID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Depredation = z
  .object({
    costEstimate: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    deprID: z.number(),
    level: z.string(),
    owner: z.string(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentVehicleView = z
  .object({
    departedAt: z.string().nullish(),
    flveID: z.number(),
    ifdiID: z.number(),
    inveID: z.number(),
    licensePlate: z.string(),
    model: z.string(),
    responsibleName: z.string(),
    returnedAt: z.string().nullish(),
    userID: z.string(),
    year: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InvolvedPartyView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    documentNumber: z.string(),
    documentType: z.string(),
    educationLevel: z.string().nullish(),
    estimatedAge: z.number().nullish(),
    incidentResponseLocation: z.string(),
    income: z.string().nullish(),
    inpaID: z.number(),
    involvementType: z.string(),
    irloID: z.number().nullish(),
    maritalStatus: z.string().nullish(),
    name: z.string().nullish(),
    phcoID: z.number().nullish(),
    physicalCondition: z.string(),
    professionalActivity: z.string().nullish(),
    religion: z.string().nullish(),
    sex: z.string(),
    skinTone: z.string(),
    vulnerablePopulation: z.string(),
    vupoID: z.number().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SeizedItemView = z
  .object({
    amount: z.number(),
    attachment: z.string().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    estimatedValue: z.number().nullish(),
    name: z.string(),
    sealNumber: z.string().nullish(),
    seitID: z.number(),
    storageLocation: z.string(),
    unitOfMeasure: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentView = z
  .object({
    actionTypeName: z.string(),
    address: z
      .object({
        city: z.string().nullish(),
        complement: z.string().nullish(),
        isVillage: z.boolean(),
        latitude: z.number().nullish(),
        longitude: z.number().nullish(),
        neighborhood: z.string().nullish(),
        number: z.string().nullish(),
        state: z.string().nullish(),
        street: z.string().nullish(),
        zipCode: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    agentID: z.string().nullish(),
    agentName: z.string(),
    agentRole: z.string().nullish(),
    arrivalAt: z.string().nullish(),
    buunID: z.number().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    depredations: z.array(
      github_com_falqondev_cidade360_backend_service_Depredation
    ),
    description: z.string(),
    details: z
      .object({
        confidential: z.boolean().nullable(),
        protocolNumber: z.string().nullable(),
        relatorAttachment: z.string().nullable(),
        relatorDescription: z.string().nullable(),
        solution: z.string().nullable(),
      })
      .partial()
      .passthrough(),
    dinaID: z.number().nullish(),
    dispatchNature: z.string(),
    dispatchStatus: z.string(),
    dispatchSubnature: z.string(),
    dispatchUnit: z.string(),
    dispatcherName: z.string(),
    distID: z.number().nullish(),
    disuID: z.number().nullish(),
    diunID: z.number().nullish(),
    environmentName: z.string().nullish(),
    establishmentName: z.string().nullish(),
    fieldContact: z
      .object({ name: z.string().nullable(), phone: z.string().nullable() })
      .partial()
      .passthrough(),
    guicID: z.number().nullish(),
    guicheName: z.string(),
    iatyID: z.number().nullish(),
    ifdiID: z.number().nullish(),
    inbnID: z.number().nullish(),
    inciID: z.string(),
    incidentType: z.string(),
    incidentVehicles: z.array(
      github_com_falqondev_cidade360_backend_service_IncidentVehicleView
    ),
    indeID: z.number().nullish(),
    indiID: z.number().nullish(),
    inenID: z.number().nullish(),
    inesID: z.number().nullish(),
    infdID: z.number().nullish(),
    ininID: z.number().nullish(),
    innaID: z.number().nullish(),
    inorID: z.number().nullish(),
    inprID: z.number().nullish(),
    inseID: z.number().nullish(),
    instID: z.string(),
    institutionName: z.string(),
    insuID: z.number().nullish(),
    involvedParties: z.array(
      github_com_falqondev_cidade360_backend_service_InvolvedPartyView
    ),
    istaID: z.number(),
    natureName: z.string(),
    originName: z.string(),
    partnerInstID: z.string().nullish(),
    partnerInstitutionName: z.string(),
    programName: z.string(),
    progressionFromUid: z.string().nullish(),
    publicEquipmentName: z.string(),
    pueqID: z.number().nullish(),
    relatorCode: z.string().nullish(),
    relatorID: z.string().nullish(),
    relatorName: z.string(),
    relatorRole: z.string().nullish(),
    requester: z
      .object({
        email: z.string().nullable(),
        name: z.string().nullable(),
        phone: z.string().nullable(),
        sex: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    sechID: z.number().nullish(),
    seizedItems: z.array(
      github_com_falqondev_cidade360_backend_service_SeizedItemView
    ),
    serviceChannelName: z.string(),
    servicedAt: z.string().nullish(),
    statusInfo: z
      .object({
        displayOptions: z
          .object({ color: z.string().nullable() })
          .partial()
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    statusName: z.string(),
    statusReason: z.string().nullish(),
    subnatureName: z.string(),
    subprogramName: z.string(),
    uid: z.string(),
    updatedAt: z.string(),
    userID: z.string(),
    workOrderUid: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DepredationForm = z
  .object({
    costEstimate: z.string(),
    level: z.string(),
    owner: z.string(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DocumentForm = z
  .object({
    data: z.unknown(),
    description: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentVehicleForm = z
  .object({
    departedAt: z.string().nullish(),
    flveID: z.number(),
    returnedAt: z.string().nullish(),
    userID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InvolvedPartyForm = z
  .object({
    description: z.string(),
    documentNumber: z.string().nullish(),
    documentType: z.string().nullish(),
    educationLevel: z.string().nullish(),
    estimatedAge: z.number().nullish(),
    income: z.string().nullish(),
    involvementType: z.string(),
    irloID: z.number().nullish(),
    maritalStatus: z.string().nullish(),
    name: z.string().nullish(),
    phcoID: z.number().nullish(),
    professionalActivity: z.string().nullish(),
    religion: z.string().nullish(),
    sex: z.string(),
    skinTone: z.string(),
    vupoID: z.number().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SeizedItemForm = z
  .object({
    amount: z.number(),
    attachment: z.string().nullish(),
    description: z.string(),
    estimatedValue: z.number().nullish(),
    name: z.string(),
    sealNumber: z.string().nullish(),
    storageLocation: z.string(),
    unitOfMeasure: z.string(),
  })
  .passthrough();
const incidentCreate_Body = z
  .object({
    address: z
      .object({
        city: z.string().nullish(),
        complement: z.string().nullish(),
        isVillage: z.boolean(),
        latitude: z.number().nullish(),
        longitude: z.number().nullish(),
        neighborhood: z.string().nullish(),
        number: z.string().nullish(),
        state: z.string().nullish(),
        street: z.string().nullish(),
        zipCode: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    agentID: z.string().nullish(),
    agentRole: z.string().nullish(),
    arrivalAt: z.string().nullish(),
    buunID: z.number().nullish(),
    depredations: z
      .array(github_com_falqondev_cidade360_backend_service_DepredationForm)
      .nullish(),
    description: z.string().nullish(),
    details: z
      .object({
        confidential: z.boolean().nullable(),
        protocolNumber: z.string().nullable(),
        relatorAttachment: z.string().nullable(),
        relatorDescription: z.string().nullable(),
        solution: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    dinaID: z.number().nullish(),
    distID: z.number().nullish(),
    disuID: z.number().nullish(),
    diunID: z.number().nullish(),
    documents: z
      .array(github_com_falqondev_cidade360_backend_service_DocumentForm)
      .nullish(),
    fieldContact: z
      .object({ name: z.string().nullable(), phone: z.string().nullable() })
      .partial()
      .passthrough()
      .nullish(),
    guicID: z.number().nullish(),
    iatyID: z.number().nullish(),
    inbnID: z.number().nullish(),
    incidentType: z.string(),
    incidentVehicles: z
      .array(github_com_falqondev_cidade360_backend_service_IncidentVehicleForm)
      .nullish(),
    indiID: z.number().nullish(),
    inenID: z.number().nullish(),
    inesID: z.number().nullish(),
    innaID: z.number().nullish(),
    inorID: z.number().nullish(),
    inprID: z.number().nullish(),
    instID: z.string(),
    insuID: z.number().nullish(),
    involvedParties: z
      .array(github_com_falqondev_cidade360_backend_service_InvolvedPartyForm)
      .nullish(),
    istaID: z.number(),
    partnerInstID: z.string().nullish(),
    progressionFromUid: z.string().nullish(),
    pueqID: z.number().nullish(),
    relatorID: z.string().nullish(),
    relatorRole: z.string().nullish(),
    requester: z
      .object({
        email: z.string().nullable(),
        name: z.string().nullable(),
        phone: z.string().nullable(),
        sex: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    sechID: z.number().nullish(),
    seizedItems: z
      .array(github_com_falqondev_cidade360_backend_service_SeizedItemForm)
      .nullish(),
    servicedAt: z.string().nullish(),
    statusReason: z.string().nullish(),
    workOrderUid: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentDocumentView = z
  .object({
    createdAt: z.string(),
    data: z.unknown(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    docuID: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    inciID: z.string(),
    infdID: z.number(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Institution = z
  .object({
    abbreviation: z.string(),
    avatar: z.string().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    documentNumber: z.string(),
    documentType: z.string(),
    instID: z.string(),
    name: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const institutionCreate_Body = z
  .object({
    abbreviation: z.string(),
    avatar: z.string().nullish(),
    documentNumber: z.string().nullish(),
    documentType: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessUnit = z
  .object({
    abbreviation: z.string(),
    address: z
      .object({
        city: z.string(),
        country: z.string(),
        neighborhood: z.string(),
        number: z.string(),
        state: z.string(),
        street: z.string(),
        zipCode: z.string(),
      })
      .passthrough()
      .nullish(),
    buunID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string(),
    inusID: z.number().nullish(),
    name: z.string(),
    phone: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const institutionUnitCreate_Body = z
  .object({
    abbreviation: z.string().nullish(),
    address: z
      .object({
        city: z.string(),
        country: z.string(),
        neighborhood: z.string(),
        number: z.string(),
        state: z.string(),
        street: z.string(),
        zipCode: z.string(),
      })
      .passthrough(),
    inusID: z.number().nullish(),
    name: z.string(),
    phone: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InstitutionUserView = z
  .object({
    admittedAt: z.string().nullish(),
    buunID: z.number().nullish(),
    code: z.string().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string(),
    inusID: z.number(),
    name: z.string(),
    operationalCode: z.string().nullish(),
    phone: z.string(),
    sex: z.string(),
    updatedAt: z.string(),
    userID: z.string(),
  })
  .passthrough();
const institutionUserCreate_Body = z
  .object({
    admittedAt: z.string().nullish(),
    buunID: z.number().nullish(),
    code: z.string().nullish(),
    operationalCode: z.string().nullish(),
    phone: z.string(),
    sex: z.string(),
    userID: z.string(),
  })
  .passthrough();
const institutionUserUpdate_Body = z
  .object({
    admittedAt: z.string().nullish(),
    buunID: z.number().nullish(),
    code: z.string().nullish(),
    operationalCode: z.string().nullish(),
    phone: z.string(),
    sex: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_KanbanView = z
  .object({
    createdAt: z.string(),
    defaultStatus: z.boolean(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    mostID: z.number(),
    name: z.string(),
    orderIndex: z.number(),
    updatedAt: z.string(),
  })
  .passthrough();
const kanbanCreate_Body = z
  .object({
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    name: z.string(),
    orderIndex: z.number(),
  })
  .passthrough();
const kanbanLinksCreate_Body = z
  .object({
    movedResourceID: z.string(),
    movedResourceType: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    planID: z.string(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_KanbanLinkView = z
  .object({
    mostID: z.number(),
    orderIndex: z.number(),
    resourceID: z.string(),
    resourceType: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_MeasurementUnit = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    formatConfig: z
      .object({
        decimalPlaces: z.number(),
        decimalSep: z.string(),
        prefix: z.string(),
        suffix: z.string(),
        thousandsSep: z.string(),
      })
      .passthrough(),
    meunID: z.number(),
    name: z.string(),
  })
  .passthrough();
const measurementUnitCreate_Body = z
  .object({
    formatConfig: z
      .object({
        decimalPlaces: z.number(),
        decimalSep: z.string(),
        prefix: z.string(),
        suffix: z.string(),
        thousandsSep: z.string(),
      })
      .passthrough()
      .nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_MyTaskQueueItem = z
  .object({
    createdAt: z.string(),
    info: z.unknown(),
    institutionAbbreviation: z.string().nullish(),
    institutionName: z.string().nullish(),
    readonly: z.boolean(),
    resourceID: z.string(),
    resourceName: z.string(),
    taskType: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule =
  z.object({ daysBefore: z.number(), doctID: z.string() }).passthrough();
const notificationConfigUpdate_Body = z
  .object({
    module: z.string(),
    notificationIntegrations: z
      .object({
        email: z
          .object({
            active: z.boolean(),
            password: z.string(),
            port: z.number(),
            server: z.string(),
            user: z.string(),
          })
          .passthrough()
          .nullable(),
        googleChat: z
          .object({
            accessToken: z.string().nullish(),
            active: z.boolean(),
            clientID: z.string(),
            clientSecret: z.string(),
            expiresAt: z.string().nullish(),
            name: z.string(),
            refreshToken: z.string().nullish(),
          })
          .passthrough()
          .nullable(),
        teams: z
          .object({
            accessToken: z.string().nullish(),
            active: z.boolean(),
            chatID: z.string(),
            clientID: z.string(),
            clientSecret: z.string(),
            expiresAt: z.string().nullish(),
            graphUserID: z.string().nullish(),
            refreshToken: z.string().nullish(),
            tenantID: z.string(),
          })
          .passthrough()
          .nullable(),
        whatsapp: z
          .object({
            active: z.boolean(),
            phoneID: z.string(),
            token: z.string(),
            wabaID: z.string(),
          })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    rules: z
      .object({
        notifySupplierDocumentExpiring: z.boolean(),
        notifySupplierDocumentStatusChange: z.boolean(),
        notifySupplierPenaltyCreated: z.boolean(),
        notifySupplierRegistryStatusChange: z.boolean(),
        supplierDocumentExpiryRules: z
          .array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
          )
          .nullish(),
      })
      .passthrough(),
  })
  .passthrough();
const notificationIntegrationsUpdate_Body = z
  .object({
    email: z
      .object({
        active: z.boolean(),
        password: z.string(),
        port: z.number(),
        server: z.string(),
        user: z.string(),
      })
      .passthrough()
      .nullable(),
    googleChat: z
      .object({
        accessToken: z.string().nullish(),
        active: z.boolean(),
        clientID: z.string(),
        clientSecret: z.string(),
        expiresAt: z.string().nullish(),
        name: z.string(),
        refreshToken: z.string().nullish(),
      })
      .passthrough()
      .nullable(),
    teams: z
      .object({
        accessToken: z.string().nullish(),
        active: z.boolean(),
        chatID: z.string(),
        clientID: z.string(),
        clientSecret: z.string(),
        expiresAt: z.string().nullish(),
        graphUserID: z.string().nullish(),
        refreshToken: z.string().nullish(),
        tenantID: z.string(),
      })
      .passthrough()
      .nullable(),
    whatsapp: z
      .object({
        active: z.boolean(),
        phoneID: z.string(),
        token: z.string(),
        wabaID: z.string(),
      })
      .passthrough()
      .nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_NotificationView = z
  .object({
    createdAt: z.string(),
    data: z.unknown(),
    notiID: z.string(),
    path: z.string(),
    readAt: z.string().nullish(),
    userID: z.string(),
  })
  .passthrough();
const notificationRead_Body = z
  .object({ notiID: z.array(z.string()) })
  .passthrough();
const oneTimeLoginCreate_Body = z
  .object({ userID: z.string(), validUntil: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenaltyView = z
  .object({
    cnpj: z.string().nullish(),
    complement: z.string().nullish(),
    contractNumber: z.string().nullish(),
    cpf: z.string().nullish(),
    createdAt: z.string(),
    decisionType: z.string().nullish(),
    deletedAt: z.string().nullish(),
    description: z.string().nullish(),
    dom: z.string(),
    endDate: z.string(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    legalBasis: z.string(),
    legalBasisDescription: z.string().nullish(),
    legalName: z.string().nullish(),
    pennID: z.string(),
    personType: z.string().nullish(),
    process: z.string(),
    publishingDate: z.string(),
    sanctionType: z.string(),
    scopID: z.string(),
    spplID: z.string(),
    startDate: z.string(),
    tradeName: z.string().nullish(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string().nullish(),
    label: z.string(),
    scopID: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const penaltyScopeCreate_Body = z
  .object({ description: z.string().nullish(), label: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PhysicalConditionView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
    phcoID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjetcUserView = z
  .object({
    instID: z.string(),
    inusID: z.number(),
    userAvatar: z.string().nullish(),
    userEmail: z.string().nullish(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    endAt: z.string(),
    instID: z.string(),
    institutionName: z.string(),
    institutionUserName: z.string(),
    inusID: z.number(),
    isDefault: z.boolean(),
    name: z.string(),
    planID: z.string(),
    planUsers: z.array(
      github_com_falqondev_cidade360_backend_service_ProjetcUserView
    ),
    startAt: z.string(),
    thaxID: z.array(z.number()),
  })
  .passthrough();
const plansCreate_Body = z
  .object({
    endAt: z.string(),
    inusID: z.number(),
    isDefault: z.boolean(),
    name: z.string(),
    planUsers: z.array(z.number()),
    startAt: z.string(),
    thaxID: z.array(z.number()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramUserView = z
  .object({
    instID: z.string(),
    inusID: z.number(),
    userAvatar: z.string().nullish(),
    userEmail: z.string().nullish(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramView = z
  .object({
    axes: z.array(z.number()),
    budgets: z.array(
      z
        .object({
          actual: z.string(),
          attachments: z.array(z.string()),
          brtyID: z.number().nullish(),
          budgID: z.string(),
          busoID: z.number(),
          butyID: z.number().nullish(),
          predicted: z.string(),
          rationale: z.string().nullish(),
          received: z.string(),
          referenceYear: z.string().nullish(),
        })
        .passthrough()
    ),
    content: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    instID: z.string().nullish(),
    institutionAbbreviation: z.string().nullish(),
    institutionName: z.string().nullish(),
    institutionUserAvatar: z.string().nullish(),
    institutionUserEmail: z.string().nullish(),
    institutionUserName: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number().nullish(),
    milestoneCount: z.number(),
    milestoneDoneCount: z.number(),
    mostID: z.number().nullish(),
    mostOrderIndex: z.number(),
    name: z.string(),
    period: z
      .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
      .passthrough(),
    planID: z.string(),
    progID: z.string(),
    programUsers: z.array(
      github_com_falqondev_cidade360_backend_service_ProgramUserView
    ),
    projectCount: z.number(),
    projectDoneCount: z.number(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    statusInfo: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    statusMessage: z.string(),
    statusOrderIndex: z.number(),
    statusReferenceDate: z.string(),
    thematicAxisInfo: z.array(
      z
        .object({
          displayOptions: z
            .object({ color: z.string() })
            .passthrough()
            .nullish(),
          thaxID: z.number(),
        })
        .passthrough()
    ),
  })
  .passthrough();
const programCreate_Body = z
  .object({
    axes: z.array(z.number()),
    content: z.string(),
    description: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number().nullish(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    programUsers: z.array(z.number()),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramCommentView = z
  .object({
    attachment: z.string().nullish(),
    commID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    message: z.string(),
    progID: z.string(),
    userAvatar: z.string().nullish(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory = z
  .object({
    progID: z.string(),
    updatedAt: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory = z
  .object({
    createdAt: z.string(),
    endAt: z.string(),
    oppeID: z.number(),
    progID: z.string(),
    prpeID: z.number(),
    startAt: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramStatusHistory = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    message: z.string(),
    progID: z.string(),
    referenceDate: z.string(),
    statID: z.number(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const programStatusUpdate_Body = z
  .object({
    message: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
    referenceDate: z.string(),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectView = z
  .object({
    actionPlanCount: z.number(),
    actionPlanDoneCount: z.number(),
    attachment: z.string().nullish(),
    axes: z.array(z.number()),
    budgets: z.array(
      z
        .object({
          actual: z.string(),
          attachments: z.array(z.string()),
          brtyID: z.number().nullish(),
          budgID: z.string(),
          busoID: z.number(),
          butyID: z.number().nullish(),
          predicted: z.string(),
          rationale: z.string().nullish(),
          received: z.string(),
          referenceYear: z.string().nullish(),
        })
        .passthrough()
    ),
    content: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    instID: z.string(),
    institutionAbbreviation: z.string(),
    institutionName: z.string(),
    institutionUserAvatar: z.string().nullish(),
    institutionUserEmail: z.string().nullish(),
    institutionUserName: z.string(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    milestoneCount: z.number(),
    milestoneDoneCount: z.number(),
    mostID: z.number().nullish(),
    mostOrderIndex: z.number(),
    name: z.string(),
    period: z
      .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
      .passthrough(),
    planID: z.string(),
    progID: z.string().nullish(),
    projID: z.string(),
    projectUsers: z.array(
      github_com_falqondev_cidade360_backend_service_ProjetcUserView
    ),
    status: z
      .object({
        approvedBy: z.string().nullish(),
        approverName: z.string().nullish(),
        attachments: z.array(z.string()),
        deletedAt: z.string().nullish(),
        info: z
          .object({
            displayOptions: z
              .object({ color: z.string() })
              .passthrough()
              .nullable(),
          })
          .partial()
          .passthrough(),
        message: z.string(),
        orderIndex: z.number(),
        projID: z.string(),
        prstID: z.number(),
        referenceDate: z.string(),
        requestReview: z.boolean(),
        reviewMessage: z.string(),
        statID: z.number(),
        state: z.string(),
        status: z.string(),
        userID: z.string(),
        userName: z.string(),
      })
      .passthrough(),
    thematicAxisInfo: z.array(
      z
        .object({
          displayOptions: z
            .object({ color: z.string() })
            .passthrough()
            .nullish(),
          thaxID: z.number(),
        })
        .passthrough()
    ),
  })
  .passthrough();
const projectCreate_Body = z
  .object({
    attachment: z.string().nullish(),
    axes: z.array(z.number()),
    content: z.string(),
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    progID: z.string().nullish(),
    projectUsers: z.array(z.number()),
    status: z
      .object({
        attachments: z.array(z.string()),
        message: z.string(),
        nextResourceID: z.string().nullish(),
        nextResourceType: z.string().nullish(),
        previousResourceID: z.string().nullish(),
        previousResourceType: z.string().nullish(),
        referenceDate: z.string(),
        statID: z.number(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectStatusView = z
  .object({
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    attachments: z.array(z.string()),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    message: z.string(),
    orderIndex: z.number(),
    projID: z.string(),
    projectName: z.string(),
    prstID: z.number(),
    referenceDate: z.string(),
    requestReview: z.boolean(),
    reviewMessage: z.string(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const projectUpdate_Body = z
  .object({
    attachment: z.string().nullish(),
    axes: z.array(z.number()),
    content: z.string(),
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    progID: z.string().nullish(),
    projectUsers: z.array(z.number()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectCommentView = z
  .object({
    attachment: z.string().nullish(),
    commID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    message: z.string(),
    projID: z.string(),
    userAvatar: z.string().nullish(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory = z
  .object({
    projID: z.string(),
    updatedAt: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory = z
  .object({
    createdAt: z.string(),
    endAt: z.string(),
    oppeID: z.number(),
    projID: z.string(),
    startAt: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const projectStatusApprove_Body = z
  .object({ approve: z.boolean(), message: z.string(), prstID: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PublicEquipmentView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
    pueqID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_RequestingCompanyView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
    recoID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ServiceChannelView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
    sechID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_StatusView = z
  .object({
    createdAt: z.string(),
    defaultStatus: z.boolean(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    orderIndex: z.number(),
    requestReview: z.boolean(),
    slug: z.string(),
    statID: z.number(),
    state: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const statusCreate_Body = z
  .object({
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    name: z.string(),
    orderIndex: z.number(),
    requestReview: z.boolean(),
    state: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_StatusLinkView = z
  .object({
    orderIndex: z.number(),
    resourceID: z.string(),
    resourceType: z.string(),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierBank = z
  .object({
    code: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    name: z.string(),
    subaID: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const supplierBankCreate_Body = z
  .object({ code: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassGroup = z
  .object({
    clgrID: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    label: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup = z
  .object({ clgrID: z.string(), label: z.string(), scsgID: z.string() })
  .passthrough();
const supplierClassSubGroupCreate_Body = z
  .object({ clgrID: z.string(), label: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClass = z
  .object({
    clasID: z.string(),
    code: z.string(),
    label: z.string(),
    scsgID: z.string(),
  })
  .passthrough();
const supplierClassCreate_Body = z
  .object({ code: z.string(), label: z.string(), scsgID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierRegistry = z
  .object({
    additionalAddressInfo: z.string().nullish(),
    address: z.string().nullish(),
    addressNumber: z.number().nullish(),
    bankName: z.string().nullish(),
    branch: z.string().nullish(),
    bstpID: z.string().nullish(),
    businessTypeName: z.string().nullish(),
    checkingAccount: z.string().nullish(),
    city: z.string().nullish(),
    cnpj: z.string().nullish(),
    country: z.string().nullish(),
    cpf: z.string().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    email: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    legalName: z.string().nullish(),
    municipalRegistration: z.string().nullish(),
    neighborhood: z.string().nullish(),
    personType: z.string(),
    phone: z.string().nullish(),
    postalCode: z.string().nullish(),
    registryStatus: z.string().nullish(),
    spplID: z.string(),
    state: z.string().nullish(),
    stateRegistration: z.string().nullish(),
    status: z.string(),
    subaID: z.string().nullish(),
    tradeName: z.string().nullish(),
    updatedAt: z.string(),
    userID: z.string().nullish(),
    verifiedEmail: z.boolean().nullish(),
    verifiedPhone: z.boolean().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView =
  z
    .object({
      createdAt: z.string(),
      daysToExpire: z.number(),
      doctID: z.string(),
      documentLabel: z.string(),
      expiryStatus: z.string(),
      filePath: z.string(),
      spdcID: z.string(),
      spplID: z.string(),
      status: z.string().nullish(),
      statusAt: z.string().nullish(),
      supplierDocument: z.string().nullish(),
      supplierName: z.string(),
      updatedAt: z.string(),
      validity: z.string().nullish(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentView = z
  .object({
    createdAt: z.string(),
    doctID: z.string(),
    filePath: z.string(),
    spdcID: z.string(),
    spplID: z.string(),
    status: z.string().nullish(),
    statusAt: z.string().nullish(),
    updatedAt: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const supplierHumanReviewDocument_Body = z
  .object({
    detail: z.string(),
    expectedStatusID: z.string(),
    validationResult: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const supplierUpdateDocumentStatus_Body = z
  .object({
    detail: z.string(),
    status: z.string(),
    validity: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult =
  z
    .object({
      name: z.string(),
      reason: z.string(),
      valid: z.boolean(),
      value: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAttempt =
  z
    .object({
      attemptID: z.string(),
      completedAt: z.string().nullish(),
      createdAt: z.string(),
      cycleAttempt: z.number(),
      cycleNumber: z.number(),
      diagnostic: z
        .object({
          causes: z.array(z.string()),
          code: z.string(),
          createdAt: z.string(),
          message: z.string(),
          stage: z.string(),
          version: z.number(),
        })
        .passthrough()
        .nullish(),
      maxFailures: z.number(),
      outcome: z
        .object({
          aiInvoked: z.string(),
          diagnostic: z
            .object({
              causes: z.array(z.string()),
              code: z.string(),
              createdAt: z.string(),
              message: z.string(),
              stage: z.string(),
              version: z.number(),
            })
            .passthrough()
            .nullish(),
          failureCount: z.number(),
          maxFailures: z.number(),
          retryAt: z.string().nullish(),
          status: z.string(),
        })
        .passthrough()
        .nullish(),
      reason: z.string().nullish(),
      requestID: z.string().nullish(),
      requestedBy: z.string().nullish(),
      retryDelaySeconds: z.number(),
      sequence: z.number(),
      startedAt: z.string().nullish(),
      state: z.string(),
      updatedAt: z.string(),
      verificationID: z.string(),
      workflowID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvent =
  z
    .object({
      attemptID: z.string(),
      createdAt: z.string(),
      diagnostic: z
        .object({
          causes: z.array(z.string()),
          code: z.string(),
          createdAt: z.string(),
          message: z.string(),
          stage: z.string(),
          version: z.number(),
        })
        .passthrough()
        .nullish(),
      eventID: z.number(),
      eventKey: z.string(),
      evidence: z
        .object({
          aiInvoked: z.string(),
          bytes: z.number(),
          durationMS: z.number(),
          inputTokens: z.number(),
          model: z.string(),
          outputTokens: z.number(),
          provider: z.string(),
          sha256: z.string(),
          totalTokens: z.number(),
        })
        .passthrough(),
      stage: z.string(),
      state: z.string(),
    })
    .passthrough();
const supplierReprocessDocumentVerification_Body = z
  .object({
    expectedCycle: z.number(),
    expectedStatusID: z.string(),
    reason: z.string(),
    requestID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenalty = z
  .object({
    complement: z.string().nullish(),
    contractNumber: z.string().nullish(),
    createdAt: z.string(),
    decisionType: z.string().nullish(),
    deletedAt: z.string().nullish(),
    description: z.string().nullish(),
    dom: z.string(),
    endDate: z.string(),
    legalBasis: z.string(),
    legalBasisDescription: z.string().nullish(),
    pennID: z.string(),
    process: z.string(),
    publishingDate: z.string(),
    sanctionType: z.string(),
    scopID: z.string(),
    spplID: z.string(),
    startDate: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const supplierPenaltyCreate_Body = z
  .object({
    complement: z.string(),
    contractNumber: z.string(),
    decisionType: z.string(),
    description: z.string(),
    dom: z.string(),
    endDate: z.string(),
    legalBasis: z.string(),
    legalBasisDescription: z.string(),
    pennID: z.string().nullish(),
    process: z.string(),
    publishingDate: z.string(),
    sanctionType: z.string(),
    scopID: z.string(),
    startDate: z.string(),
  })
  .passthrough();
const supplierUpdateStatus_Body = z
  .object({ detail: z.string(), status: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ManagerReviewNote = z
  .object({
    createdAt: z.string(),
    mrvnID: z.string(),
    note: z.string().nullish(),
    spplID: z.string(),
    userID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyResponseData = z
  .object({
    clientDevice: z.string(),
    clientIP: z.string(),
    clientUID: z.string(),
    createdAt: z.string(),
    data: z.unknown(),
    docuID: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    metadata: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyResponseListing = z
  .object({
    name: z.string(),
    responses: z.array(
      github_com_falqondev_cidade360_backend_service_SurveyResponseData
    ),
    submittedAt: z.string().nullish(),
    sursID: z.string(),
    survID: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const surveyResponseCreate_Body = z
  .object({
    clientDevice: z.string(),
    clientIP: z.string(),
    clientUID: z.string(),
    docuID: z.string().nullish(),
    document: z
      .object({
        data: z.unknown(),
        description: z.string(),
        doteID: z.string(),
        formSchema: z.unknown(),
        permissionMode: z.string(),
        printSchema: z.unknown(),
        title: z.string(),
        uiSchema: z.unknown(),
      })
      .passthrough()
      .nullish(),
    doteID: z.string(),
    metadata: z.unknown(),
    sursID: z.string(),
    survID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyForm = z
  .object({
    deletedAt: z.string().nullish(),
    doteID: z.string(),
    position: z.number(),
    survID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Survey = z
  .object({
    activeAt: z.string().nullish(),
    allowedUsers: z.array(z.string()),
    answers: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    descriptionFinished: z.string(),
    displayOptions: z.unknown(),
    drafts: z.number(),
    slug: z.string(),
    survID: z.string(),
    surveyForms: z.array(
      github_com_falqondev_cidade360_backend_service_SurveyForm
    ),
    title: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InputSurveyForm = z
  .object({ doteID: z.string(), position: z.number() })
  .passthrough();
const surveyCreate_Body = z
  .object({
    activeAt: z.string().nullish(),
    allowedUsers: z.array(z.string()),
    description: z.string().nullish(),
    descriptionFinished: z.string().nullish(),
    displayOptions: z.unknown(),
    slug: z.string().nullish(),
    surveyForms: z
      .array(github_com_falqondev_cidade360_backend_service_InputSurveyForm)
      .nullish(),
    title: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_MySurvey = z
  .object({
    activeAt: z.string().nullish(),
    answers: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    descriptionFinished: z.string(),
    displayOptions: z.unknown(),
    drafts: z.number(),
    slug: z.string(),
    survID: z.string(),
    surveyForms: z.array(
      github_com_falqondev_cidade360_backend_service_SurveyForm
    ),
    title: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PendingTerm = z
  .object({ slug: z.string(), termID: z.number(), title: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Term = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    slug: z.string(),
    termID: z.number(),
    title: z.string(),
    type: z.string(),
  })
  .passthrough();
const termCreate_Body = z
  .object({
    description: z.string(),
    slug: z.string(),
    title: z.string(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ThematicAxis = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    thaxID: z.number(),
    updatedAt: z.string(),
  })
  .passthrough();
const thematicAxisCreate_Body = z
  .object({
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UrbanEquipmentView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string(),
    ureqID: z.number(),
  })
  .passthrough();
const userRoleCreate_Body = z
  .object({ aproIDs: z.array(z.string()), userID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PermissionItem = z
  .object({ action: z.string(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PermissionModule = z
  .object({
    label: z.string(),
    module: z.string(),
    permissions: z.array(
      github_com_falqondev_cidade360_backend_service_PermissionItem
    ),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UserInstitutions = z
  .object({
    abbreviation: z.string(),
    code: z.string(),
    instID: z.string().nullish(),
    inusID: z.number().nullish(),
    name: z.string(),
    operationalCode: z.string(),
    phone: z.string(),
    unit: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UserInformation = z
  .object({
    applID: z.string(),
    authenticationProvider: z.string(),
    avatar: z.string().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    email: z.string().nullish(),
    info: z.object({ tourCompleted: z.boolean() }).passthrough(),
    name: z.string(),
    phone: z.string().nullish(),
    pushTokens: z.array(z.string()).nullish(),
    roles: z.array(z.string()),
    userID: z.string(),
    userInstitutions: z.array(
      github_com_falqondev_cidade360_backend_service_UserInstitutions
    ),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InstitutionUserCreateFormByUser =
  z
    .object({
      admittedAt: z.string().nullish(),
      buunID: z.number().nullish(),
      code: z.string().nullish(),
      instID: z.string(),
      operationalCode: z.string().nullish(),
      phone: z.string(),
      sex: z.string(),
    })
    .passthrough();
const userCreate_Body = z
  .object({
    applID: z.string(),
    avatar: z.string().nullish(),
    email: z.string(),
    institutions: z.array(
      github_com_falqondev_cidade360_backend_service_InstitutionUserCreateFormByUser
    ),
    name: z.string(),
    password: z.string().nullish(),
  })
  .passthrough();
const userUpdate_Body = z
  .object({
    avatar: z.string().nullable(),
    email: z.string().nullable(),
    name: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_VulnerablePopulationView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      instID: z.string().nullish(),
      institutionName: z.string().nullish(),
      name: z.string(),
      vupoID: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      instID: z.string().nullish(),
      institutionName: z.string().nullish(),
      name: z.string(),
      woclID: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderProgramView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    instID: z.string(),
    institutionName: z.string().nullish(),
    name: z.string(),
    woprID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      instID: z.string().nullish(),
      institutionName: z.string().nullish(),
      name: z.string(),
      worfID: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView =
  z
    .object({
      createdAt: z.string(),
      deletedAt: z.string().nullish(),
      instID: z.string().nullish(),
      institutionName: z.string().nullish(),
      name: z.string(),
      wortID: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderStatusView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    reasons: z.array(z.string()).nullish(),
    requiredReason: z.boolean().nullish(),
    wostID: z.number(),
  })
  .passthrough();
const workOrderStatusCreate_Body = z
  .object({
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    reasons: z.array(z.string()).nullish(),
    requiredReason: z.boolean().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    name: z.string(),
    woprID: z.number(),
    wosuID: z.number(),
  })
  .passthrough();
const workOrderSubprogramCreate_Body = z
  .object({ name: z.string(), woprID: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FieldAgentInfo = z
  .object({
    code: z.string(),
    name: z.string(),
    phone: z.string(),
    shiftEndAt: z.string(),
    shiftStartAt: z.string(),
    unit: z.string(),
    userID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderView = z
  .object({
    address: z
      .object({
        city: z.string().nullable(),
        complement: z.string().nullable(),
        latitude: z.number().nullable(),
        longitude: z.number().nullable(),
        neighborhood: z.string().nullable(),
        number: z.string().nullable(),
        state: z.string().nullable(),
        street: z.string().nullable(),
        zipCode: z.string().nullable(),
      })
      .partial()
      .passthrough(),
    attachment: z.string(),
    classification: z.string().nullish(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    endAt: z.string().nullish(),
    event: z.string(),
    extraordinaryEffective: z.number(),
    fieldAgents: z.array(
      github_com_falqondev_cidade360_backend_service_FieldAgentInfo
    ),
    generalEffective: z.number(),
    instID: z.string(),
    institutionName: z.string(),
    ordinaryEffective: z.number(),
    planningIdentifier: z.string(),
    programName: z.string(),
    recoID: z.number().nullish(),
    requester: z
      .object({
        documentNumber: z.string().nullable(),
        documentType: z.string().nullable(),
        name: z.string().nullable(),
        phone: z.string().nullable(),
      })
      .partial()
      .passthrough(),
    requesterCompanyName: z.string().nullish(),
    requesterRole: z.string(),
    requesterType: z.string(),
    startAt: z.string().nullish(),
    status: z.string(),
    statusInfo: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    statusReason: z.string().nullish(),
    subprogramName: z.string(),
    uid: z.string(),
    updatedAt: z.string(),
    urbanEquipmentName: z.string(),
    ureqID: z.number().nullish(),
    userID: z.string(),
    woclID: z.number().nullish(),
    wodoID: z.number().nullish(),
    wofaID: z.number().nullish(),
    woorID: z.string(),
    woprID: z.number().nullish(),
    worfID: z.number().nullish(),
    wortID: z.number().nullish(),
    wostID: z.number(),
    wosuID: z.number().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FieldAgentUser = z
  .object({
    shiftEndAt: z.string().nullish(),
    shiftStartAt: z.string().nullish(),
    userID: z.string(),
  })
  .passthrough();
const workOrderCreate_Body = z
  .object({
    address: z
      .object({
        city: z.string().nullable(),
        complement: z.string().nullable(),
        latitude: z.number().nullable(),
        longitude: z.number().nullable(),
        neighborhood: z.string().nullable(),
        number: z.string().nullable(),
        state: z.string().nullable(),
        street: z.string().nullable(),
        zipCode: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    attachment: z.string().nullish(),
    description: z.string().nullish(),
    documents: z
      .array(github_com_falqondev_cidade360_backend_service_DocumentForm)
      .nullish(),
    endAt: z.string().nullish(),
    event: z.string().nullish(),
    extraordinaryEffective: z.number().nullish(),
    fieldAgentContact: z
      .object({ name: z.string().nullable(), phone: z.string().nullable() })
      .partial()
      .passthrough()
      .nullish(),
    fieldAgentUsers: z
      .array(github_com_falqondev_cidade360_backend_service_FieldAgentUser)
      .nullish(),
    generalEffective: z.number().nullish(),
    instID: z.string(),
    ordinaryEffective: z.number().nullish(),
    planningIdentifier: z.string().nullish(),
    recoID: z.number().nullish(),
    requester: z
      .object({
        documentNumber: z.string().nullable(),
        documentType: z.string().nullable(),
        name: z.string().nullable(),
        phone: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    startAt: z.string().nullish(),
    statusReason: z.string().nullish(),
    ureqID: z.number().nullish(),
    woclID: z.number().nullish(),
    woprID: z.number().nullish(),
    worfID: z.number().nullish(),
    wortID: z.number().nullish(),
    wostID: z.number(),
    wosuID: z.number().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView = z
  .object({
    createdAt: z.string(),
    data: z.unknown(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    docuID: z.string(),
    doteID: z.string(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
    updatedAt: z.string(),
    wodoID: z.number(),
    woorID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkflowExecutionView = z
  .object({
    applicationID: z.string().nullish(),
    applicationVersion: z.string().nullish(),
    attempts: z.number(),
    authenticatedUser: z.string().nullish(),
    createdAt: z.string(),
    deadline: z.string().nullish(),
    error: z.string().nullish(),
    executorID: z.string().nullish(),
    forkedFrom: z.string().nullish(),
    input: z.string().nullish(),
    output: z.string().nullish(),
    queueName: z.string().nullish(),
    startedAt: z.string().nullish(),
    status: z.string(),
    updatedAt: z.string(),
    workflowID: z.string(),
    workflowName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView =
  z
    .object({
      childWorkflowID: z.string().nullish(),
      completedAt: z.string().nullish(),
      error: z.string().nullish(),
      output: z.string().nullish(),
      startedAt: z.string().nullish(),
      stepID: z.number(),
      stepName: z.string(),
    })
    .passthrough();
const ApplicationPermissions = z.array(
  z.enum([
    "*",
    "createUser",
    "getUser",
    "getInstUser",
    "updateInstUser",
    "updateUser",
    "deleteUser",
    "createManager",
    "updateManager",
    "createUploadedMedia",
    "getUploadedMedia",
    "deleteUploadedMedia",
    "createTerm",
    "updateTerm",
    "deleteTerm",
    "getTerm",
    "createBudgetSource",
    "updateBudgetSource",
    "deleteBudgetSource",
    "getBudgetSource",
    "createBudgetType",
    "updateBudgetType",
    "deleteBudgetType",
    "getBudgetType",
    "createBudgetResourceType",
    "updateBudgetResourceType",
    "deleteBudgetResourceType",
    "getBudgetResourceType",
    "createMeasurementUnit",
    "updateMeasurementUnit",
    "deleteMeasurementUnit",
    "getMeasurementUnit",
    "createBusinessMetric",
    "updateBusinessMetric",
    "deleteBusinessMetric",
    "getBusinessMetric",
    "createPlan",
    "updatePlan",
    "deletePlan",
    "getPlan",
    "importPlan",
    "createDocumentTemplate",
    "updateDocumentTemplate",
    "deleteDocumentTemplate",
    "getDocumentTemplate",
    "createDefaultDescriptionText",
    "updateDefaultDescriptionText",
    "deleteDefaultDescriptionText",
    "getDefaultDescriptionText",
    "createDocument",
    "updateDocument",
    "deleteDocument",
    "getDocument",
    "createSurvey",
    "updateSurvey",
    "deleteSurvey",
    "getSurvey",
    "createSurveyResponse",
    "getSurveyResponse",
    "getMySurvey",
    "getSurveyPeriod",
    "createThematicAxis",
    "updateThematicAxis",
    "deleteThematicAxis",
    "getThematicAxis",
    "createStatus",
    "updateStatus",
    "deleteStatus",
    "getStatus",
    "linkStatus",
    "createKanbanStatus",
    "updateKanbanStatus",
    "deleteKanbanStatus",
    "getKanbanStatus",
    "linkKanbanStatus",
    "createInstitution",
    "updateInstitution",
    "deleteInstitution",
    "getInstitution",
    "createUserInstitution",
    "updateUserInstitution",
    "deleteUserInstitution",
    "getUserInstitution",
    "createBusinessUnit",
    "updateBusinessUnit",
    "deleteBusinessUnit",
    "getBusinessUnit",
    "createProgram",
    "updateProgram",
    "deleteProgram",
    "getProgram",
    "createProgramComment",
    "deleteProgramComment",
    "getProgramComment",
    "createProject",
    "updateProject",
    "deleteProject",
    "getProject",
    "updateProjectStatus",
    "approveProjectStatus",
    "createProjectComment",
    "deleteProjectComment",
    "getProjectComment",
    "createActionPlan",
    "updateActionPlan",
    "deleteActionPlan",
    "getActionPlan",
    "createActionPlanComment",
    "deleteActionPlanComment",
    "getActionPlanComment",
    "updateActionPlanStatus",
    "approveActionPlanStatus",
    "approveActionPlanBudget",
    "createAction",
    "updateAction",
    "deleteAction",
    "getAction",
    "createActionComment",
    "deleteActionComment",
    "getActionComment",
    "updateActionStatus",
    "approveActionStatus",
    "createCustomKPI",
    "updateCustomKPI",
    "deleteCustomKPI",
    "getCustomKPI",
    "approveCustomKPIValue",
    "createIncidentNature",
    "updateIncidentNature",
    "deleteIncidentNature",
    "getIncidentNature",
    "createRelator",
    "updateRelator",
    "deleteRelator",
    "getRelator",
    "createIncidentProgram",
    "updateIncidentProgram",
    "deleteIncidentProgram",
    "getIncidentProgram",
    "createIncidentSubprogram",
    "updateIncidentSubprogram",
    "deleteIncidentSubprogram",
    "getIncidentSubprogram",
    "createGuiche",
    "updateGuiche",
    "deleteGuiche",
    "getGuiche",
    "createIncidentStatus",
    "updateIncidentStatus",
    "deleteIncidentStatus",
    "getIncidentStatus",
    "createApplicationRoles",
    "updateApplicationRoles",
    "deleteApplicationRoles",
    "getApplicationRoles",
    "createFleetVehicle",
    "updateFleetVehicle",
    "deleteFleetVehicle",
    "getFleetVehicle",
    "createDispatchNature",
    "updateDispatchNature",
    "deleteDispatchNature",
    "getDispatchNature",
    "createDispatchSubnature",
    "updateDispatchSubnature",
    "deleteDispatchSubnature",
    "getDispatchSubnature",
    "createDispatchUnit",
    "updateDispatchUnit",
    "deleteDispatchUnit",
    "getDispatchUnit",
    "createDispatchStatus",
    "updateDispatchStatus",
    "deleteDispatchStatus",
    "getDispatchStatus",
    "createIncidentActionType",
    "updateIncidentActionType",
    "deleteIncidentActionType",
    "getIncidentActionType",
    "createIncidentOrigin",
    "updateIncidentOrigin",
    "deleteIncidentOrigin",
    "getIncidentOrigin",
    "createUrbanEquipment",
    "updateUrbanEquipment",
    "deleteUrbanEquipment",
    "getUrbanEquipment",
    "createIncidentDispatcher",
    "updateIncidentDispatcher",
    "deleteIncidentDispatcher",
    "getIncidentDispatcher",
    "createServiceChannel",
    "updateServiceChannel",
    "deleteServiceChannel",
    "getServiceChannel",
    "createRequestingCompany",
    "updateRequestingCompany",
    "deleteRequestingCompany",
    "getRequestingCompany",
    "createWorkOrderClassification",
    "updateWorkOrderClassification",
    "deleteWorkOrderClassification",
    "getWorkOrderClassification",
    "createWorkOrderRequesterType",
    "updateWorkOrderRequesterType",
    "deleteWorkOrderRequesterType",
    "getWorkOrderRequesterType",
    "createIncidentSubnature",
    "updateIncidentSubnature",
    "deleteIncidentSubnature",
    "getIncidentSubnature",
    "createIncidentEnvironment",
    "updateIncidentEnvironment",
    "deleteIncidentEnvironment",
    "getIncidentEnvironment",
    "createWorkOrderProgram",
    "updateWorkOrderProgram",
    "deleteWorkOrderProgram",
    "getWorkOrderProgram",
    "createWorkOrderSubprogram",
    "updateWorkOrderSubprogram",
    "deleteWorkOrderSubprogram",
    "getWorkOrderSubprogram",
    "createWorkOrderRequesterFunction",
    "updateWorkOrderRequesterFunction",
    "deleteWorkOrderRequesterFunction",
    "getWorkOrderRequesterFunction",
    "createWorkOrderStatus",
    "updateWorkOrderStatus",
    "deleteWorkOrderStatus",
    "getWorkOrderStatus",
    "createIncident",
    "updateIncident",
    "deleteIncident",
    "getIncident",
    "createWorkOrder",
    "updateWorkOrder",
    "deleteWorkOrder",
    "getWorkOrder",
    "createPhysicalCondition",
    "updatePhysicalCondition",
    "deletePhysicalCondition",
    "getPhysicalCondition",
    "createIncidentEstablishment",
    "updateIncidentEstablishment",
    "deleteIncidentEstablishment",
    "getIncidentEstablishment",
    "createIncidentResponseLocation",
    "updateIncidentResponseLocation",
    "deleteIncidentResponseLocation",
    "getIncidentResponseLocation",
    "createFormValidation",
    "updateFormValidation",
    "deleteFormValidation",
    "getFormValidation",
    "createFormDocumentTemplate",
    "updateFormDocumentTemplate",
    "deleteFormDocumentTemplate",
    "getFormDocumentTemplate",
    "createPublicEquipment",
    "updatePublicEquipment",
    "deletePublicEquipment",
    "getPublicEquipment",
    "createVulnerablePopulation",
    "updateVulnerablePopulation",
    "deleteVulnerablePopulation",
    "getVulnerablePopulation",
    "createDocumentation",
    "updateDocumentation",
    "deleteDocumentation",
    "getDocumentation",
    "getAuditLog",
    "createNotificationRules",
    "updateNotificationRules",
    "getNotificationRules",
    "getTaskQueue",
    "getWorkflow",
    "updateWorkflow",
    "executeWorkflow",
    "createEventClassification",
    "getEventClassification",
    "createCityEvent",
    "updateCityEvent",
    "deleteCityEvent",
    "getCityEvent",
    "createBusinessType",
    "updateBusinessType",
    "deleteBusinessType",
    "getBusinessType",
    "getSupplier",
    "updateSupplier",
    "deleteSupplier",
    "createDocumentType",
    "updateDocumentType",
    "deleteDocumentType",
    "getDocumentType",
    "uploadSupplierDocument",
    "approveSupplierDocument",
    "getAttraction",
    "approveAttraction",
    "createArtisticContract",
    "updateArtisticContract",
    "cancelArtisticContract",
    "getArtisticContract",
    "getContractTermination",
    "createSupplierPenalty",
    "updateSupplierPenalty",
    "deleteSupplierPenalty",
    "getSupplierPenalty",
    "createPenaltyScope",
    "updatePenaltyScope",
    "deletePenaltyScope",
    "getPenaltyScope",
    "createManagerReviewNote",
    "getManagerReviewNote",
    "manageBusinessTypeDocumentType",
    "createSupplierBank",
    "updateSupplierBank",
    "deleteSupplierBank",
    "getSupplierBank",
    "createSupplierClass",
    "updateSupplierClass",
    "deleteSupplierClass",
    "getSupplierClass",
    "createSupplierClassGroup",
    "updateSupplierClassGroup",
    "deleteSupplierClassGroup",
    "getSupplierClassGroup",
    "createSupplierClassSubGroup",
    "updateSupplierClassSubGroup",
    "deleteSupplierClassSubGroup",
    "getSupplierClassSubGroup",
  ])
);
const data = z.object({}).partial().passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_adminDocumentMediaAuthResponse =
  z.object({ file: z.string(), jwt: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_aiChatCompletionRequest =
  z
    .object({
      messages: z.array(
        github_com_falqondev_cidade360_backend_api_http_admin_server_aiChatMessage
      ),
      model: z.string(),
      stream: z.boolean().nullish(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_aiProxyResponse =
  z.object({}).partial().passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_aiResponsesRequest =
  z
    .object({
      input: z.string(),
      model: z.string(),
      stream: z.boolean().nullish(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_attractionDocumentMediaAuthResponse =
  z.object({ file: z.string(), jwt: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_api_http_admin_server_mediaAuthToken =
  z.object({ jwt: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_ActionCommentForm = z
  .object({ attachment: z.string().nullish(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionCreateForm = z
  .object({
    acplID: z.string(),
    instID: z.string().nullish(),
    inusID: z.number(),
    milestone: z.boolean(),
    name: z.string(),
    parentID: z.string().nullish(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    status: z
      .object({
        attachments: z.array(z.string()),
        message: z.string(),
        nextResourceID: z.string().nullish(),
        nextResourceType: z.string().nullish(),
        previousResourceID: z.string().nullish(),
        previousResourceType: z.string().nullish(),
        referenceDate: z.string(),
        statID: z.number(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionForm = z
  .object({
    acplID: z.string(),
    instID: z.string().nullish(),
    inusID: z.number(),
    milestone: z.boolean(),
    name: z.string(),
    parentID: z.string().nullish(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPeriodForm = z
  .object({ endAt: z.string(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPeriodView = z
  .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlan = z
  .object({
    acplID: z.string(),
    attachment: z.string().nullish(),
    content: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    inusID: z.number(),
    name: z.string(),
    progID: z.string().nullish(),
    projID: z.string(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanBudgetApproveForm =
  z
    .object({ apbrID: z.number(), approve: z.boolean(), message: z.string() })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanCommentForm = z
  .object({ attachment: z.string().nullish(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanCreateForm = z
  .object({
    actionPlanUsers: z.array(z.number()),
    attachment: z.string().nullish(),
    budgets: z.array(
      github_com_falqondev_cidade360_backend_service_ActionPlanBudgetForm
    ),
    content: z.string(),
    description: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    projID: z.string(),
    status: z
      .object({
        attachments: z.array(z.string()),
        message: z.string(),
        nextResourceID: z.string().nullish(),
        nextResourceType: z.string().nullish(),
        previousResourceID: z.string().nullish(),
        previousResourceType: z.string().nullish(),
        referenceDate: z.string(),
        statID: z.number(),
      })
      .passthrough(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanForm = z
  .object({
    actionPlanUsers: z.array(z.number()),
    attachment: z.string().nullish(),
    budgets: z.array(
      github_com_falqondev_cidade360_backend_service_ActionPlanBudgetForm
    ),
    content: z.string(),
    description: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    projID: z.string(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanPeriodForm = z
  .object({ endAt: z.string(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanPeriodView = z
  .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanStatusApproveForm =
  z
    .object({ approve: z.boolean(), apstID: z.number(), message: z.string() })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanStatusForm = z
  .object({
    attachments: z.array(z.string()),
    message: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
    referenceDate: z.string(),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionPlanStatusInfo = z
  .object({
    acplID: z.string(),
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    apstID: z.number(),
    attachments: z.array(z.string()),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    message: z.string(),
    orderIndex: z.number(),
    referenceDate: z.string(),
    requestReview: z.boolean(),
    reviewMessage: z.string(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionStatusApproveForm = z
  .object({ acstID: z.number(), approve: z.boolean(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionStatusForm = z
  .object({
    attachments: z.array(z.string()),
    message: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
    referenceDate: z.string(),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ActionStatusInfo = z
  .object({
    acstID: z.number(),
    actiID: z.string(),
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    attachments: z.array(z.string()),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    message: z.string(),
    orderIndex: z.number(),
    referenceDate: z.string(),
    requestReview: z.boolean(),
    reviewMessage: z.string(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ApplicationRoleForm = z
  .object({
    assignmentRules: z.array(z.string()),
    description: z.string(),
    name: z.string(),
    roles: z.array(z.string()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractCancelForm =
  z.object({ expectedStatusID: z.string(), reason: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractForm = z
  .object({
    agency: z.string(),
    attrID: z.string(),
    cievID: z.string(),
    code: z.string(),
    dates: z.array(
      github_com_falqondev_cidade360_backend_service_ArtisticContractDateForm
    ),
    finalizationDeadline: z.string(),
    requestedAmount: z.string(),
    venue: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractProposalDecisionForm =
  z
    .object({
      approved: z.boolean(),
      detail: z.string(),
      expectedStatusID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractRegistrationDecisionForm =
  z
    .object({
      approved: z.boolean(),
      detail: z.string(),
      expectedStatusID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractStartReviewForm =
  z.object({ expectedStatusID: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_ArtisticContractStatus = z
  .object({
    acstID: z.string(),
    arcoID: z.string(),
    changedBy: z.string(),
    createdAt: z.string(),
    current: z.boolean(),
    detail: z.string().nullish(),
    status: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionDocumentStatus =
  z
    .object({
      adstID: z.string(),
      atdoID: z.string(),
      createdAt: z.string(),
      current: z.boolean(),
      detail: z.string().nullish(),
      reviewedBy: z.string().nullish(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionDocumentStatusForm =
  z
    .object({
      detail: z.string(),
      expectedStatusID: z.string(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionRegistryStatus =
  z
    .object({
      arstID: z.string(),
      attrID: z.string(),
      createdAt: z.string(),
      current: z.boolean(),
      detail: z.string().nullish(),
      reviewedBy: z.string().nullish(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_AttractionRegistryStatusForm =
  z
    .object({
      detail: z.string(),
      expectedStatusID: z.string().nullish(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_AuditLUserInformation = z
  .object({
    avatar: z.string().nullable(),
    email: z.string().nullable(),
    name: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetResourceTypeForm = z
  .object({ name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetRevision = z
  .object({
    apbrID: z.number(),
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    budgets: z.array(
      z
        .object({
          actual: z.string(),
          attachments: z.array(z.string()),
          brtyID: z.number().nullish(),
          budgID: z.string(),
          busoID: z.number(),
          butyID: z.number().nullish(),
          predicted: z.string(),
          rationale: z.string().nullish(),
          received: z.string(),
          referenceYear: z.string().nullish(),
        })
        .passthrough()
    ),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    reviewMessage: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetSourceForm = z
  .object({ name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BudgetTypeForm = z
  .object({ name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetric = z
  .object({
    bumeID: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    instID: z.string().nullish(),
    metricType: z.string(),
    name: z.string(),
    planID: z.string(),
    rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
    status: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricForm = z
  .object({
    acplID: z.string().nullish(),
    actiID: z.string().nullish(),
    description: z.string().nullish(),
    instID: z.string(),
    inusIDs: z.array(z.number()),
    metricType: z.string(),
    metrics: z.array(z.number()),
    name: z.string(),
    planID: z.string(),
    progID: z.string().nullish(),
    programs: z.array(z.string()),
    projID: z.string().nullish(),
    projects: z.array(z.string()),
    rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
    status: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricKPIView = z
  .object({
    businessMetric: z
      .object({
        bumeID: z.number(),
        createdAt: z.string(),
        deletedAt: z.string().nullish(),
        description: z.string(),
        instID: z.string().nullish(),
        institutionAbbreviation: z.string().nullish(),
        institutionName: z.string().nullish(),
        kpiProgress: z
          .object({
            actual: z.string(),
            baselinePeriodEnd: z.string().nullish(),
            baselinePeriodStart: z.string().nullish(),
            baselineValue: z.string(),
            displayOption: z.string(),
            offTrack: z.string(),
            onTrack: z.string(),
            referenceDate: z.string().nullish(),
            referenceValue: z.string(),
          })
          .passthrough(),
        metricType: z.string(),
        metrics: z.array(
          github_com_falqondev_cidade360_backend_service_BusinessMetricChild
        ),
        name: z.string(),
        periodValueInDays: z.number().nullish(),
        planID: z.string(),
        programs: z.array(
          github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
        ),
        progressLink: z
          .object({
            acplID: z.string().nullable(),
            actiID: z.string().nullable(),
            actionName: z.string().nullable(),
            actionPlanName: z.string().nullable(),
            progID: z.string().nullable(),
            programName: z.string().nullable(),
            projID: z.string().nullable(),
            projectName: z.string().nullable(),
          })
          .partial()
          .passthrough()
          .nullish(),
        projects: z.array(
          github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
        ),
        rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
        status: z.string(),
        users: z.array(
          github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
        ),
      })
      .passthrough(),
    customKPI: z
      .object({
        acplID: z.string().nullish(),
        actiID: z.string().nullish(),
        actionName: z.string().nullish(),
        actionPlanName: z.string().nullish(),
        createdAt: z.string(),
        cukpID: z.number(),
        deletedAt: z.string().nullish(),
        description: z.string(),
        kpiType: z.string(),
        meunID: z.number().nullish(),
        name: z.string(),
        periodValueDisplay: z.string().nullish(),
        periodValueInDays: z.number().nullish(),
        progID: z.string().nullish(),
        programName: z.string().nullish(),
        projID: z.string().nullish(),
        projectName: z.string().nullish(),
        updatedAt: z.string(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessMetricWithCustomKPIForm =
  z
    .object({
      businessMetric: z
        .object({
          acplID: z.string().nullish(),
          actiID: z.string().nullish(),
          description: z.string().nullish(),
          instID: z.string(),
          inusIDs: z.array(z.number()),
          metricType: z.string(),
          metrics: z.array(z.number()),
          name: z.string(),
          planID: z.string(),
          progID: z.string().nullish(),
          programs: z.array(z.string()),
          projID: z.string().nullish(),
          projects: z.array(z.string()),
          rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
          status: z.string(),
        })
        .passthrough(),
      customKPI: z
        .object({
          acplID: z.string().nullish(),
          actiID: z.string().nullish(),
          description: z.string().nullish(),
          kpiType: z.string(),
          meunID: z.number().nullish(),
          name: z.string(),
          periodValueDisplay: z.string().nullish(),
          periodValueInDays: z.number().nullish(),
          progID: z.string().nullish(),
          projID: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_BusinessTypeForm = z
  .object({ description: z.string(), label: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_CityEventForm = z
  .object({
    contractingMethods: z.array(z.string()),
    endsAt: z.string(),
    evclID: z.string(),
    eventYear: z.number(),
    name: z.string(),
    parentCievID: z.string().nullish(),
    participatesInRegistration: z.boolean(),
    startsAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_CreateUserForm = z
  .object({
    applID: z.string(),
    avatar: z.string().nullish(),
    email: z.string(),
    institutions: z.array(
      github_com_falqondev_cidade360_backend_service_InstitutionUserCreateFormByUser
    ),
    name: z.string(),
    password: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_CustomKPIFrom = z
  .object({
    acplID: z.string().nullish(),
    actiID: z.string().nullish(),
    description: z.string().nullish(),
    kpiType: z.string(),
    meunID: z.number().nullish(),
    name: z.string(),
    periodValueDisplay: z.string().nullish(),
    periodValueInDays: z.number().nullish(),
    progID: z.string().nullish(),
    projID: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_CustomKPIValueFrom = z
  .object({
    attachments: z.array(z.string()),
    description: z.string(),
    targetAt: z.string(),
    value: z.string(),
    valueOmitted: z.boolean(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardIncidents = z
  .object({
    averageResponseTime: z
      .object({
        average: z.string(),
        comparativePercentageLastMonth: z.number(),
        comparativePercentageLastYear: z.number(),
      })
      .passthrough(),
    incidentProgression: z
      .object({
        comparativePercentageLastMonth: z.number(),
        comparativePercentageLastYear: z.number(),
        percentage: z.number(),
      })
      .passthrough(),
    securityIncidents: z
      .object({
        comparativePercentageLastMonth: z.number(),
        comparativePercentageLastYear: z.number(),
        total: z.number(),
      })
      .passthrough(),
    serviceIncidents: z
      .object({
        comparativePercentageLastMonth: z.number(),
        comparativePercentageLastYear: z.number(),
        total: z.number(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardSurvey = z
  .object({
    pools: z.number(),
    responses: z.array(
      github_com_falqondev_cidade360_backend_service_DashboardSurveyResponse
    ),
    survIDs: z.array(z.string()),
    totalAnswers: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DashboardWorkOrder = z
  .object({
    MonthTotal: z
      .object({ comparativePercentageLastYear: z.number(), total: z.number() })
      .passthrough(),
    YearTotal: z
      .object({ comparativePercentageLastYear: z.number(), total: z.number() })
      .passthrough(),
    averagePerYear: z.number(),
    total: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextForm =
  z
    .object({
      description: z.string(),
      formField: z.string(),
      formName: z.string(),
      instID: z.string(),
      name: z.string(),
      placeholder: z.boolean(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_Dimensions = z
  .object({ height: z.number(), length: z.number(), width: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchNatureForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchStatusForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchSubnatureForm = z
  .object({ dinaID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchSubnatureUpdateForm =
  z.object({ name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_DispatchUnitForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DocumentTemplateForm = z
  .object({
    defaultData: z.unknown(),
    description: z.string().nullish(),
    formSchema: z.unknown(),
    permissionMode: z.string(),
    printSchema: z.unknown(),
    title: z.string(),
    uiSchema: z.unknown(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Documentation = z
  .object({
    content: z.string(),
    createdAt: z.string(),
    docuID: z.number(),
    tags: z.array(z.string()),
    title: z.string(),
    videoURL: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_DocumentationForm = z
  .object({
    content: z.string(),
    tags: z.array(z.string()).nullish(),
    title: z.string(),
    videoURL: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_EmailConfig = z
  .object({
    active: z.boolean(),
    password: z.string(),
    port: z.number(),
    server: z.string(),
    user: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Engine = z
  .object({ capacity: z.string(), type: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_EventClassificationForm = z
  .object({ name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FieldAgentContact = z
  .object({ name: z.string().nullable(), phone: z.string().nullable() })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FleetVehicleForm = z
  .object({
    details: z
      .object({
        carrying_capacity: z.string(),
        color: z.string(),
        dimensions: z
          .object({ height: z.number(), length: z.number(), width: z.number() })
          .passthrough(),
        engine: z
          .object({ capacity: z.string(), type: z.string() })
          .passthrough(),
        features: z.array(z.string()),
        mileage_km: z.number(),
        purchase_date: z.string(),
        seat_numbers: z.number(),
        serial_number: z.string(),
        type: z.string(),
        warranty: z
          .object({ details: z.string().nullish(), expiry_date: z.string() })
          .passthrough(),
      })
      .passthrough(),
    instID: z.string(),
    licensePlate: z.string(),
    make: z.string(),
    model: z.string(),
    registrationNumber: z.string(),
    year: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_FormDocumentTemplateForm =
  z
    .object({
      documentTemplate: z
        .object({
          defaultData: z.unknown(),
          description: z.string().nullish(),
          formSchema: z.unknown(),
          permissionMode: z.string(),
          printSchema: z.unknown(),
          title: z.string(),
          uiSchema: z.unknown(),
        })
        .passthrough(),
      formName: z.string(),
      instID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_FormValidationForm = z
  .object({
    formName: z.string(),
    instID: z.string(),
    validationSchema: z.unknown(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_GoogleChatConfig = z
  .object({
    accessToken: z.string().nullish(),
    active: z.boolean(),
    clientID: z.string(),
    clientSecret: z.string(),
    expiresAt: z.string().nullish(),
    name: z.string(),
    refreshToken: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_GuicheForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentActionTypeForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentAddress = z
  .object({
    city: z.string().nullish(),
    complement: z.string().nullish(),
    isVillage: z.boolean(),
    latitude: z.number().nullish(),
    longitude: z.number().nullish(),
    neighborhood: z.string().nullish(),
    number: z.string().nullish(),
    state: z.string().nullish(),
    street: z.string().nullish(),
    zipCode: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentCount = z
  .object({
    comparativePercentageLastMonth: z.number(),
    comparativePercentageLastYear: z.number(),
    total: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentDetails = z
  .object({
    confidential: z.boolean().nullable(),
    protocolNumber: z.string().nullable(),
    relatorAttachment: z.string().nullable(),
    relatorDescription: z.string().nullable(),
    solution: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentDispatcherForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentEnvironmentForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentEstablishmentForm =
  z.object({ instID: z.string().nullish(), name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentFieldContact = z
  .object({ name: z.string().nullable(), phone: z.string().nullable() })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentForm = z
  .object({
    address: z
      .object({
        city: z.string().nullish(),
        complement: z.string().nullish(),
        isVillage: z.boolean(),
        latitude: z.number().nullish(),
        longitude: z.number().nullish(),
        neighborhood: z.string().nullish(),
        number: z.string().nullish(),
        state: z.string().nullish(),
        street: z.string().nullish(),
        zipCode: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    agentID: z.string().nullish(),
    agentRole: z.string().nullish(),
    arrivalAt: z.string().nullish(),
    buunID: z.number().nullish(),
    depredations: z
      .array(github_com_falqondev_cidade360_backend_service_DepredationForm)
      .nullish(),
    description: z.string().nullish(),
    details: z
      .object({
        confidential: z.boolean().nullable(),
        protocolNumber: z.string().nullable(),
        relatorAttachment: z.string().nullable(),
        relatorDescription: z.string().nullable(),
        solution: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    dinaID: z.number().nullish(),
    distID: z.number().nullish(),
    disuID: z.number().nullish(),
    diunID: z.number().nullish(),
    documents: z
      .array(github_com_falqondev_cidade360_backend_service_DocumentForm)
      .nullish(),
    fieldContact: z
      .object({ name: z.string().nullable(), phone: z.string().nullable() })
      .partial()
      .passthrough()
      .nullish(),
    guicID: z.number().nullish(),
    iatyID: z.number().nullish(),
    inbnID: z.number().nullish(),
    incidentType: z.string(),
    incidentVehicles: z
      .array(github_com_falqondev_cidade360_backend_service_IncidentVehicleForm)
      .nullish(),
    indiID: z.number().nullish(),
    inenID: z.number().nullish(),
    inesID: z.number().nullish(),
    innaID: z.number().nullish(),
    inorID: z.number().nullish(),
    inprID: z.number().nullish(),
    instID: z.string(),
    insuID: z.number().nullish(),
    involvedParties: z
      .array(github_com_falqondev_cidade360_backend_service_InvolvedPartyForm)
      .nullish(),
    istaID: z.number(),
    partnerInstID: z.string().nullish(),
    progressionFromUid: z.string().nullish(),
    pueqID: z.number().nullish(),
    relatorID: z.string().nullish(),
    relatorRole: z.string().nullish(),
    requester: z
      .object({
        email: z.string().nullable(),
        name: z.string().nullable(),
        phone: z.string().nullable(),
        sex: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    sechID: z.number().nullish(),
    seizedItems: z
      .array(github_com_falqondev_cidade360_backend_service_SeizedItemForm)
      .nullish(),
    servicedAt: z.string().nullish(),
    statusReason: z.string().nullish(),
    workOrderUid: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentNatureForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentOriginForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentProgramForm = z
  .object({ instID: z.string(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentProgression = z
  .object({
    comparativePercentageLastMonth: z.number(),
    comparativePercentageLastYear: z.number(),
    percentage: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentRequester = z
  .object({
    email: z.string().nullable(),
    name: z.string().nullable(),
    phone: z.string().nullable(),
    sex: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentResponseCount = z
  .object({
    average: z.string(),
    comparativePercentageLastMonth: z.number(),
    comparativePercentageLastYear: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentResponseLocationForm =
  z.object({ instID: z.string().nullish(), name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentStatusDisplayOptions =
  z.object({ color: z.string().nullable() }).partial().passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentStatusForm = z
  .object({
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string().nullable() })
          .partial()
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    reasons: z.array(z.string()).nullish(),
    requiredReason: z.boolean().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentStatusInfo = z
  .object({
    displayOptions: z
      .object({ color: z.string().nullable() })
      .partial()
      .passthrough()
      .nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentSubnatureForm = z
  .object({ innaID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentSubprogramForm = z
  .object({ inprID: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentsByNature = z
  .object({ inciIDs: z.array(z.string()), total: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_IncidentsInNeighborhood = z
  .object({ inciIDs: z.array(z.string()), total: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InportPlansResult = z
  .object({
    importedActionPlans: z.array(z.string()),
    importedActions: z.array(z.string()),
    importedBusinessMetric: z.array(z.number()),
    importedPlans: z.array(z.string()),
    importedPrograms: z.array(z.string()),
    importedProjects: z.array(z.string()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InstitutionCreateForm = z
  .object({
    abbreviation: z.string(),
    avatar: z.string().nullish(),
    documentNumber: z.string().nullish(),
    documentType: z.string().nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_InstitutionUnitCreateForm =
  z
    .object({
      abbreviation: z.string().nullish(),
      address: z
        .object({
          city: z.string(),
          country: z.string(),
          neighborhood: z.string(),
          number: z.string(),
          state: z.string(),
          street: z.string(),
          zipCode: z.string(),
        })
        .passthrough(),
      inusID: z.number().nullish(),
      name: z.string(),
      phone: z.string().nullish(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_InstitutionUserCreateForm =
  z
    .object({
      admittedAt: z.string().nullish(),
      buunID: z.number().nullish(),
      code: z.string().nullish(),
      operationalCode: z.string().nullish(),
      phone: z.string(),
      sex: z.string(),
      userID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_InstitutionUserUpdateForm =
  z
    .object({
      admittedAt: z.string().nullish(),
      buunID: z.number().nullish(),
      code: z.string().nullish(),
      operationalCode: z.string().nullish(),
      phone: z.string(),
      sex: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_KPIProgress = z
  .object({
    actual: z.string(),
    baselinePeriodEnd: z.string().nullish(),
    baselinePeriodStart: z.string().nullish(),
    baselineValue: z.string(),
    displayOption: z.string(),
    offTrack: z.string(),
    onTrack: z.string(),
    referenceDate: z.string().nullish(),
    referenceValue: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_KPIValueApproveForm = z
  .object({ approved: z.boolean(), cpvaID: z.number(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_KanbanForm = z
  .object({
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    name: z.string(),
    orderIndex: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_KanbanReorderForm = z
  .object({
    movedResourceID: z.string(),
    movedResourceType: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    planID: z.string(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ManagerReviewNoteForm = z
  .object({ note: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_MeasurementUnitForm = z
  .object({
    formatConfig: z
      .object({
        decimalPlaces: z.number(),
        decimalSep: z.string(),
        prefix: z.string(),
        suffix: z.string(),
        thousandsSep: z.string(),
      })
      .passthrough()
      .nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_MeasurementUnitFormatConfig =
  z
    .object({
      decimalPlaces: z.number(),
      decimalSep: z.string(),
      prefix: z.string(),
      suffix: z.string(),
      thousandsSep: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_NotificationConfig = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    module: z.string(),
    noruID: z.string(),
    notificationIntegrations: z
      .object({
        email: z
          .object({
            active: z.boolean(),
            password: z.string(),
            port: z.number(),
            server: z.string(),
            user: z.string(),
          })
          .passthrough()
          .nullable(),
        googleChat: z
          .object({
            accessToken: z.string().nullish(),
            active: z.boolean(),
            clientID: z.string(),
            clientSecret: z.string(),
            expiresAt: z.string().nullish(),
            name: z.string(),
            refreshToken: z.string().nullish(),
          })
          .passthrough()
          .nullable(),
        teams: z
          .object({
            accessToken: z.string().nullish(),
            active: z.boolean(),
            chatID: z.string(),
            clientID: z.string(),
            clientSecret: z.string(),
            expiresAt: z.string().nullish(),
            graphUserID: z.string().nullish(),
            refreshToken: z.string().nullish(),
            tenantID: z.string(),
          })
          .passthrough()
          .nullable(),
        whatsapp: z
          .object({
            active: z.boolean(),
            phoneID: z.string(),
            token: z.string(),
            wabaID: z.string(),
          })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    rules: z
      .object({
        notifySupplierDocumentExpiring: z.boolean(),
        notifySupplierDocumentStatusChange: z.boolean(),
        notifySupplierPenaltyCreated: z.boolean(),
        notifySupplierRegistryStatusChange: z.boolean(),
        supplierDocumentExpiryRules: z
          .array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
          )
          .nullish(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_NotificationConfigForm = z
  .object({
    module: z.string(),
    notificationIntegrations: z
      .object({
        email: z
          .object({
            active: z.boolean(),
            password: z.string(),
            port: z.number(),
            server: z.string(),
            user: z.string(),
          })
          .passthrough()
          .nullable(),
        googleChat: z
          .object({
            accessToken: z.string().nullish(),
            active: z.boolean(),
            clientID: z.string(),
            clientSecret: z.string(),
            expiresAt: z.string().nullish(),
            name: z.string(),
            refreshToken: z.string().nullish(),
          })
          .passthrough()
          .nullable(),
        teams: z
          .object({
            accessToken: z.string().nullish(),
            active: z.boolean(),
            chatID: z.string(),
            clientID: z.string(),
            clientSecret: z.string(),
            expiresAt: z.string().nullish(),
            graphUserID: z.string().nullish(),
            refreshToken: z.string().nullish(),
            tenantID: z.string(),
          })
          .passthrough()
          .nullable(),
        whatsapp: z
          .object({
            active: z.boolean(),
            phoneID: z.string(),
            token: z.string(),
            wabaID: z.string(),
          })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    rules: z
      .object({
        notifySupplierDocumentExpiring: z.boolean(),
        notifySupplierDocumentStatusChange: z.boolean(),
        notifySupplierPenaltyCreated: z.boolean(),
        notifySupplierRegistryStatusChange: z.boolean(),
        supplierDocumentExpiryRules: z
          .array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
          )
          .nullish(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_NotificationIntegrationConfig =
  z
    .object({
      email: z
        .object({
          active: z.boolean(),
          password: z.string(),
          port: z.number(),
          server: z.string(),
          user: z.string(),
        })
        .passthrough()
        .nullable(),
      googleChat: z
        .object({
          accessToken: z.string().nullish(),
          active: z.boolean(),
          clientID: z.string(),
          clientSecret: z.string(),
          expiresAt: z.string().nullish(),
          name: z.string(),
          refreshToken: z.string().nullish(),
        })
        .passthrough()
        .nullable(),
      teams: z
        .object({
          accessToken: z.string().nullish(),
          active: z.boolean(),
          chatID: z.string(),
          clientID: z.string(),
          clientSecret: z.string(),
          expiresAt: z.string().nullish(),
          graphUserID: z.string().nullish(),
          refreshToken: z.string().nullish(),
          tenantID: z.string(),
        })
        .passthrough()
        .nullable(),
      whatsapp: z
        .object({
          active: z.boolean(),
          phoneID: z.string(),
          token: z.string(),
          wabaID: z.string(),
        })
        .passthrough()
        .nullable(),
    })
    .partial()
    .passthrough();
const github_com_falqondev_cidade360_backend_service_NotificationRulesRules = z
  .object({
    notifySupplierDocumentExpiring: z.boolean(),
    notifySupplierDocumentStatusChange: z.boolean(),
    notifySupplierPenaltyCreated: z.boolean(),
    notifySupplierRegistryStatusChange: z.boolean(),
    supplierDocumentExpiryRules: z
      .array(
        github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
      )
      .nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_OneTimeLogin = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    otloID: z.number(),
    token: z.string(),
    userID: z.string(),
    validUntil: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_OneTimeLoginForm = z
  .object({ userID: z.string(), validUntil: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PatchUserInformationForm =
  z
    .object({
      avatar: z.string().nullable(),
      email: z.string().nullable(),
      name: z.string().nullable(),
    })
    .partial()
    .passthrough();
const github_com_falqondev_cidade360_backend_service_PendingUserTerms = z
  .object({
    terms: z.array(github_com_falqondev_cidade360_backend_service_PendingTerm),
    userID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PhysicalConditionForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanBudgetSummary = z
  .object({
    budgetSummary: z.array(
      github_com_falqondev_cidade360_backend_service_BudgetSummary
    ),
    percentageUsage: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanDashboard = z
  .object({
    budgetSourceName: z.array(z.string()),
    planID: z.string(),
    resourceTimeline: z.array(
      github_com_falqondev_cidade360_backend_service_ResourceCount
    ),
    totalActual: z.number(),
    totalPredicted: z.number(),
    totalReceived: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanForm = z
  .object({
    endAt: z.string(),
    inusID: z.number(),
    isDefault: z.boolean(),
    name: z.string(),
    planUsers: z.array(z.number()),
    startAt: z.string(),
    thaxID: z.array(z.number()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanSummary = z
  .object({
    resourceSummary: z.array(
      github_com_falqondev_cidade360_backend_service_Resource
    ),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PlanTaskSummary = z
  .object({
    finishedPercentage: z.number(),
    finishedTasks: z.number(),
    openTasks: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Program = z
  .object({
    content: z.string(),
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    inusID: z.number().nullish(),
    name: z.string(),
    planID: z.string(),
    progID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramCommentForm = z
  .object({ attachment: z.string().nullish(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramFinalBudget = z
  .object({ progID: z.string(), totalActual: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramForm = z
  .object({
    axes: z.array(z.number()),
    content: z.string(),
    description: z.string().nullish(),
    institutions: z.array(z.string()),
    inusID: z.number().nullish(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    programUsers: z.array(z.number()),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramPeriodForm = z
  .object({ endAt: z.string(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramPeriodView = z
  .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgramStatusForm = z
  .object({
    message: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
    referenceDate: z.string(),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProgressLink = z
  .object({
    acplID: z.string().nullable(),
    actiID: z.string().nullable(),
    actionName: z.string().nullable(),
    actionPlanName: z.string().nullable(),
    progID: z.string().nullable(),
    programName: z.string().nullable(),
    projID: z.string().nullable(),
    projectName: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectCommentForm = z
  .object({ attachment: z.string().nullish(), message: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectCreateForm = z
  .object({
    attachment: z.string().nullish(),
    axes: z.array(z.number()),
    content: z.string(),
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    progID: z.string().nullish(),
    projectUsers: z.array(z.number()),
    status: z
      .object({
        attachments: z.array(z.string()),
        message: z.string(),
        nextResourceID: z.string().nullish(),
        nextResourceType: z.string().nullish(),
        previousResourceID: z.string().nullish(),
        previousResourceType: z.string().nullish(),
        referenceDate: z.string(),
        statID: z.number(),
      })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectDisplayOptions = z
  .object({ color: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectFinalBudget = z
  .object({ projID: z.string(), totalActual: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectForm = z
  .object({
    attachment: z.string().nullish(),
    axes: z.array(z.number()),
    content: z.string(),
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    institutions: z.array(z.string()),
    inusID: z.number(),
    name: z.string(),
    period: z.object({ endAt: z.string(), startAt: z.string() }).passthrough(),
    planID: z.string(),
    progID: z.string().nullish(),
    projectUsers: z.array(z.number()),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectInfo = z
  .object({
    displayOptions: z.object({ color: z.string() }).passthrough().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectInformations = z
  .object({
    displayOptions: z.object({ color: z.string() }).passthrough().nullish(),
    name: z.string(),
    projID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectPeriodForm = z
  .object({ endAt: z.string(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectPeriodView = z
  .object({ endAt: z.string(), oppeID: z.number(), startAt: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectStatusApproveForm =
  z
    .object({ approve: z.boolean(), message: z.string(), prstID: z.number() })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectStatusForm = z
  .object({
    attachments: z.array(z.string()),
    message: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
    referenceDate: z.string(),
    statID: z.number(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ProjectStatusInfo = z
  .object({
    approvedBy: z.string().nullish(),
    approverName: z.string().nullish(),
    attachments: z.array(z.string()),
    deletedAt: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    message: z.string(),
    orderIndex: z.number(),
    projID: z.string(),
    prstID: z.number(),
    referenceDate: z.string(),
    requestReview: z.boolean(),
    reviewMessage: z.string(),
    statID: z.number(),
    state: z.string(),
    status: z.string(),
    userID: z.string(),
    userName: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_PublicEquipmentForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_RequestingCompanyForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ServiceChannelForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_Status = z
  .object({
    createdAt: z.string(),
    deletedAt: z.string().nullish(),
    description: z.string(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    orderIndex: z.number(),
    requestReview: z.boolean(),
    slug: z.string(),
    statID: z.number(),
    state: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_StatusCreateForm = z
  .object({
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    name: z.string(),
    orderIndex: z.number(),
    requestReview: z.boolean(),
    state: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_StatusDisplayOptions = z
  .object({ color: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_StatusInfo = z
  .object({
    displayOptions: z.object({ color: z.string() }).passthrough().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_StatusOrderForm = z
  .object({
    movedResourceID: z.string(),
    movedResourceType: z.string(),
    nextResourceID: z.string().nullish(),
    nextResourceType: z.string().nullish(),
    planID: z.string(),
    previousResourceID: z.string().nullish(),
    previousResourceType: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierBankForm = z
  .object({ code: z.number(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentTypeForm =
  z.object({ doctID: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassForm = z
  .object({ code: z.string(), label: z.string(), scsgID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassGroupForm = z
  .object({ label: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierClassSubGroupForm =
  z.object({ clgrID: z.string(), label: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentHumanReviewForm =
  z
    .object({
      detail: z.string(),
      expectedStatusID: z.string(),
      validationResult: z.string(),
      validity: z.string().nullish(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentStatus = z
  .object({
    createdAt: z.string(),
    current: z.boolean(),
    detail: z.string().nullish(),
    reviewedBy: z.string().nullish(),
    spdcID: z.string(),
    spdsID: z.string(),
    status: z.string(),
    validationResult: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentStatusForm =
  z
    .object({
      detail: z.string(),
      status: z.string(),
      validity: z.string().nullish(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentTypeForm =
  z
    .object({
      extractionFields: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
      ),
      label: z.string(),
      validationPrompt: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAdminView =
  z
    .object({
      activeAttemptID: z.string().nullish(),
      aiResult: z
        .object({
          fields: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult
          ),
          reason: z.string(),
          status: z.string(),
        })
        .passthrough()
        .nullish(),
      attempts: z
        .array(
          github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAttempt
        )
        .nullish(),
      completedAt: z.string().nullish(),
      createdAt: z.string(),
      currentStage: z.string().nullish(),
      currentStatus: z.string(),
      currentStatusID: z.string(),
      cycleNumber: z.number(),
      documentID: z.string(),
      enqueuedAt: z.string().nullish(),
      errorCode: z.string().nullish(),
      events: z
        .array(
          github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvent
        )
        .nullish(),
      executionState: z.string(),
      extractedTextBytes: z.number().nullish(),
      failureCount: z.number(),
      lastDiagnostic: z
        .object({
          causes: z.array(z.string()),
          code: z.string(),
          createdAt: z.string(),
          message: z.string(),
          stage: z.string(),
          version: z.number(),
        })
        .passthrough()
        .nullish(),
      model: z.string().nullish(),
      provider: z.string().nullish(),
      resultSource: z.string().nullish(),
      scheduledAt: z.string(),
      startedAt: z.string().nullish(),
      updatedAt: z.string(),
      verificationID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationDiagnostic =
  z
    .object({
      causes: z.array(z.string()),
      code: z.string(),
      createdAt: z.string(),
      message: z.string(),
      stage: z.string(),
      version: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvidence =
  z
    .object({
      aiInvoked: z.string(),
      bytes: z.number(),
      durationMS: z.number(),
      inputTokens: z.number(),
      model: z.string(),
      outputTokens: z.number(),
      provider: z.string(),
      sha256: z.string(),
      totalTokens: z.number(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationOutcome =
  z
    .object({
      aiInvoked: z.string(),
      diagnostic: z
        .object({
          causes: z.array(z.string()),
          code: z.string(),
          createdAt: z.string(),
          message: z.string(),
          stage: z.string(),
          version: z.number(),
        })
        .passthrough()
        .nullish(),
      failureCount: z.number(),
      maxFailures: z.number(),
      retryAt: z.string().nullish(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessForm =
  z
    .object({
      expectedCycle: z.number(),
      expectedStatusID: z.string(),
      reason: z.string(),
      requestID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessResult =
  z
    .object({
      alreadyExists: z.boolean(),
      attemptID: z.string(),
      cycle: z.number(),
      verificationID: z.string(),
      workflowID: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationResult =
  z
    .object({
      fields: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult
      ),
      reason: z.string(),
      status: z.string(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenaltyForm = z
  .object({
    complement: z.string(),
    contractNumber: z.string(),
    decisionType: z.string(),
    description: z.string(),
    dom: z.string(),
    endDate: z.string(),
    legalBasis: z.string(),
    legalBasisDescription: z.string(),
    pennID: z.string().nullish(),
    process: z.string(),
    publishingDate: z.string(),
    sanctionType: z.string(),
    scopID: z.string(),
    startDate: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SupplierPenaltyScopeForm =
  z
    .object({ description: z.string().nullish(), label: z.string() })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyCreateForm = z
  .object({
    activeAt: z.string().nullish(),
    allowedUsers: z.array(z.string()),
    description: z.string().nullish(),
    descriptionFinished: z.string().nullish(),
    displayOptions: z.unknown(),
    slug: z.string().nullish(),
    surveyForms: z
      .array(github_com_falqondev_cidade360_backend_service_InputSurveyForm)
      .nullish(),
    title: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyFormTemplate = z
  .object({ doteID: z.string(), suftID: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyFormTemplateDocumentTemplateForm =
  z
    .object({
      defaultData: z.unknown(),
      description: z.string().nullish(),
      formSchema: z.unknown(),
      permissionMode: z.string(),
      printSchema: z.unknown(),
      title: z.string(),
      uiSchema: z.unknown(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyResponse = z
  .object({
    clientDevice: z.string(),
    clientIP: z.string(),
    clientUID: z.string(),
    createdAt: z.string(),
    docuID: z.string(),
    doteID: z.string(),
    metadata: z.unknown(),
    sureID: z.number(),
    sursID: z.string(),
    survID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyResponseDocumentForm =
  z
    .object({
      data: z.unknown(),
      description: z.string(),
      doteID: z.string(),
      formSchema: z.unknown(),
      permissionMode: z.string(),
      printSchema: z.unknown(),
      title: z.string(),
      uiSchema: z.unknown(),
    })
    .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyResponseForm = z
  .object({
    clientDevice: z.string(),
    clientIP: z.string(),
    clientUID: z.string(),
    docuID: z.string().nullish(),
    document: z
      .object({
        data: z.unknown(),
        description: z.string(),
        doteID: z.string(),
        formSchema: z.unknown(),
        permissionMode: z.string(),
        printSchema: z.unknown(),
        title: z.string(),
        uiSchema: z.unknown(),
      })
      .passthrough()
      .nullish(),
    doteID: z.string(),
    metadata: z.unknown(),
    sursID: z.string(),
    survID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_SurveyResponseSession = z
  .object({
    submittedAt: z.string().nullish(),
    sursID: z.string(),
    survID: z.string(),
    userID: z.string().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_TOTPDisableResponse = z
  .object({ disabled: z.boolean() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_TeamsConfig = z
  .object({
    accessToken: z.string().nullish(),
    active: z.boolean(),
    chatID: z.string(),
    clientID: z.string(),
    clientSecret: z.string(),
    expiresAt: z.string().nullish(),
    graphUserID: z.string().nullish(),
    refreshToken: z.string().nullish(),
    tenantID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_TermForm = z
  .object({
    description: z.string(),
    slug: z.string(),
    title: z.string(),
    type: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ThematicAxisCreateForm = z
  .object({
    description: z.string().nullish(),
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    name: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_ThematicAxisDisplayOptions =
  z.object({ color: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_ThematicAxisInfo = z
  .object({
    displayOptions: z.object({ color: z.string() }).passthrough().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UnitAddress = z
  .object({
    city: z.string(),
    country: z.string(),
    neighborhood: z.string(),
    number: z.string(),
    state: z.string(),
    street: z.string(),
    zipCode: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UrbanEquipmentForm = z
  .object({ instID: z.string().nullish(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UserInfo = z
  .object({ tourCompleted: z.boolean() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UserRoleForm = z
  .object({ aproIDs: z.array(z.string()), userID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UserRoleView = z
  .object({ roles: z.array(z.string()), userID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_UserTerm = z
  .object({ accepted: z.boolean(), termID: z.number(), userID: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_VehicleDetails = z
  .object({
    carrying_capacity: z.string(),
    color: z.string(),
    dimensions: z
      .object({ height: z.number(), length: z.number(), width: z.number() })
      .passthrough(),
    engine: z.object({ capacity: z.string(), type: z.string() }).passthrough(),
    features: z.array(z.string()),
    mileage_km: z.number(),
    purchase_date: z.string(),
    seat_numbers: z.number(),
    serial_number: z.string(),
    type: z.string(),
    warranty: z
      .object({ details: z.string().nullish(), expiry_date: z.string() })
      .passthrough(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_VulnerablePopulationForm =
  z.object({ instID: z.string().nullish(), name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_Warranty = z
  .object({ details: z.string().nullish(), expiry_date: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WhatsAppConfig = z
  .object({
    active: z.boolean(),
    phoneID: z.string(),
    token: z.string(),
    wabaID: z.string(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderAddress = z
  .object({
    city: z.string().nullable(),
    complement: z.string().nullable(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    neighborhood: z.string().nullable(),
    number: z.string().nullable(),
    state: z.string().nullable(),
    street: z.string().nullable(),
    zipCode: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderClassificationForm =
  z.object({ instID: z.string().nullish(), name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderCount = z
  .object({ comparativePercentageLastYear: z.number(), total: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderForm = z
  .object({
    address: z
      .object({
        city: z.string().nullable(),
        complement: z.string().nullable(),
        latitude: z.number().nullable(),
        longitude: z.number().nullable(),
        neighborhood: z.string().nullable(),
        number: z.string().nullable(),
        state: z.string().nullable(),
        street: z.string().nullable(),
        zipCode: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    attachment: z.string().nullish(),
    description: z.string().nullish(),
    documents: z
      .array(github_com_falqondev_cidade360_backend_service_DocumentForm)
      .nullish(),
    endAt: z.string().nullish(),
    event: z.string().nullish(),
    extraordinaryEffective: z.number().nullish(),
    fieldAgentContact: z
      .object({ name: z.string().nullable(), phone: z.string().nullable() })
      .partial()
      .passthrough()
      .nullish(),
    fieldAgentUsers: z
      .array(github_com_falqondev_cidade360_backend_service_FieldAgentUser)
      .nullish(),
    generalEffective: z.number().nullish(),
    instID: z.string(),
    ordinaryEffective: z.number().nullish(),
    planningIdentifier: z.string().nullish(),
    recoID: z.number().nullish(),
    requester: z
      .object({
        documentNumber: z.string().nullable(),
        documentType: z.string().nullable(),
        name: z.string().nullable(),
        phone: z.string().nullable(),
      })
      .partial()
      .passthrough()
      .nullish(),
    startAt: z.string().nullish(),
    statusReason: z.string().nullish(),
    ureqID: z.number().nullish(),
    woclID: z.number().nullish(),
    woprID: z.number().nullish(),
    worfID: z.number().nullish(),
    wortID: z.number().nullish(),
    wostID: z.number(),
    wosuID: z.number().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderProgramForm = z
  .object({ instID: z.string(), name: z.string() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderRequester = z
  .object({
    documentNumber: z.string().nullable(),
    documentType: z.string().nullable(),
    name: z.string().nullable(),
    phone: z.string().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionForm =
  z.object({ instID: z.string().nullish(), name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeForm =
  z.object({ instID: z.string().nullish(), name: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderStatusDisplayOptions =
  z.object({ color: z.string() }).passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderStatusForm = z
  .object({
    info: z
      .object({
        displayOptions: z
          .object({ color: z.string() })
          .passthrough()
          .nullable(),
      })
      .partial()
      .passthrough(),
    name: z.string(),
    reasons: z.array(z.string()).nullish(),
    requiredReason: z.boolean().nullish(),
  })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderStatusInfo = z
  .object({
    displayOptions: z.object({ color: z.string() }).passthrough().nullable(),
  })
  .partial()
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramForm = z
  .object({ name: z.string(), woprID: z.number() })
  .passthrough();
const github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramUpdateForm =
  z.object({ name: z.string() }).passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionCommentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPeriodHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionPeriodHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionPlanCommentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionPlanStatusView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionPlanView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ActionStatusView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_ActionView),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ArtisticContractView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_AttractionDocumentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_AttractionView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AuditLogView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_AuditLogView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_BudgetResourceType
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_BudgetSource
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetType_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_BudgetType),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_BusinessMetricView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessType_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_BusinessType
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_BusinessUnit
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CityEvent_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_CityEvent),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ContractTerminationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_CustomKPIValueView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_CustomKPIView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DispatchNatureView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DispatchStatusView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DispatchSubnatureView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DispatchUnitView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DocumentTemplate
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Document_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_Document),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_DocumentationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_EventClassification_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_EventClassification
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_FleetVehicleView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_FormValidationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_GuicheView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_GuicheView),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentActionTypeView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentDispatcherView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDocumentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentDocumentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentNatureView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentOriginView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentProgramView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentStatus
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentSubnatureView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentSubprogramView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_IncidentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_InstitutionUserView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Institution_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_Institution
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanLinkView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_KanbanLinkView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_KanbanView),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ManagerReviewNote
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_MeasurementUnit
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MySurvey_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_MySurvey),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MyTaskQueueItem_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_MyTaskQueueItem
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_NotificationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_NotificationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PermissionModule_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_PermissionModule
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_PhysicalConditionView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanLatestComments_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_PlanLatestComments
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanNextTask_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_PlanNextTask
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_PlanView),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProgramCommentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramStatusHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProgramStatusHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProgramView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProjectCommentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProjectStatusView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ProjectView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_PublicEquipmentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_RequestingCompanyView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ServiceChannelView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusLinkView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_StatusLinkView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_StatusView),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierBank
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierClassGroup
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierClass
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierDocumentType
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierDocumentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierPenaltyView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierPenalty
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SupplierRegistry
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_SurveyResponseListing
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Survey_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_Survey),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Term_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(github_com_falqondev_cidade360_backend_service_Term),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_ThematicAxis
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_UrbanEquipmentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UserInformation_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_UserInformation
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_VulnerablePopulationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderProgramView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderStatusView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkOrderView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_ =
  z
    .object({
      currentItemCount: z.number(),
      items: z.array(
        github_com_falqondev_cidade360_backend_service_WorkflowExecutionView
      ),
      itemsPerPage: z.number(),
      kind: z.string(),
      lang: z.string().nullish(),
      pageIndex: z.number(),
      startIndex: z.number(),
      totalItems: z.number(),
      totalPages: z.number(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionCommentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPeriodHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPeriodHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPlanCommentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPlanStatusView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPlanView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionStatusView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ActionView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ArtisticContractView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_AttractionDocumentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_AttractionView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AuditLogView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_AuditLogView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_BudgetResourceType
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_BudgetSource
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_BudgetType
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessMetricView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessType
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessUnit
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CityEvent_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_CityEvent
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ContractTerminationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_CustomKPIValueView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_CustomKPIView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DispatchNatureView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DispatchStatusView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DispatchSubnatureView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DispatchUnitView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DocumentTemplate
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Document_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_Document
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_DocumentationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_EventClassification_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_EventClassification
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_FleetVehicleView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_FormValidationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_GuicheView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_GuicheView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentActionTypeView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentDispatcherView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDocumentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentDocumentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentNatureView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentOriginView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentProgramView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentStatus
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentSubnatureView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentSubprogramView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_InstitutionUserView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Institution_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_Institution
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanLinkView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_KanbanLinkView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_KanbanView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ManagerReviewNote
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_MeasurementUnit
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MySurvey_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_MySurvey
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MyTaskQueueItem_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_MyTaskQueueItem
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_NotificationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_NotificationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PermissionModule_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_PermissionModule
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_PhysicalConditionView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanLatestComments_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_PlanLatestComments
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanNextTask_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_PlanNextTask
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_PlanView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProgramCommentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramStatusHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProgramStatusHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProgramView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProjectCommentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProjectStatusView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ProjectView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_PublicEquipmentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_RequestingCompanyView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ServiceChannelView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusLinkView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_StatusLinkView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_StatusView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierBank
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierClassGroup
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierClass
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentType
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierPenaltyView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierPenalty
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierRegistry
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_SurveyResponseListing
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Survey_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(github_com_falqondev_cidade360_backend_service_Survey),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Term_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(github_com_falqondev_cidade360_backend_service_Term),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_ThematicAxis
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_UrbanEquipmentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UserInformation_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_UserInformation
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_VulnerablePopulationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderProgramView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderStatusView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkOrderView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          currentItemCount: z.number(),
          items: z.array(
            github_com_falqondev_cidade360_backend_service_WorkflowExecutionView
          ),
          itemsPerPage: z.number(),
          kind: z.string(),
          lang: z.string().nullish(),
          pageIndex: z.number(),
          startIndex: z.number(),
          totalItems: z.number(),
          totalPages: z.number(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_bool_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.boolean(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_adminDocumentMediaAuthResponse_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_aiProxyResponse_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.object({}).partial().passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_attractionDocumentMediaAuthResponse_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_mediaAuthToken_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.object({ jwt: z.string() }).passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              actiID: z.string(),
              attachment: z.string().nullish(),
              commID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              message: z.string(),
              userAvatar: z.string().nullish(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acplID: z.string(),
              attachment: z.string().nullish(),
              commID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              message: z.string(),
              userAvatar: z.string().nullish(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acplID: z.string(),
              actionPlanName: z.string(),
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              apstID: z.number(),
              attachments: z.array(z.string()),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              message: z.string(),
              orderIndex: z.number(),
              referenceDate: z.string(),
              requestReview: z.boolean(),
              reviewMessage: z.string(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acplID: z.string(),
              actionCount: z.number(),
              actionPlanUsers: z.array(
                github_com_falqondev_cidade360_backend_service_ActionPlanUserView
              ),
              attachment: z.string().nullish(),
              comments: z.number().nullish(),
              content: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              doneActionCount: z.number(),
              doneMilestoneCount: z.number(),
              instID: z.string(),
              institutionAbbreviation: z.string(),
              institutionName: z.string(),
              institutionUserAvatar: z.string().nullish(),
              institutionUserEmail: z.string().nullish(),
              institutionUserName: z.string(),
              institutions: z.array(z.string()),
              inusID: z.number(),
              milestoneCount: z.number(),
              mostID: z.number().nullish(),
              mostOrderIndex: z.number(),
              name: z.string(),
              period: z
                .object({
                  endAt: z.string(),
                  oppeID: z.number(),
                  startAt: z.string(),
                })
                .passthrough(),
              progID: z.string().nullish(),
              projID: z.string(),
              projectInfo: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullish(),
                  name: z.string(),
                  projID: z.string(),
                })
                .passthrough(),
              revision: z
                .object({
                  apbrID: z.number(),
                  approvedBy: z.string().nullish(),
                  approverName: z.string().nullish(),
                  budgets: z.array(
                    z
                      .object({
                        actual: z.string(),
                        attachments: z.array(z.string()),
                        brtyID: z.number().nullish(),
                        budgID: z.string(),
                        busoID: z.number(),
                        butyID: z.number().nullish(),
                        predicted: z.string(),
                        rationale: z.string().nullish(),
                        received: z.string(),
                        referenceYear: z.string().nullish(),
                      })
                      .passthrough()
                  ),
                  createdAt: z.string(),
                  deletedAt: z.string().nullish(),
                  reviewMessage: z.string(),
                  userID: z.string(),
                  userName: z.string(),
                })
                .passthrough()
                .nullish(),
              status: z
                .object({
                  acplID: z.string(),
                  approvedBy: z.string().nullish(),
                  approverName: z.string().nullish(),
                  apstID: z.number(),
                  attachments: z.array(z.string()),
                  deletedAt: z.string().nullish(),
                  info: z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullable(),
                    })
                    .partial()
                    .passthrough(),
                  message: z.string(),
                  orderIndex: z.number(),
                  referenceDate: z.string(),
                  requestReview: z.boolean(),
                  reviewMessage: z.string(),
                  statID: z.number(),
                  state: z.string(),
                  status: z.string(),
                  userID: z.string(),
                  userName: z.string(),
                })
                .passthrough(),
              thematicAxisInfo: z.array(
                z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    thaxID: z.number(),
                  })
                  .passthrough()
              ),
              type: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlan_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acplID: z.string(),
              attachment: z.string().nullish(),
              content: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              inusID: z.number(),
              name: z.string(),
              progID: z.string().nullish(),
              projID: z.string(),
              type: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acstID: z.number(),
              actiID: z.string(),
              actionName: z.string(),
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              attachments: z.array(z.string()),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              message: z.string(),
              orderIndex: z.number(),
              referenceDate: z.string(),
              requestReview: z.boolean(),
              reviewMessage: z.string(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acplID: z.string(),
              actiID: z.string(),
              actionPlanName: z.string(),
              comments: z.number().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string(),
              institutionAbbreviation: z.string(),
              institutionName: z.string(),
              inusID: z.number(),
              milestone: z.boolean(),
              mostID: z.number().nullish(),
              mostOrderIndex: z.number(),
              name: z.string(),
              parentID: z.string().nullish(),
              period: z
                .object({
                  endAt: z.string(),
                  oppeID: z.number(),
                  startAt: z.string(),
                })
                .passthrough(),
              progID: z.string().nullish(),
              projID: z.string(),
              projectInfo: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullish(),
                  name: z.string(),
                  projID: z.string(),
                })
                .passthrough(),
              status: z
                .object({
                  acstID: z.number(),
                  actiID: z.string(),
                  approvedBy: z.string().nullish(),
                  approverName: z.string().nullish(),
                  attachments: z.array(z.string()),
                  createdAt: z.string(),
                  deletedAt: z.string().nullish(),
                  info: z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullable(),
                    })
                    .partial()
                    .passthrough(),
                  message: z.string(),
                  orderIndex: z.number(),
                  referenceDate: z.string(),
                  requestReview: z.boolean(),
                  reviewMessage: z.string(),
                  statID: z.number(),
                  state: z.string(),
                  status: z.string(),
                  userID: z.string(),
                  userName: z.string(),
                })
                .passthrough(),
              userAvatar: z.string().nullish(),
              userEmail: z.string().nullish(),
              userName: z.string().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              aproID: z.string(),
              assignmentRules: z.array(z.string()),
              description: z.string(),
              name: z.string(),
              roles: z.array(z.string()),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acstID: z.string(),
              arcoID: z.string(),
              changedBy: z.string(),
              createdAt: z.string(),
              current: z.boolean(),
              detail: z.string().nullish(),
              status: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              agency: z.string(),
              arcoID: z.string(),
              attrID: z.string(),
              attractionName: z.string().nullish(),
              attractionStatus: z.string().nullish(),
              blockingItems: z.array(z.string()).nullish(),
              cievID: z.string(),
              code: z.string(),
              createdAt: z.string(),
              createdBy: z.string(),
              dates: z
                .array(
                  github_com_falqondev_cidade360_backend_service_ArtisticContractDate
                )
                .nullish(),
              deadlineExpired: z.boolean(),
              deletedAt: z.string().nullish(),
              eventName: z.string().nullish(),
              finalizationDeadline: z.string(),
              logs: z
                .array(
                  github_com_falqondev_cidade360_backend_service_ArtisticContractLog
                )
                .nullish(),
              requestedAmount: z.string(),
              spplID: z.string(),
              status: z.string().nullish(),
              statusAt: z.string().nullish(),
              statusDetail: z.string().nullish(),
              statusID: z.string().nullish(),
              supplierDocument: z.string().nullish(),
              supplierName: z.string().nullish(),
              supplierStatus: z.string().nullish(),
              updatedAt: z.string(),
              venue: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              adstID: z.string(),
              atdoID: z.string(),
              createdAt: z.string(),
              current: z.boolean(),
              detail: z.string().nullish(),
              reviewedBy: z.string().nullish(),
              status: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionRegistryStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              arstID: z.string(),
              attrID: z.string(),
              createdAt: z.string(),
              current: z.boolean(),
              detail: z.string().nullish(),
              reviewedBy: z.string().nullish(),
              status: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              attrID: z.string(),
              attractionType: z.string(),
              clippingLinks: z
                .array(
                  github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                )
                .nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              documents: z
                .array(
                  github_com_falqondev_cidade360_backend_service_AttractionDocument
                )
                .nullish(),
              fiscalAverage: z.string(),
              fiscalValues: z
                .array(
                  github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                )
                .nullish(),
              missingDocumentTypes: z.array(z.string()).nullish(),
              name: z.string(),
              registryStatus: z.string().nullish(),
              spplID: z.string(),
              status: z.string().nullish(),
              statusAt: z.string().nullish(),
              statusDetail: z.string().nullish(),
              statusID: z.string().nullish(),
              supplierDocument: z.string().nullish(),
              supplierName: z.string().nullish(),
              updatedAt: z.string(),
              videoUrl: z.string().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              brtyID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              busoID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              butyID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricKPIView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              businessMetric: z
                .object({
                  bumeID: z.number(),
                  createdAt: z.string(),
                  deletedAt: z.string().nullish(),
                  description: z.string(),
                  instID: z.string().nullish(),
                  institutionAbbreviation: z.string().nullish(),
                  institutionName: z.string().nullish(),
                  kpiProgress: z
                    .object({
                      actual: z.string(),
                      baselinePeriodEnd: z.string().nullish(),
                      baselinePeriodStart: z.string().nullish(),
                      baselineValue: z.string(),
                      displayOption: z.string(),
                      offTrack: z.string(),
                      onTrack: z.string(),
                      referenceDate: z.string().nullish(),
                      referenceValue: z.string(),
                    })
                    .passthrough(),
                  metricType: z.string(),
                  metrics: z.array(
                    github_com_falqondev_cidade360_backend_service_BusinessMetricChild
                  ),
                  name: z.string(),
                  periodValueInDays: z.number().nullish(),
                  planID: z.string(),
                  programs: z.array(
                    github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
                  ),
                  progressLink: z
                    .object({
                      acplID: z.string().nullable(),
                      actiID: z.string().nullable(),
                      actionName: z.string().nullable(),
                      actionPlanName: z.string().nullable(),
                      progID: z.string().nullable(),
                      programName: z.string().nullable(),
                      projID: z.string().nullable(),
                      projectName: z.string().nullable(),
                    })
                    .partial()
                    .passthrough()
                    .nullish(),
                  projects: z.array(
                    github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
                  ),
                  rule: z.array(
                    github_com_falqondev_cidade360_backend_service_Rule
                  ),
                  status: z.string(),
                  users: z.array(
                    github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
                  ),
                })
                .passthrough(),
              customKPI: z
                .object({
                  acplID: z.string().nullish(),
                  actiID: z.string().nullish(),
                  actionName: z.string().nullish(),
                  actionPlanName: z.string().nullish(),
                  createdAt: z.string(),
                  cukpID: z.number(),
                  deletedAt: z.string().nullish(),
                  description: z.string(),
                  kpiType: z.string(),
                  meunID: z.number().nullish(),
                  name: z.string(),
                  periodValueDisplay: z.string().nullish(),
                  periodValueInDays: z.number().nullish(),
                  progID: z.string().nullish(),
                  programName: z.string().nullish(),
                  projID: z.string().nullish(),
                  projectName: z.string().nullish(),
                  updatedAt: z.string(),
                })
                .passthrough(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              bumeID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              instID: z.string().nullish(),
              institutionAbbreviation: z.string().nullish(),
              institutionName: z.string().nullish(),
              kpiProgress: z
                .object({
                  actual: z.string(),
                  baselinePeriodEnd: z.string().nullish(),
                  baselinePeriodStart: z.string().nullish(),
                  baselineValue: z.string(),
                  displayOption: z.string(),
                  offTrack: z.string(),
                  onTrack: z.string(),
                  referenceDate: z.string().nullish(),
                  referenceValue: z.string(),
                })
                .passthrough(),
              metricType: z.string(),
              metrics: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricChild
              ),
              name: z.string(),
              periodValueInDays: z.number().nullish(),
              planID: z.string(),
              programs: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
              ),
              progressLink: z
                .object({
                  acplID: z.string().nullable(),
                  actiID: z.string().nullable(),
                  actionName: z.string().nullable(),
                  actionPlanName: z.string().nullable(),
                  progID: z.string().nullable(),
                  programName: z.string().nullable(),
                  projID: z.string().nullable(),
                  projectName: z.string().nullable(),
                })
                .partial()
                .passthrough()
                .nullish(),
              projects: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
              ),
              rule: z.array(
                github_com_falqondev_cidade360_backend_service_Rule
              ),
              status: z.string(),
              users: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
              ),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetric_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              bumeID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              instID: z.string().nullish(),
              metricType: z.string(),
              name: z.string(),
              planID: z.string(),
              rule: z.array(
                github_com_falqondev_cidade360_backend_service_Rule
              ),
              status: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              bstpID: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              isFisicaDefault: z.boolean(),
              label: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              abbreviation: z.string(),
              address: z
                .object({
                  city: z.string(),
                  country: z.string(),
                  neighborhood: z.string(),
                  number: z.string(),
                  state: z.string(),
                  street: z.string(),
                  zipCode: z.string(),
                })
                .passthrough()
                .nullish(),
              buunID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string(),
              inusID: z.number().nullish(),
              name: z.string(),
              phone: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CityEvent_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              cievID: z.string(),
              contractingMethods: z.array(z.string()),
              createdAt: z.string(),
              createdBy: z.string(),
              deletedAt: z.string().nullish(),
              endsAt: z.string(),
              evclID: z.string(),
              eventYear: z.number(),
              name: z.string(),
              parentCievID: z.string().nullish(),
              participatesInRegistration: z.boolean(),
              startsAt: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              arcoID: z.string(),
              attractionName: z.string().nullish(),
              code: z.string(),
              contractCode: z.string(),
              coteID: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              eventName: z.string().nullish(),
              requestedBy: z.string(),
              requesterName: z.string().nullish(),
              status: z.string().nullish(),
              statusAt: z.string().nullish(),
              statusDetail: z.string().nullish(),
              statusHistory: z
                .array(
                  github_com_falqondev_cidade360_backend_service_ContractTerminationStatus
                )
                .nullish(),
              statusID: z.string().nullish(),
              supplierName: z.string().nullish(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              approved: z.boolean(),
              approverName: z.string().nullish(),
              attachments: z.array(z.string()),
              ckreID: z.number().nullish(),
              cpvaID: z.number(),
              createdAt: z.string(),
              cukpID: z.number(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              message: z.string().nullish(),
              reviewedAt: z.string().nullish(),
              reviewedBy: z.string().nullish(),
              targetAt: z.string(),
              userID: z.string(),
              userName: z.string(),
              value: z.string(),
              valueOmitted: z.boolean(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              acplID: z.string().nullish(),
              actiID: z.string().nullish(),
              actionName: z.string().nullish(),
              actionPlanName: z.string().nullish(),
              createdAt: z.string(),
              cukpID: z.number(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              kpiType: z.string(),
              meunID: z.number().nullish(),
              name: z.string(),
              periodValueDisplay: z.string().nullish(),
              periodValueInDays: z.number().nullish(),
              progID: z.string().nullish(),
              programName: z.string().nullish(),
              projID: z.string().nullish(),
              projectName: z.string().nullish(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidents_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              averageResponseTime: z
                .object({
                  average: z.string(),
                  comparativePercentageLastMonth: z.number(),
                  comparativePercentageLastYear: z.number(),
                })
                .passthrough(),
              incidentProgression: z
                .object({
                  comparativePercentageLastMonth: z.number(),
                  comparativePercentageLastYear: z.number(),
                  percentage: z.number(),
                })
                .passthrough(),
              securityIncidents: z
                .object({
                  comparativePercentageLastMonth: z.number(),
                  comparativePercentageLastYear: z.number(),
                  total: z.number(),
                })
                .passthrough(),
              serviceIncidents: z
                .object({
                  comparativePercentageLastMonth: z.number(),
                  comparativePercentageLastYear: z.number(),
                  total: z.number(),
                })
                .passthrough(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardSurvey_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              pools: z.number(),
              responses: z.array(
                github_com_falqondev_cidade360_backend_service_DashboardSurveyResponse
              ),
              survIDs: z.array(z.string()),
              totalAnswers: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrder_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              MonthTotal: z
                .object({
                  comparativePercentageLastYear: z.number(),
                  total: z.number(),
                })
                .passthrough(),
              YearTotal: z
                .object({
                  comparativePercentageLastYear: z.number(),
                  total: z.number(),
                })
                .passthrough(),
              averagePerYear: z.number(),
              total: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              ddteID: z.number(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              formField: z.string(),
              formName: z.string(),
              instID: z.string(),
              institutionName: z.string(),
              name: z.string(),
              placeholder: z.boolean(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              dinaID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              distID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              dinaID: z.number(),
              disuID: z.number(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              diunID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              defaultData: z.unknown(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              doteID: z.string(),
              formSchema: z.unknown(),
              permissionMode: z.string(),
              printSchema: z.unknown(),
              title: z.string(),
              uiSchema: z.unknown(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Document_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              data: z.unknown(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              docuID: z.string(),
              doteID: z.string(),
              formSchema: z.unknown(),
              permissionMode: z.string(),
              printSchema: z.unknown(),
              title: z.string(),
              uiSchema: z.unknown(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              content: z.string(),
              createdAt: z.string(),
              docuID: z.number(),
              tags: z.array(z.string()),
              title: z.string(),
              videoURL: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Documentation_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              content: z.string(),
              createdAt: z.string(),
              docuID: z.number(),
              tags: z.array(z.string()),
              title: z.string(),
              videoURL: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_EventClassification_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              evclID: z.string(),
              name: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              details: z
                .object({
                  carrying_capacity: z.string(),
                  color: z.string(),
                  dimensions: z
                    .object({
                      height: z.number(),
                      length: z.number(),
                      width: z.number(),
                    })
                    .passthrough(),
                  engine: z
                    .object({ capacity: z.string(), type: z.string() })
                    .passthrough(),
                  features: z.array(z.string()),
                  mileage_km: z.number(),
                  purchase_date: z.string(),
                  seat_numbers: z.number(),
                  serial_number: z.string(),
                  type: z.string(),
                  warranty: z
                    .object({
                      details: z.string().nullish(),
                      expiry_date: z.string(),
                    })
                    .passthrough(),
                })
                .passthrough(),
              flveID: z.number(),
              instID: z.string(),
              institutionName: z.string().nullish(),
              licensePlate: z.string(),
              make: z.string(),
              model: z.string(),
              registrationNumber: z.string(),
              updatedAt: z.string(),
              year: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              doteID: z.string(),
              fodtID: z.number(),
              formName: z.string(),
              instID: z.string(),
              institutionName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              formName: z.string(),
              fovaID: z.number(),
              instID: z.string(),
              institutionName: z.string(),
              validationSchema: z.unknown(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_GuicheView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              guicID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              iatyID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              indiID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              inenID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              inesID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              innaID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              inorID: z.number(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              inprID: z.number(),
              instID: z.string(),
              institutionName: z.string().nullish(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              irloID: z.number(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string().nullable() })
                    .partial()
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              istaID: z.number(),
              name: z.string(),
              reasons: z.array(z.string()).nullish(),
              requiredReason: z.boolean().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              inbnID: z.number(),
              innaID: z.number(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              inprID: z.number(),
              insuID: z.number(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              actionTypeName: z.string(),
              address: z
                .object({
                  city: z.string().nullish(),
                  complement: z.string().nullish(),
                  isVillage: z.boolean(),
                  latitude: z.number().nullish(),
                  longitude: z.number().nullish(),
                  neighborhood: z.string().nullish(),
                  number: z.string().nullish(),
                  state: z.string().nullish(),
                  street: z.string().nullish(),
                  zipCode: z.string().nullish(),
                })
                .passthrough()
                .nullish(),
              agentID: z.string().nullish(),
              agentName: z.string(),
              agentRole: z.string().nullish(),
              arrivalAt: z.string().nullish(),
              buunID: z.number().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              depredations: z.array(
                github_com_falqondev_cidade360_backend_service_Depredation
              ),
              description: z.string(),
              details: z
                .object({
                  confidential: z.boolean().nullable(),
                  protocolNumber: z.string().nullable(),
                  relatorAttachment: z.string().nullable(),
                  relatorDescription: z.string().nullable(),
                  solution: z.string().nullable(),
                })
                .partial()
                .passthrough(),
              dinaID: z.number().nullish(),
              dispatchNature: z.string(),
              dispatchStatus: z.string(),
              dispatchSubnature: z.string(),
              dispatchUnit: z.string(),
              dispatcherName: z.string(),
              distID: z.number().nullish(),
              disuID: z.number().nullish(),
              diunID: z.number().nullish(),
              environmentName: z.string().nullish(),
              establishmentName: z.string().nullish(),
              fieldContact: z
                .object({
                  name: z.string().nullable(),
                  phone: z.string().nullable(),
                })
                .partial()
                .passthrough(),
              guicID: z.number().nullish(),
              guicheName: z.string(),
              iatyID: z.number().nullish(),
              ifdiID: z.number().nullish(),
              inbnID: z.number().nullish(),
              inciID: z.string(),
              incidentType: z.string(),
              incidentVehicles: z.array(
                github_com_falqondev_cidade360_backend_service_IncidentVehicleView
              ),
              indeID: z.number().nullish(),
              indiID: z.number().nullish(),
              inenID: z.number().nullish(),
              inesID: z.number().nullish(),
              infdID: z.number().nullish(),
              ininID: z.number().nullish(),
              innaID: z.number().nullish(),
              inorID: z.number().nullish(),
              inprID: z.number().nullish(),
              inseID: z.number().nullish(),
              instID: z.string(),
              institutionName: z.string(),
              insuID: z.number().nullish(),
              involvedParties: z.array(
                github_com_falqondev_cidade360_backend_service_InvolvedPartyView
              ),
              istaID: z.number(),
              natureName: z.string(),
              originName: z.string(),
              partnerInstID: z.string().nullish(),
              partnerInstitutionName: z.string(),
              programName: z.string(),
              progressionFromUid: z.string().nullish(),
              publicEquipmentName: z.string(),
              pueqID: z.number().nullish(),
              relatorCode: z.string().nullish(),
              relatorID: z.string().nullish(),
              relatorName: z.string(),
              relatorRole: z.string().nullish(),
              requester: z
                .object({
                  email: z.string().nullable(),
                  name: z.string().nullable(),
                  phone: z.string().nullable(),
                  sex: z.string().nullable(),
                })
                .partial()
                .passthrough()
                .nullish(),
              sechID: z.number().nullish(),
              seizedItems: z.array(
                github_com_falqondev_cidade360_backend_service_SeizedItemView
              ),
              serviceChannelName: z.string(),
              servicedAt: z.string().nullish(),
              statusInfo: z
                .object({
                  displayOptions: z
                    .object({ color: z.string().nullable() })
                    .partial()
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              statusName: z.string(),
              statusReason: z.string().nullish(),
              subnatureName: z.string(),
              subprogramName: z.string(),
              uid: z.string(),
              updatedAt: z.string(),
              userID: z.string(),
              workOrderUid: z.string().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InportPlansResult_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              importedActionPlans: z.array(z.string()),
              importedActions: z.array(z.string()),
              importedBusinessMetric: z.array(z.number()),
              importedPlans: z.array(z.string()),
              importedPrograms: z.array(z.string()),
              importedProjects: z.array(z.string()),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              admittedAt: z.string().nullish(),
              buunID: z.number().nullish(),
              code: z.string().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string(),
              inusID: z.number(),
              name: z.string(),
              operationalCode: z.string().nullish(),
              phone: z.string(),
              sex: z.string(),
              updatedAt: z.string(),
              userID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Institution_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              abbreviation: z.string(),
              avatar: z.string().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              documentNumber: z.string(),
              documentType: z.string(),
              instID: z.string(),
              name: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_KanbanView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              defaultStatus: z.boolean(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              mostID: z.number(),
              name: z.string(),
              orderIndex: z.number(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              mrvnID: z.string(),
              note: z.string().nullish(),
              spplID: z.string(),
              userID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              formatConfig: z
                .object({
                  decimalPlaces: z.number(),
                  decimalSep: z.string(),
                  prefix: z.string(),
                  suffix: z.string(),
                  thousandsSep: z.string(),
                })
                .passthrough(),
              meunID: z.number(),
              name: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MySurvey_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              activeAt: z.string().nullish(),
              answers: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              descriptionFinished: z.string(),
              displayOptions: z.unknown(),
              drafts: z.number(),
              slug: z.string(),
              survID: z.string(),
              surveyForms: z.array(
                github_com_falqondev_cidade360_backend_service_SurveyForm
              ),
              title: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationConfig_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              module: z.string(),
              noruID: z.string(),
              notificationIntegrations: z
                .object({
                  email: z
                    .object({
                      active: z.boolean(),
                      password: z.string(),
                      port: z.number(),
                      server: z.string(),
                      user: z.string(),
                    })
                    .passthrough()
                    .nullable(),
                  googleChat: z
                    .object({
                      accessToken: z.string().nullish(),
                      active: z.boolean(),
                      clientID: z.string(),
                      clientSecret: z.string(),
                      expiresAt: z.string().nullish(),
                      name: z.string(),
                      refreshToken: z.string().nullish(),
                    })
                    .passthrough()
                    .nullable(),
                  teams: z
                    .object({
                      accessToken: z.string().nullish(),
                      active: z.boolean(),
                      chatID: z.string(),
                      clientID: z.string(),
                      clientSecret: z.string(),
                      expiresAt: z.string().nullish(),
                      graphUserID: z.string().nullish(),
                      refreshToken: z.string().nullish(),
                      tenantID: z.string(),
                    })
                    .passthrough()
                    .nullable(),
                  whatsapp: z
                    .object({
                      active: z.boolean(),
                      phoneID: z.string(),
                      token: z.string(),
                      wabaID: z.string(),
                    })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              rules: z
                .object({
                  notifySupplierDocumentExpiring: z.boolean(),
                  notifySupplierDocumentStatusChange: z.boolean(),
                  notifySupplierPenaltyCreated: z.boolean(),
                  notifySupplierRegistryStatusChange: z.boolean(),
                  supplierDocumentExpiryRules: z
                    .array(
                      github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
                    )
                    .nullish(),
                })
                .passthrough(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationIntegrationConfig_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              email: z
                .object({
                  active: z.boolean(),
                  password: z.string(),
                  port: z.number(),
                  server: z.string(),
                  user: z.string(),
                })
                .passthrough()
                .nullable(),
              googleChat: z
                .object({
                  accessToken: z.string().nullish(),
                  active: z.boolean(),
                  clientID: z.string(),
                  clientSecret: z.string(),
                  expiresAt: z.string().nullish(),
                  name: z.string(),
                  refreshToken: z.string().nullish(),
                })
                .passthrough()
                .nullable(),
              teams: z
                .object({
                  accessToken: z.string().nullish(),
                  active: z.boolean(),
                  chatID: z.string(),
                  clientID: z.string(),
                  clientSecret: z.string(),
                  expiresAt: z.string().nullish(),
                  graphUserID: z.string().nullish(),
                  refreshToken: z.string().nullish(),
                  tenantID: z.string(),
                })
                .passthrough()
                .nullable(),
              whatsapp: z
                .object({
                  active: z.boolean(),
                  phoneID: z.string(),
                  token: z.string(),
                  wabaID: z.string(),
                })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              data: z.unknown(),
              notiID: z.string(),
              path: z.string(),
              readAt: z.string().nullish(),
              userID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_OneTimeLogin_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              otloID: z.number(),
              token: z.string(),
              userID: z.string(),
              validUntil: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PendingUserTerms_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              terms: z.array(
                github_com_falqondev_cidade360_backend_service_PendingTerm
              ),
              userID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              phcoID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanBudgetSummary_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              budgetSummary: z.array(
                github_com_falqondev_cidade360_backend_service_BudgetSummary
              ),
              percentageUsage: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanDashboard_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              budgetSourceName: z.array(z.string()),
              planID: z.string(),
              resourceTimeline: z.array(
                github_com_falqondev_cidade360_backend_service_ResourceCount
              ),
              totalActual: z.number(),
              totalPredicted: z.number(),
              totalReceived: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanSummary_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              resourceSummary: z.array(
                github_com_falqondev_cidade360_backend_service_Resource
              ),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanTaskSummary_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              finishedPercentage: z.number(),
              finishedTasks: z.number(),
              openTasks: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              endAt: z.string(),
              instID: z.string(),
              institutionName: z.string(),
              institutionUserName: z.string(),
              inusID: z.number(),
              isDefault: z.boolean(),
              name: z.string(),
              planID: z.string(),
              planUsers: z.array(
                github_com_falqondev_cidade360_backend_service_ProjetcUserView
              ),
              startAt: z.string(),
              thaxID: z.array(z.number()),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              attachment: z.string().nullish(),
              commID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              message: z.string(),
              progID: z.string(),
              userAvatar: z.string().nullish(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramFinalBudget_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({ progID: z.string(), totalActual: z.number() })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              axes: z.array(z.number()),
              budgets: z.array(
                z
                  .object({
                    actual: z.string(),
                    attachments: z.array(z.string()),
                    brtyID: z.number().nullish(),
                    budgID: z.string(),
                    busoID: z.number(),
                    butyID: z.number().nullish(),
                    predicted: z.string(),
                    rationale: z.string().nullish(),
                    received: z.string(),
                    referenceYear: z.string().nullish(),
                  })
                  .passthrough()
              ),
              content: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              instID: z.string().nullish(),
              institutionAbbreviation: z.string().nullish(),
              institutionName: z.string().nullish(),
              institutionUserAvatar: z.string().nullish(),
              institutionUserEmail: z.string().nullish(),
              institutionUserName: z.string().nullish(),
              institutions: z.array(z.string()),
              inusID: z.number().nullish(),
              milestoneCount: z.number(),
              milestoneDoneCount: z.number(),
              mostID: z.number().nullish(),
              mostOrderIndex: z.number(),
              name: z.string(),
              period: z
                .object({
                  endAt: z.string(),
                  oppeID: z.number(),
                  startAt: z.string(),
                })
                .passthrough(),
              planID: z.string(),
              progID: z.string(),
              programUsers: z.array(
                github_com_falqondev_cidade360_backend_service_ProgramUserView
              ),
              projectCount: z.number(),
              projectDoneCount: z.number(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              statusInfo: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              statusMessage: z.string(),
              statusOrderIndex: z.number(),
              statusReferenceDate: z.string(),
              thematicAxisInfo: z.array(
                z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    thaxID: z.number(),
                  })
                  .passthrough()
              ),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Program_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              content: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              inusID: z.number().nullish(),
              name: z.string(),
              planID: z.string(),
              progID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              attachment: z.string().nullish(),
              commID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              message: z.string(),
              projID: z.string(),
              userAvatar: z.string().nullish(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectFinalBudget_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({ projID: z.string(), totalActual: z.number() })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              attachments: z.array(z.string()),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              message: z.string(),
              orderIndex: z.number(),
              projID: z.string(),
              projectName: z.string(),
              prstID: z.number(),
              referenceDate: z.string(),
              requestReview: z.boolean(),
              reviewMessage: z.string(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              actionPlanCount: z.number(),
              actionPlanDoneCount: z.number(),
              attachment: z.string().nullish(),
              axes: z.array(z.number()),
              budgets: z.array(
                z
                  .object({
                    actual: z.string(),
                    attachments: z.array(z.string()),
                    brtyID: z.number().nullish(),
                    budgID: z.string(),
                    busoID: z.number(),
                    butyID: z.number().nullish(),
                    predicted: z.string(),
                    rationale: z.string().nullish(),
                    received: z.string(),
                    referenceYear: z.string().nullish(),
                  })
                  .passthrough()
              ),
              content: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              instID: z.string(),
              institutionAbbreviation: z.string(),
              institutionName: z.string(),
              institutionUserAvatar: z.string().nullish(),
              institutionUserEmail: z.string().nullish(),
              institutionUserName: z.string(),
              institutions: z.array(z.string()),
              inusID: z.number(),
              milestoneCount: z.number(),
              milestoneDoneCount: z.number(),
              mostID: z.number().nullish(),
              mostOrderIndex: z.number(),
              name: z.string(),
              period: z
                .object({
                  endAt: z.string(),
                  oppeID: z.number(),
                  startAt: z.string(),
                })
                .passthrough(),
              planID: z.string(),
              progID: z.string().nullish(),
              projID: z.string(),
              projectUsers: z.array(
                github_com_falqondev_cidade360_backend_service_ProjetcUserView
              ),
              status: z
                .object({
                  approvedBy: z.string().nullish(),
                  approverName: z.string().nullish(),
                  attachments: z.array(z.string()),
                  deletedAt: z.string().nullish(),
                  info: z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullable(),
                    })
                    .partial()
                    .passthrough(),
                  message: z.string(),
                  orderIndex: z.number(),
                  projID: z.string(),
                  prstID: z.number(),
                  referenceDate: z.string(),
                  requestReview: z.boolean(),
                  reviewMessage: z.string(),
                  statID: z.number(),
                  state: z.string(),
                  status: z.string(),
                  userID: z.string(),
                  userName: z.string(),
                })
                .passthrough(),
              thematicAxisInfo: z.array(
                z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    thaxID: z.number(),
                  })
                  .passthrough()
              ),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              pueqID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              recoID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              sechID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_StatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              defaultStatus: z.boolean(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              name: z.string(),
              orderIndex: z.number(),
              requestReview: z.boolean(),
              slug: z.string(),
              statID: z.number(),
              state: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Status_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              name: z.string(),
              orderIndex: z.number(),
              requestReview: z.boolean(),
              slug: z.string(),
              statID: z.number(),
              state: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              code: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              name: z.string(),
              subaID: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              bstpID: z.string(),
              doctID: z.string(),
              sbtdID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              clgrID: z.string(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              label: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              clgrID: z.string(),
              label: z.string(),
              scsgID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              clasID: z.string(),
              code: z.string(),
              label: z.string(),
              scsgID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentStatus_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              current: z.boolean(),
              detail: z.string().nullish(),
              reviewedBy: z.string().nullish(),
              spdcID: z.string(),
              spdsID: z.string(),
              status: z.string(),
              validationResult: z.string().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              deletedAt: z.string().nullish(),
              doctID: z.string(),
              extractionFields: z.array(
                github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
              ),
              label: z.string(),
              validationPrompt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAdminView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              activeAttemptID: z.string().nullish(),
              aiResult: z
                .object({
                  fields: z.array(
                    github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult
                  ),
                  reason: z.string(),
                  status: z.string(),
                })
                .passthrough()
                .nullish(),
              attempts: z
                .array(
                  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAttempt
                )
                .nullish(),
              completedAt: z.string().nullish(),
              createdAt: z.string(),
              currentStage: z.string().nullish(),
              currentStatus: z.string(),
              currentStatusID: z.string(),
              cycleNumber: z.number(),
              documentID: z.string(),
              enqueuedAt: z.string().nullish(),
              errorCode: z.string().nullish(),
              events: z
                .array(
                  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvent
                )
                .nullish(),
              executionState: z.string(),
              extractedTextBytes: z.number().nullish(),
              failureCount: z.number(),
              lastDiagnostic: z
                .object({
                  causes: z.array(z.string()),
                  code: z.string(),
                  createdAt: z.string(),
                  message: z.string(),
                  stage: z.string(),
                  version: z.number(),
                })
                .passthrough()
                .nullish(),
              model: z.string().nullish(),
              provider: z.string().nullish(),
              resultSource: z.string().nullish(),
              scheduledAt: z.string(),
              startedAt: z.string().nullish(),
              updatedAt: z.string(),
              verificationID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessResult_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              alreadyExists: z.boolean(),
              attemptID: z.string(),
              cycle: z.number(),
              verificationID: z.string(),
              workflowID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string().nullish(),
              label: z.string(),
              scopID: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              complement: z.string().nullish(),
              contractNumber: z.string().nullish(),
              createdAt: z.string(),
              decisionType: z.string().nullish(),
              deletedAt: z.string().nullish(),
              description: z.string().nullish(),
              dom: z.string(),
              endDate: z.string(),
              legalBasis: z.string(),
              legalBasisDescription: z.string().nullish(),
              pennID: z.string(),
              process: z.string(),
              publishingDate: z.string(),
              sanctionType: z.string(),
              scopID: z.string(),
              spplID: z.string(),
              startDate: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              additionalAddressInfo: z.string().nullish(),
              address: z.string().nullish(),
              addressNumber: z.number().nullish(),
              bankName: z.string().nullish(),
              branch: z.string().nullish(),
              bstpID: z.string().nullish(),
              businessTypeName: z.string().nullish(),
              checkingAccount: z.string().nullish(),
              city: z.string().nullish(),
              cnpj: z.string().nullish(),
              country: z.string().nullish(),
              cpf: z.string().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              email: z.string().nullish(),
              firstName: z.string().nullish(),
              lastName: z.string().nullish(),
              legalName: z.string().nullish(),
              municipalRegistration: z.string().nullish(),
              neighborhood: z.string().nullish(),
              personType: z.string(),
              phone: z.string().nullish(),
              postalCode: z.string().nullish(),
              registryStatus: z.string().nullish(),
              spplID: z.string(),
              state: z.string().nullish(),
              stateRegistration: z.string().nullish(),
              status: z.string(),
              subaID: z.string().nullish(),
              tradeName: z.string().nullish(),
              updatedAt: z.string(),
              userID: z.string().nullish(),
              verifiedEmail: z.boolean().nullish(),
              verifiedPhone: z.boolean().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyFormTemplate_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({ doteID: z.string(), suftID: z.number() })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              name: z.string(),
              responses: z.array(
                github_com_falqondev_cidade360_backend_service_SurveyResponseData
              ),
              submittedAt: z.string().nullish(),
              sursID: z.string(),
              survID: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseSession_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              submittedAt: z.string().nullish(),
              sursID: z.string(),
              survID: z.string(),
              userID: z.string().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponse_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              clientDevice: z.string(),
              clientIP: z.string(),
              clientUID: z.string(),
              createdAt: z.string(),
              docuID: z.string(),
              doteID: z.string(),
              metadata: z.unknown(),
              sureID: z.number(),
              sursID: z.string(),
              survID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Survey_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              activeAt: z.string().nullish(),
              allowedUsers: z.array(z.string()),
              answers: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              descriptionFinished: z.string(),
              displayOptions: z.unknown(),
              drafts: z.number(),
              slug: z.string(),
              survID: z.string(),
              surveyForms: z.array(
                github_com_falqondev_cidade360_backend_service_SurveyForm
              ),
              title: z.string(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_TOTPDisableResponse_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.object({ disabled: z.boolean() }).passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Term_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              slug: z.string(),
              termID: z.number(),
              title: z.string(),
              type: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              name: z.string(),
              thaxID: z.number(),
              updatedAt: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              ureqID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInfo_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.object({ tourCompleted: z.boolean() }).passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInformation_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              applID: z.string(),
              authenticationProvider: z.string(),
              avatar: z.string().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              email: z.string().nullish(),
              info: z.object({ tourCompleted: z.boolean() }).passthrough(),
              name: z.string(),
              phone: z.string().nullish(),
              pushTokens: z.array(z.string()).nullish(),
              roles: z.array(z.string()),
              userID: z.string(),
              userInstitutions: z.array(
                github_com_falqondev_cidade360_backend_service_UserInstitutions
              ),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserRoleView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({ roles: z.array(z.string()), userID: z.string() })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserTerm_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              accepted: z.boolean(),
              termID: z.number(),
              userID: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              vupoID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              woclID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string(),
              institutionName: z.string().nullish(),
              name: z.string(),
              woprID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              worfID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              instID: z.string().nullish(),
              institutionName: z.string().nullish(),
              name: z.string(),
              wortID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              name: z.string(),
              reasons: z.array(z.string()).nullish(),
              requiredReason: z.boolean().nullish(),
              wostID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              name: z.string(),
              woprID: z.number(),
              wosuID: z.number(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              address: z
                .object({
                  city: z.string().nullable(),
                  complement: z.string().nullable(),
                  latitude: z.number().nullable(),
                  longitude: z.number().nullable(),
                  neighborhood: z.string().nullable(),
                  number: z.string().nullable(),
                  state: z.string().nullable(),
                  street: z.string().nullable(),
                  zipCode: z.string().nullable(),
                })
                .partial()
                .passthrough(),
              attachment: z.string(),
              classification: z.string().nullish(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              endAt: z.string().nullish(),
              event: z.string(),
              extraordinaryEffective: z.number(),
              fieldAgents: z.array(
                github_com_falqondev_cidade360_backend_service_FieldAgentInfo
              ),
              generalEffective: z.number(),
              instID: z.string(),
              institutionName: z.string(),
              ordinaryEffective: z.number(),
              planningIdentifier: z.string(),
              programName: z.string(),
              recoID: z.number().nullish(),
              requester: z
                .object({
                  documentNumber: z.string().nullable(),
                  documentType: z.string().nullable(),
                  name: z.string().nullable(),
                  phone: z.string().nullable(),
                })
                .partial()
                .passthrough(),
              requesterCompanyName: z.string().nullish(),
              requesterRole: z.string(),
              requesterType: z.string(),
              startAt: z.string().nullish(),
              status: z.string(),
              statusInfo: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              statusReason: z.string().nullish(),
              subprogramName: z.string(),
              uid: z.string(),
              updatedAt: z.string(),
              urbanEquipmentName: z.string(),
              ureqID: z.number().nullish(),
              userID: z.string(),
              woclID: z.number().nullish(),
              wodoID: z.number().nullish(),
              wofaID: z.number().nullish(),
              woorID: z.string(),
              woprID: z.number().nullish(),
              worfID: z.number().nullish(),
              wortID: z.number().nullish(),
              wostID: z.number(),
              wosuID: z.number().nullish(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z
            .object({
              applicationID: z.string().nullish(),
              applicationVersion: z.string().nullish(),
              attempts: z.number(),
              authenticatedUser: z.string().nullish(),
              createdAt: z.string(),
              deadline: z.string().nullish(),
              error: z.string().nullish(),
              executorID: z.string().nullish(),
              forkedFrom: z.string().nullish(),
              input: z.string().nullish(),
              output: z.string().nullish(),
              queueName: z.string().nullish(),
              startedAt: z.string().nullish(),
              status: z.string(),
              updatedAt: z.string(),
              workflowID: z.string(),
              workflowName: z.string(),
            })
            .passthrough(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_interface__ =
  z
    .object({
      context: z.string().nullish(),
      data: z.object({}).partial().passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_string_ =
  z
    .object({
      context: z.string().nullish(),
      data: z
        .object({
          item: z.string(),
          kind: z.string(),
          lang: z.string().nullish(),
        })
        .passthrough(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_bool_ = z
  .object({ item: z.boolean(), kind: z.string(), lang: z.string().nullish() })
  .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_adminDocumentMediaAuthResponse_ =
  z
    .object({
      item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_aiProxyResponse_ =
  z
    .object({
      item: z.object({}).partial().passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_attractionDocumentMediaAuthResponse_ =
  z
    .object({
      item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_mediaAuthToken_ =
  z
    .object({
      item: z.object({ jwt: z.string() }).passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_ =
  z
    .object({
      item: z
        .object({
          actiID: z.string(),
          attachment: z.string().nullish(),
          commID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          message: z.string(),
          userAvatar: z.string().nullish(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_ =
  z
    .object({
      item: z
        .object({
          acplID: z.string(),
          attachment: z.string().nullish(),
          commID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          message: z.string(),
          userAvatar: z.string().nullish(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_ =
  z
    .object({
      item: z
        .object({
          acplID: z.string(),
          actionPlanName: z.string(),
          approvedBy: z.string().nullish(),
          approverName: z.string().nullish(),
          apstID: z.number(),
          attachments: z.array(z.string()),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          message: z.string(),
          orderIndex: z.number(),
          referenceDate: z.string(),
          requestReview: z.boolean(),
          reviewMessage: z.string(),
          statID: z.number(),
          state: z.string(),
          status: z.string(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_ =
  z
    .object({
      item: z
        .object({
          acplID: z.string(),
          actionCount: z.number(),
          actionPlanUsers: z.array(
            github_com_falqondev_cidade360_backend_service_ActionPlanUserView
          ),
          attachment: z.string().nullish(),
          comments: z.number().nullish(),
          content: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          doneActionCount: z.number(),
          doneMilestoneCount: z.number(),
          instID: z.string(),
          institutionAbbreviation: z.string(),
          institutionName: z.string(),
          institutionUserAvatar: z.string().nullish(),
          institutionUserEmail: z.string().nullish(),
          institutionUserName: z.string(),
          institutions: z.array(z.string()),
          inusID: z.number(),
          milestoneCount: z.number(),
          mostID: z.number().nullish(),
          mostOrderIndex: z.number(),
          name: z.string(),
          period: z
            .object({
              endAt: z.string(),
              oppeID: z.number(),
              startAt: z.string(),
            })
            .passthrough(),
          progID: z.string().nullish(),
          projID: z.string(),
          projectInfo: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullish(),
              name: z.string(),
              projID: z.string(),
            })
            .passthrough(),
          revision: z
            .object({
              apbrID: z.number(),
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              budgets: z.array(
                z
                  .object({
                    actual: z.string(),
                    attachments: z.array(z.string()),
                    brtyID: z.number().nullish(),
                    budgID: z.string(),
                    busoID: z.number(),
                    butyID: z.number().nullish(),
                    predicted: z.string(),
                    rationale: z.string().nullish(),
                    received: z.string(),
                    referenceYear: z.string().nullish(),
                  })
                  .passthrough()
              ),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              reviewMessage: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough()
            .nullish(),
          status: z
            .object({
              acplID: z.string(),
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              apstID: z.number(),
              attachments: z.array(z.string()),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              message: z.string(),
              orderIndex: z.number(),
              referenceDate: z.string(),
              requestReview: z.boolean(),
              reviewMessage: z.string(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          thematicAxisInfo: z.array(
            z
              .object({
                displayOptions: z
                  .object({ color: z.string() })
                  .passthrough()
                  .nullish(),
                thaxID: z.number(),
              })
              .passthrough()
          ),
          type: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlan_ =
  z
    .object({
      item: z
        .object({
          acplID: z.string(),
          attachment: z.string().nullish(),
          content: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          inusID: z.number(),
          name: z.string(),
          progID: z.string().nullish(),
          projID: z.string(),
          type: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_ =
  z
    .object({
      item: z
        .object({
          acstID: z.number(),
          actiID: z.string(),
          actionName: z.string(),
          approvedBy: z.string().nullish(),
          approverName: z.string().nullish(),
          attachments: z.array(z.string()),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          message: z.string(),
          orderIndex: z.number(),
          referenceDate: z.string(),
          requestReview: z.boolean(),
          reviewMessage: z.string(),
          statID: z.number(),
          state: z.string(),
          status: z.string(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionView_ =
  z
    .object({
      item: z
        .object({
          acplID: z.string(),
          actiID: z.string(),
          actionPlanName: z.string(),
          comments: z.number().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string(),
          institutionAbbreviation: z.string(),
          institutionName: z.string(),
          inusID: z.number(),
          milestone: z.boolean(),
          mostID: z.number().nullish(),
          mostOrderIndex: z.number(),
          name: z.string(),
          parentID: z.string().nullish(),
          period: z
            .object({
              endAt: z.string(),
              oppeID: z.number(),
              startAt: z.string(),
            })
            .passthrough(),
          progID: z.string().nullish(),
          projID: z.string(),
          projectInfo: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullish(),
              name: z.string(),
              projID: z.string(),
            })
            .passthrough(),
          status: z
            .object({
              acstID: z.number(),
              actiID: z.string(),
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              attachments: z.array(z.string()),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              message: z.string(),
              orderIndex: z.number(),
              referenceDate: z.string(),
              requestReview: z.boolean(),
              reviewMessage: z.string(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          userAvatar: z.string().nullish(),
          userEmail: z.string().nullish(),
          userName: z.string().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_ =
  z
    .object({
      item: z
        .object({
          aproID: z.string(),
          assignmentRules: z.array(z.string()),
          description: z.string(),
          name: z.string(),
          roles: z.array(z.string()),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractStatus_ =
  z
    .object({
      item: z
        .object({
          acstID: z.string(),
          arcoID: z.string(),
          changedBy: z.string(),
          createdAt: z.string(),
          current: z.boolean(),
          detail: z.string().nullish(),
          status: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_ =
  z
    .object({
      item: z
        .object({
          agency: z.string(),
          arcoID: z.string(),
          attrID: z.string(),
          attractionName: z.string().nullish(),
          attractionStatus: z.string().nullish(),
          blockingItems: z.array(z.string()).nullish(),
          cievID: z.string(),
          code: z.string(),
          createdAt: z.string(),
          createdBy: z.string(),
          dates: z
            .array(
              github_com_falqondev_cidade360_backend_service_ArtisticContractDate
            )
            .nullish(),
          deadlineExpired: z.boolean(),
          deletedAt: z.string().nullish(),
          eventName: z.string().nullish(),
          finalizationDeadline: z.string(),
          logs: z
            .array(
              github_com_falqondev_cidade360_backend_service_ArtisticContractLog
            )
            .nullish(),
          requestedAmount: z.string(),
          spplID: z.string(),
          status: z.string().nullish(),
          statusAt: z.string().nullish(),
          statusDetail: z.string().nullish(),
          statusID: z.string().nullish(),
          supplierDocument: z.string().nullish(),
          supplierName: z.string().nullish(),
          supplierStatus: z.string().nullish(),
          updatedAt: z.string(),
          venue: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentStatus_ =
  z
    .object({
      item: z
        .object({
          adstID: z.string(),
          atdoID: z.string(),
          createdAt: z.string(),
          current: z.boolean(),
          detail: z.string().nullish(),
          reviewedBy: z.string().nullish(),
          status: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionRegistryStatus_ =
  z
    .object({
      item: z
        .object({
          arstID: z.string(),
          attrID: z.string(),
          createdAt: z.string(),
          current: z.boolean(),
          detail: z.string().nullish(),
          reviewedBy: z.string().nullish(),
          status: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionView_ =
  z
    .object({
      item: z
        .object({
          attrID: z.string(),
          attractionType: z.string(),
          clippingLinks: z
            .array(
              github_com_falqondev_cidade360_backend_service_AttractionClippingLink
            )
            .nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          documents: z
            .array(
              github_com_falqondev_cidade360_backend_service_AttractionDocument
            )
            .nullish(),
          fiscalAverage: z.string(),
          fiscalValues: z
            .array(
              github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
            )
            .nullish(),
          missingDocumentTypes: z.array(z.string()).nullish(),
          name: z.string(),
          registryStatus: z.string().nullish(),
          spplID: z.string(),
          status: z.string().nullish(),
          statusAt: z.string().nullish(),
          statusDetail: z.string().nullish(),
          statusID: z.string().nullish(),
          supplierDocument: z.string().nullish(),
          supplierName: z.string().nullish(),
          updatedAt: z.string(),
          videoUrl: z.string().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_ =
  z
    .object({
      item: z
        .object({
          brtyID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_ =
  z
    .object({
      item: z
        .object({
          busoID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetType_ =
  z
    .object({
      item: z
        .object({
          butyID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricKPIView_ =
  z
    .object({
      item: z
        .object({
          businessMetric: z
            .object({
              bumeID: z.number(),
              createdAt: z.string(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              instID: z.string().nullish(),
              institutionAbbreviation: z.string().nullish(),
              institutionName: z.string().nullish(),
              kpiProgress: z
                .object({
                  actual: z.string(),
                  baselinePeriodEnd: z.string().nullish(),
                  baselinePeriodStart: z.string().nullish(),
                  baselineValue: z.string(),
                  displayOption: z.string(),
                  offTrack: z.string(),
                  onTrack: z.string(),
                  referenceDate: z.string().nullish(),
                  referenceValue: z.string(),
                })
                .passthrough(),
              metricType: z.string(),
              metrics: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricChild
              ),
              name: z.string(),
              periodValueInDays: z.number().nullish(),
              planID: z.string(),
              programs: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
              ),
              progressLink: z
                .object({
                  acplID: z.string().nullable(),
                  actiID: z.string().nullable(),
                  actionName: z.string().nullable(),
                  actionPlanName: z.string().nullable(),
                  progID: z.string().nullable(),
                  programName: z.string().nullable(),
                  projID: z.string().nullable(),
                  projectName: z.string().nullable(),
                })
                .partial()
                .passthrough()
                .nullish(),
              projects: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
              ),
              rule: z.array(
                github_com_falqondev_cidade360_backend_service_Rule
              ),
              status: z.string(),
              users: z.array(
                github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
              ),
            })
            .passthrough(),
          customKPI: z
            .object({
              acplID: z.string().nullish(),
              actiID: z.string().nullish(),
              actionName: z.string().nullish(),
              actionPlanName: z.string().nullish(),
              createdAt: z.string(),
              cukpID: z.number(),
              deletedAt: z.string().nullish(),
              description: z.string(),
              kpiType: z.string(),
              meunID: z.number().nullish(),
              name: z.string(),
              periodValueDisplay: z.string().nullish(),
              periodValueInDays: z.number().nullish(),
              progID: z.string().nullish(),
              programName: z.string().nullish(),
              projID: z.string().nullish(),
              projectName: z.string().nullish(),
              updatedAt: z.string(),
            })
            .passthrough(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_ =
  z
    .object({
      item: z
        .object({
          bumeID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          instID: z.string().nullish(),
          institutionAbbreviation: z.string().nullish(),
          institutionName: z.string().nullish(),
          kpiProgress: z
            .object({
              actual: z.string(),
              baselinePeriodEnd: z.string().nullish(),
              baselinePeriodStart: z.string().nullish(),
              baselineValue: z.string(),
              displayOption: z.string(),
              offTrack: z.string(),
              onTrack: z.string(),
              referenceDate: z.string().nullish(),
              referenceValue: z.string(),
            })
            .passthrough(),
          metricType: z.string(),
          metrics: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessMetricChild
          ),
          name: z.string(),
          periodValueInDays: z.number().nullish(),
          planID: z.string(),
          programs: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
          ),
          progressLink: z
            .object({
              acplID: z.string().nullable(),
              actiID: z.string().nullable(),
              actionName: z.string().nullable(),
              actionPlanName: z.string().nullable(),
              progID: z.string().nullable(),
              programName: z.string().nullable(),
              projID: z.string().nullable(),
              projectName: z.string().nullable(),
            })
            .partial()
            .passthrough()
            .nullish(),
          projects: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
          ),
          rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
          status: z.string(),
          users: z.array(
            github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
          ),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetric_ =
  z
    .object({
      item: z
        .object({
          bumeID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          instID: z.string().nullish(),
          metricType: z.string(),
          name: z.string(),
          planID: z.string(),
          rule: z.array(github_com_falqondev_cidade360_backend_service_Rule),
          status: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessType_ =
  z
    .object({
      item: z
        .object({
          bstpID: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          isFisicaDefault: z.boolean(),
          label: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_ =
  z
    .object({
      item: z
        .object({
          abbreviation: z.string(),
          address: z
            .object({
              city: z.string(),
              country: z.string(),
              neighborhood: z.string(),
              number: z.string(),
              state: z.string(),
              street: z.string(),
              zipCode: z.string(),
            })
            .passthrough()
            .nullish(),
          buunID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string(),
          inusID: z.number().nullish(),
          name: z.string(),
          phone: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CityEvent_ =
  z
    .object({
      item: z
        .object({
          cievID: z.string(),
          contractingMethods: z.array(z.string()),
          createdAt: z.string(),
          createdBy: z.string(),
          deletedAt: z.string().nullish(),
          endsAt: z.string(),
          evclID: z.string(),
          eventYear: z.number(),
          name: z.string(),
          parentCievID: z.string().nullish(),
          participatesInRegistration: z.boolean(),
          startsAt: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_ =
  z
    .object({
      item: z
        .object({
          arcoID: z.string(),
          attractionName: z.string().nullish(),
          code: z.string(),
          contractCode: z.string(),
          coteID: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          eventName: z.string().nullish(),
          requestedBy: z.string(),
          requesterName: z.string().nullish(),
          status: z.string().nullish(),
          statusAt: z.string().nullish(),
          statusDetail: z.string().nullish(),
          statusHistory: z
            .array(
              github_com_falqondev_cidade360_backend_service_ContractTerminationStatus
            )
            .nullish(),
          statusID: z.string().nullish(),
          supplierName: z.string().nullish(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_ =
  z
    .object({
      item: z
        .object({
          approved: z.boolean(),
          approverName: z.string().nullish(),
          attachments: z.array(z.string()),
          ckreID: z.number().nullish(),
          cpvaID: z.number(),
          createdAt: z.string(),
          cukpID: z.number(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          message: z.string().nullish(),
          reviewedAt: z.string().nullish(),
          reviewedBy: z.string().nullish(),
          targetAt: z.string(),
          userID: z.string(),
          userName: z.string(),
          value: z.string(),
          valueOmitted: z.boolean(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_ =
  z
    .object({
      item: z
        .object({
          acplID: z.string().nullish(),
          actiID: z.string().nullish(),
          actionName: z.string().nullish(),
          actionPlanName: z.string().nullish(),
          createdAt: z.string(),
          cukpID: z.number(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          kpiType: z.string(),
          meunID: z.number().nullish(),
          name: z.string(),
          periodValueDisplay: z.string().nullish(),
          periodValueInDays: z.number().nullish(),
          progID: z.string().nullish(),
          programName: z.string().nullish(),
          projID: z.string().nullish(),
          projectName: z.string().nullish(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidents_ =
  z
    .object({
      item: z
        .object({
          averageResponseTime: z
            .object({
              average: z.string(),
              comparativePercentageLastMonth: z.number(),
              comparativePercentageLastYear: z.number(),
            })
            .passthrough(),
          incidentProgression: z
            .object({
              comparativePercentageLastMonth: z.number(),
              comparativePercentageLastYear: z.number(),
              percentage: z.number(),
            })
            .passthrough(),
          securityIncidents: z
            .object({
              comparativePercentageLastMonth: z.number(),
              comparativePercentageLastYear: z.number(),
              total: z.number(),
            })
            .passthrough(),
          serviceIncidents: z
            .object({
              comparativePercentageLastMonth: z.number(),
              comparativePercentageLastYear: z.number(),
              total: z.number(),
            })
            .passthrough(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardSurvey_ =
  z
    .object({
      item: z
        .object({
          pools: z.number(),
          responses: z.array(
            github_com_falqondev_cidade360_backend_service_DashboardSurveyResponse
          ),
          survIDs: z.array(z.string()),
          totalAnswers: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrder_ =
  z
    .object({
      item: z
        .object({
          MonthTotal: z
            .object({
              comparativePercentageLastYear: z.number(),
              total: z.number(),
            })
            .passthrough(),
          YearTotal: z
            .object({
              comparativePercentageLastYear: z.number(),
              total: z.number(),
            })
            .passthrough(),
          averagePerYear: z.number(),
          total: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          ddteID: z.number(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          formField: z.string(),
          formName: z.string(),
          instID: z.string(),
          institutionName: z.string(),
          name: z.string(),
          placeholder: z.boolean(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          dinaID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          distID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          dinaID: z.number(),
          disuID: z.number(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          diunID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          defaultData: z.unknown(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          doteID: z.string(),
          formSchema: z.unknown(),
          permissionMode: z.string(),
          printSchema: z.unknown(),
          title: z.string(),
          uiSchema: z.unknown(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Document_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          data: z.unknown(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          docuID: z.string(),
          doteID: z.string(),
          formSchema: z.unknown(),
          permissionMode: z.string(),
          printSchema: z.unknown(),
          title: z.string(),
          uiSchema: z.unknown(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_ =
  z
    .object({
      item: z
        .object({
          content: z.string(),
          createdAt: z.string(),
          docuID: z.number(),
          tags: z.array(z.string()),
          title: z.string(),
          videoURL: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Documentation_ =
  z
    .object({
      item: z
        .object({
          content: z.string(),
          createdAt: z.string(),
          docuID: z.number(),
          tags: z.array(z.string()),
          title: z.string(),
          videoURL: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_EventClassification_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          evclID: z.string(),
          name: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          details: z
            .object({
              carrying_capacity: z.string(),
              color: z.string(),
              dimensions: z
                .object({
                  height: z.number(),
                  length: z.number(),
                  width: z.number(),
                })
                .passthrough(),
              engine: z
                .object({ capacity: z.string(), type: z.string() })
                .passthrough(),
              features: z.array(z.string()),
              mileage_km: z.number(),
              purchase_date: z.string(),
              seat_numbers: z.number(),
              serial_number: z.string(),
              type: z.string(),
              warranty: z
                .object({
                  details: z.string().nullish(),
                  expiry_date: z.string(),
                })
                .passthrough(),
            })
            .passthrough(),
          flveID: z.number(),
          instID: z.string(),
          institutionName: z.string().nullish(),
          licensePlate: z.string(),
          make: z.string(),
          model: z.string(),
          registrationNumber: z.string(),
          updatedAt: z.string(),
          year: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          doteID: z.string(),
          fodtID: z.number(),
          formName: z.string(),
          instID: z.string(),
          institutionName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          formName: z.string(),
          fovaID: z.number(),
          instID: z.string(),
          institutionName: z.string(),
          validationSchema: z.unknown(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_GuicheView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          guicID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          iatyID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          indiID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          inenID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          inesID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          innaID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          inorID: z.number(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          inprID: z.number(),
          instID: z.string(),
          institutionName: z.string().nullish(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          irloID: z.number(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string().nullable() })
                .partial()
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          istaID: z.number(),
          name: z.string(),
          reasons: z.array(z.string()).nullish(),
          requiredReason: z.boolean().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          inbnID: z.number(),
          innaID: z.number(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          inprID: z.number(),
          insuID: z.number(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentView_ =
  z
    .object({
      item: z
        .object({
          actionTypeName: z.string(),
          address: z
            .object({
              city: z.string().nullish(),
              complement: z.string().nullish(),
              isVillage: z.boolean(),
              latitude: z.number().nullish(),
              longitude: z.number().nullish(),
              neighborhood: z.string().nullish(),
              number: z.string().nullish(),
              state: z.string().nullish(),
              street: z.string().nullish(),
              zipCode: z.string().nullish(),
            })
            .passthrough()
            .nullish(),
          agentID: z.string().nullish(),
          agentName: z.string(),
          agentRole: z.string().nullish(),
          arrivalAt: z.string().nullish(),
          buunID: z.number().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          depredations: z.array(
            github_com_falqondev_cidade360_backend_service_Depredation
          ),
          description: z.string(),
          details: z
            .object({
              confidential: z.boolean().nullable(),
              protocolNumber: z.string().nullable(),
              relatorAttachment: z.string().nullable(),
              relatorDescription: z.string().nullable(),
              solution: z.string().nullable(),
            })
            .partial()
            .passthrough(),
          dinaID: z.number().nullish(),
          dispatchNature: z.string(),
          dispatchStatus: z.string(),
          dispatchSubnature: z.string(),
          dispatchUnit: z.string(),
          dispatcherName: z.string(),
          distID: z.number().nullish(),
          disuID: z.number().nullish(),
          diunID: z.number().nullish(),
          environmentName: z.string().nullish(),
          establishmentName: z.string().nullish(),
          fieldContact: z
            .object({
              name: z.string().nullable(),
              phone: z.string().nullable(),
            })
            .partial()
            .passthrough(),
          guicID: z.number().nullish(),
          guicheName: z.string(),
          iatyID: z.number().nullish(),
          ifdiID: z.number().nullish(),
          inbnID: z.number().nullish(),
          inciID: z.string(),
          incidentType: z.string(),
          incidentVehicles: z.array(
            github_com_falqondev_cidade360_backend_service_IncidentVehicleView
          ),
          indeID: z.number().nullish(),
          indiID: z.number().nullish(),
          inenID: z.number().nullish(),
          inesID: z.number().nullish(),
          infdID: z.number().nullish(),
          ininID: z.number().nullish(),
          innaID: z.number().nullish(),
          inorID: z.number().nullish(),
          inprID: z.number().nullish(),
          inseID: z.number().nullish(),
          instID: z.string(),
          institutionName: z.string(),
          insuID: z.number().nullish(),
          involvedParties: z.array(
            github_com_falqondev_cidade360_backend_service_InvolvedPartyView
          ),
          istaID: z.number(),
          natureName: z.string(),
          originName: z.string(),
          partnerInstID: z.string().nullish(),
          partnerInstitutionName: z.string(),
          programName: z.string(),
          progressionFromUid: z.string().nullish(),
          publicEquipmentName: z.string(),
          pueqID: z.number().nullish(),
          relatorCode: z.string().nullish(),
          relatorID: z.string().nullish(),
          relatorName: z.string(),
          relatorRole: z.string().nullish(),
          requester: z
            .object({
              email: z.string().nullable(),
              name: z.string().nullable(),
              phone: z.string().nullable(),
              sex: z.string().nullable(),
            })
            .partial()
            .passthrough()
            .nullish(),
          sechID: z.number().nullish(),
          seizedItems: z.array(
            github_com_falqondev_cidade360_backend_service_SeizedItemView
          ),
          serviceChannelName: z.string(),
          servicedAt: z.string().nullish(),
          statusInfo: z
            .object({
              displayOptions: z
                .object({ color: z.string().nullable() })
                .partial()
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          statusName: z.string(),
          statusReason: z.string().nullish(),
          subnatureName: z.string(),
          subprogramName: z.string(),
          uid: z.string(),
          updatedAt: z.string(),
          userID: z.string(),
          workOrderUid: z.string().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InportPlansResult_ =
  z
    .object({
      item: z
        .object({
          importedActionPlans: z.array(z.string()),
          importedActions: z.array(z.string()),
          importedBusinessMetric: z.array(z.number()),
          importedPlans: z.array(z.string()),
          importedPrograms: z.array(z.string()),
          importedProjects: z.array(z.string()),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_ =
  z
    .object({
      item: z
        .object({
          admittedAt: z.string().nullish(),
          buunID: z.number().nullish(),
          code: z.string().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string(),
          inusID: z.number(),
          name: z.string(),
          operationalCode: z.string().nullish(),
          phone: z.string(),
          sex: z.string(),
          updatedAt: z.string(),
          userID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Institution_ =
  z
    .object({
      item: z
        .object({
          abbreviation: z.string(),
          avatar: z.string().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          documentNumber: z.string(),
          documentType: z.string(),
          instID: z.string(),
          name: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_KanbanView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          defaultStatus: z.boolean(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          mostID: z.number(),
          name: z.string(),
          orderIndex: z.number(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          mrvnID: z.string(),
          note: z.string().nullish(),
          spplID: z.string(),
          userID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          formatConfig: z
            .object({
              decimalPlaces: z.number(),
              decimalSep: z.string(),
              prefix: z.string(),
              suffix: z.string(),
              thousandsSep: z.string(),
            })
            .passthrough(),
          meunID: z.number(),
          name: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MySurvey_ =
  z
    .object({
      item: z
        .object({
          activeAt: z.string().nullish(),
          answers: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          descriptionFinished: z.string(),
          displayOptions: z.unknown(),
          drafts: z.number(),
          slug: z.string(),
          survID: z.string(),
          surveyForms: z.array(
            github_com_falqondev_cidade360_backend_service_SurveyForm
          ),
          title: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationConfig_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          module: z.string(),
          noruID: z.string(),
          notificationIntegrations: z
            .object({
              email: z
                .object({
                  active: z.boolean(),
                  password: z.string(),
                  port: z.number(),
                  server: z.string(),
                  user: z.string(),
                })
                .passthrough()
                .nullable(),
              googleChat: z
                .object({
                  accessToken: z.string().nullish(),
                  active: z.boolean(),
                  clientID: z.string(),
                  clientSecret: z.string(),
                  expiresAt: z.string().nullish(),
                  name: z.string(),
                  refreshToken: z.string().nullish(),
                })
                .passthrough()
                .nullable(),
              teams: z
                .object({
                  accessToken: z.string().nullish(),
                  active: z.boolean(),
                  chatID: z.string(),
                  clientID: z.string(),
                  clientSecret: z.string(),
                  expiresAt: z.string().nullish(),
                  graphUserID: z.string().nullish(),
                  refreshToken: z.string().nullish(),
                  tenantID: z.string(),
                })
                .passthrough()
                .nullable(),
              whatsapp: z
                .object({
                  active: z.boolean(),
                  phoneID: z.string(),
                  token: z.string(),
                  wabaID: z.string(),
                })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          rules: z
            .object({
              notifySupplierDocumentExpiring: z.boolean(),
              notifySupplierDocumentStatusChange: z.boolean(),
              notifySupplierPenaltyCreated: z.boolean(),
              notifySupplierRegistryStatusChange: z.boolean(),
              supplierDocumentExpiryRules: z
                .array(
                  github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
                )
                .nullish(),
            })
            .passthrough(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationIntegrationConfig_ =
  z
    .object({
      item: z
        .object({
          email: z
            .object({
              active: z.boolean(),
              password: z.string(),
              port: z.number(),
              server: z.string(),
              user: z.string(),
            })
            .passthrough()
            .nullable(),
          googleChat: z
            .object({
              accessToken: z.string().nullish(),
              active: z.boolean(),
              clientID: z.string(),
              clientSecret: z.string(),
              expiresAt: z.string().nullish(),
              name: z.string(),
              refreshToken: z.string().nullish(),
            })
            .passthrough()
            .nullable(),
          teams: z
            .object({
              accessToken: z.string().nullish(),
              active: z.boolean(),
              chatID: z.string(),
              clientID: z.string(),
              clientSecret: z.string(),
              expiresAt: z.string().nullish(),
              graphUserID: z.string().nullish(),
              refreshToken: z.string().nullish(),
              tenantID: z.string(),
            })
            .passthrough()
            .nullable(),
          whatsapp: z
            .object({
              active: z.boolean(),
              phoneID: z.string(),
              token: z.string(),
              wabaID: z.string(),
            })
            .passthrough()
            .nullable(),
        })
        .partial()
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          data: z.unknown(),
          notiID: z.string(),
          path: z.string(),
          readAt: z.string().nullish(),
          userID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_OneTimeLogin_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          otloID: z.number(),
          token: z.string(),
          userID: z.string(),
          validUntil: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PendingUserTerms_ =
  z
    .object({
      item: z
        .object({
          terms: z.array(
            github_com_falqondev_cidade360_backend_service_PendingTerm
          ),
          userID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          phcoID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanBudgetSummary_ =
  z
    .object({
      item: z
        .object({
          budgetSummary: z.array(
            github_com_falqondev_cidade360_backend_service_BudgetSummary
          ),
          percentageUsage: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanDashboard_ =
  z
    .object({
      item: z
        .object({
          budgetSourceName: z.array(z.string()),
          planID: z.string(),
          resourceTimeline: z.array(
            github_com_falqondev_cidade360_backend_service_ResourceCount
          ),
          totalActual: z.number(),
          totalPredicted: z.number(),
          totalReceived: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanSummary_ =
  z
    .object({
      item: z
        .object({
          resourceSummary: z.array(
            github_com_falqondev_cidade360_backend_service_Resource
          ),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanTaskSummary_ =
  z
    .object({
      item: z
        .object({
          finishedPercentage: z.number(),
          finishedTasks: z.number(),
          openTasks: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          endAt: z.string(),
          instID: z.string(),
          institutionName: z.string(),
          institutionUserName: z.string(),
          inusID: z.number(),
          isDefault: z.boolean(),
          name: z.string(),
          planID: z.string(),
          planUsers: z.array(
            github_com_falqondev_cidade360_backend_service_ProjetcUserView
          ),
          startAt: z.string(),
          thaxID: z.array(z.number()),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_ =
  z
    .object({
      item: z
        .object({
          attachment: z.string().nullish(),
          commID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          message: z.string(),
          progID: z.string(),
          userAvatar: z.string().nullish(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramFinalBudget_ =
  z
    .object({
      item: z
        .object({ progID: z.string(), totalActual: z.number() })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramView_ =
  z
    .object({
      item: z
        .object({
          axes: z.array(z.number()),
          budgets: z.array(
            z
              .object({
                actual: z.string(),
                attachments: z.array(z.string()),
                brtyID: z.number().nullish(),
                budgID: z.string(),
                busoID: z.number(),
                butyID: z.number().nullish(),
                predicted: z.string(),
                rationale: z.string().nullish(),
                received: z.string(),
                referenceYear: z.string().nullish(),
              })
              .passthrough()
          ),
          content: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          instID: z.string().nullish(),
          institutionAbbreviation: z.string().nullish(),
          institutionName: z.string().nullish(),
          institutionUserAvatar: z.string().nullish(),
          institutionUserEmail: z.string().nullish(),
          institutionUserName: z.string().nullish(),
          institutions: z.array(z.string()),
          inusID: z.number().nullish(),
          milestoneCount: z.number(),
          milestoneDoneCount: z.number(),
          mostID: z.number().nullish(),
          mostOrderIndex: z.number(),
          name: z.string(),
          period: z
            .object({
              endAt: z.string(),
              oppeID: z.number(),
              startAt: z.string(),
            })
            .passthrough(),
          planID: z.string(),
          progID: z.string(),
          programUsers: z.array(
            github_com_falqondev_cidade360_backend_service_ProgramUserView
          ),
          projectCount: z.number(),
          projectDoneCount: z.number(),
          statID: z.number(),
          state: z.string(),
          status: z.string(),
          statusInfo: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          statusMessage: z.string(),
          statusOrderIndex: z.number(),
          statusReferenceDate: z.string(),
          thematicAxisInfo: z.array(
            z
              .object({
                displayOptions: z
                  .object({ color: z.string() })
                  .passthrough()
                  .nullish(),
                thaxID: z.number(),
              })
              .passthrough()
          ),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Program_ =
  z
    .object({
      item: z
        .object({
          content: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          inusID: z.number().nullish(),
          name: z.string(),
          planID: z.string(),
          progID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_ =
  z
    .object({
      item: z
        .object({
          attachment: z.string().nullish(),
          commID: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          message: z.string(),
          projID: z.string(),
          userAvatar: z.string().nullish(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectFinalBudget_ =
  z
    .object({
      item: z
        .object({ projID: z.string(), totalActual: z.number() })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_ =
  z
    .object({
      item: z
        .object({
          approvedBy: z.string().nullish(),
          approverName: z.string().nullish(),
          attachments: z.array(z.string()),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          message: z.string(),
          orderIndex: z.number(),
          projID: z.string(),
          projectName: z.string(),
          prstID: z.number(),
          referenceDate: z.string(),
          requestReview: z.boolean(),
          reviewMessage: z.string(),
          statID: z.number(),
          state: z.string(),
          status: z.string(),
          userID: z.string(),
          userName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectView_ =
  z
    .object({
      item: z
        .object({
          actionPlanCount: z.number(),
          actionPlanDoneCount: z.number(),
          attachment: z.string().nullish(),
          axes: z.array(z.number()),
          budgets: z.array(
            z
              .object({
                actual: z.string(),
                attachments: z.array(z.string()),
                brtyID: z.number().nullish(),
                budgID: z.string(),
                busoID: z.number(),
                butyID: z.number().nullish(),
                predicted: z.string(),
                rationale: z.string().nullish(),
                received: z.string(),
                referenceYear: z.string().nullish(),
              })
              .passthrough()
          ),
          content: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          instID: z.string(),
          institutionAbbreviation: z.string(),
          institutionName: z.string(),
          institutionUserAvatar: z.string().nullish(),
          institutionUserEmail: z.string().nullish(),
          institutionUserName: z.string(),
          institutions: z.array(z.string()),
          inusID: z.number(),
          milestoneCount: z.number(),
          milestoneDoneCount: z.number(),
          mostID: z.number().nullish(),
          mostOrderIndex: z.number(),
          name: z.string(),
          period: z
            .object({
              endAt: z.string(),
              oppeID: z.number(),
              startAt: z.string(),
            })
            .passthrough(),
          planID: z.string(),
          progID: z.string().nullish(),
          projID: z.string(),
          projectUsers: z.array(
            github_com_falqondev_cidade360_backend_service_ProjetcUserView
          ),
          status: z
            .object({
              approvedBy: z.string().nullish(),
              approverName: z.string().nullish(),
              attachments: z.array(z.string()),
              deletedAt: z.string().nullish(),
              info: z
                .object({
                  displayOptions: z
                    .object({ color: z.string() })
                    .passthrough()
                    .nullable(),
                })
                .partial()
                .passthrough(),
              message: z.string(),
              orderIndex: z.number(),
              projID: z.string(),
              prstID: z.number(),
              referenceDate: z.string(),
              requestReview: z.boolean(),
              reviewMessage: z.string(),
              statID: z.number(),
              state: z.string(),
              status: z.string(),
              userID: z.string(),
              userName: z.string(),
            })
            .passthrough(),
          thematicAxisInfo: z.array(
            z
              .object({
                displayOptions: z
                  .object({ color: z.string() })
                  .passthrough()
                  .nullish(),
                thaxID: z.number(),
              })
              .passthrough()
          ),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          pueqID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          recoID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          sechID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_StatusView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          defaultStatus: z.boolean(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          name: z.string(),
          orderIndex: z.number(),
          requestReview: z.boolean(),
          slug: z.string(),
          statID: z.number(),
          state: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Status_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          name: z.string(),
          orderIndex: z.number(),
          requestReview: z.boolean(),
          slug: z.string(),
          statID: z.number(),
          state: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_ =
  z
    .object({
      item: z
        .object({
          code: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          name: z.string(),
          subaID: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_ =
  z
    .object({
      item: z
        .object({ bstpID: z.string(), doctID: z.string(), sbtdID: z.string() })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_ =
  z
    .object({
      item: z
        .object({
          clgrID: z.string(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          label: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_ =
  z
    .object({
      item: z
        .object({ clgrID: z.string(), label: z.string(), scsgID: z.string() })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_ =
  z
    .object({
      item: z
        .object({
          clasID: z.string(),
          code: z.string(),
          label: z.string(),
          scsgID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentStatus_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          current: z.boolean(),
          detail: z.string().nullish(),
          reviewedBy: z.string().nullish(),
          spdcID: z.string(),
          spdsID: z.string(),
          status: z.string(),
          validationResult: z.string().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_ =
  z
    .object({
      item: z
        .object({
          deletedAt: z.string().nullish(),
          doctID: z.string(),
          extractionFields: z.array(
            github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
          ),
          label: z.string(),
          validationPrompt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAdminView_ =
  z
    .object({
      item: z
        .object({
          activeAttemptID: z.string().nullish(),
          aiResult: z
            .object({
              fields: z.array(
                github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult
              ),
              reason: z.string(),
              status: z.string(),
            })
            .passthrough()
            .nullish(),
          attempts: z
            .array(
              github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAttempt
            )
            .nullish(),
          completedAt: z.string().nullish(),
          createdAt: z.string(),
          currentStage: z.string().nullish(),
          currentStatus: z.string(),
          currentStatusID: z.string(),
          cycleNumber: z.number(),
          documentID: z.string(),
          enqueuedAt: z.string().nullish(),
          errorCode: z.string().nullish(),
          events: z
            .array(
              github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvent
            )
            .nullish(),
          executionState: z.string(),
          extractedTextBytes: z.number().nullish(),
          failureCount: z.number(),
          lastDiagnostic: z
            .object({
              causes: z.array(z.string()),
              code: z.string(),
              createdAt: z.string(),
              message: z.string(),
              stage: z.string(),
              version: z.number(),
            })
            .passthrough()
            .nullish(),
          model: z.string().nullish(),
          provider: z.string().nullish(),
          resultSource: z.string().nullish(),
          scheduledAt: z.string(),
          startedAt: z.string().nullish(),
          updatedAt: z.string(),
          verificationID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessResult_ =
  z
    .object({
      item: z
        .object({
          alreadyExists: z.boolean(),
          attemptID: z.string(),
          cycle: z.number(),
          verificationID: z.string(),
          workflowID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string().nullish(),
          label: z.string(),
          scopID: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_ =
  z
    .object({
      item: z
        .object({
          complement: z.string().nullish(),
          contractNumber: z.string().nullish(),
          createdAt: z.string(),
          decisionType: z.string().nullish(),
          deletedAt: z.string().nullish(),
          description: z.string().nullish(),
          dom: z.string(),
          endDate: z.string(),
          legalBasis: z.string(),
          legalBasisDescription: z.string().nullish(),
          pennID: z.string(),
          process: z.string(),
          publishingDate: z.string(),
          sanctionType: z.string(),
          scopID: z.string(),
          spplID: z.string(),
          startDate: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_ =
  z
    .object({
      item: z
        .object({
          additionalAddressInfo: z.string().nullish(),
          address: z.string().nullish(),
          addressNumber: z.number().nullish(),
          bankName: z.string().nullish(),
          branch: z.string().nullish(),
          bstpID: z.string().nullish(),
          businessTypeName: z.string().nullish(),
          checkingAccount: z.string().nullish(),
          city: z.string().nullish(),
          cnpj: z.string().nullish(),
          country: z.string().nullish(),
          cpf: z.string().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          email: z.string().nullish(),
          firstName: z.string().nullish(),
          lastName: z.string().nullish(),
          legalName: z.string().nullish(),
          municipalRegistration: z.string().nullish(),
          neighborhood: z.string().nullish(),
          personType: z.string(),
          phone: z.string().nullish(),
          postalCode: z.string().nullish(),
          registryStatus: z.string().nullish(),
          spplID: z.string(),
          state: z.string().nullish(),
          stateRegistration: z.string().nullish(),
          status: z.string(),
          subaID: z.string().nullish(),
          tradeName: z.string().nullish(),
          updatedAt: z.string(),
          userID: z.string().nullish(),
          verifiedEmail: z.boolean().nullish(),
          verifiedPhone: z.boolean().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyFormTemplate_ =
  z
    .object({
      item: z.object({ doteID: z.string(), suftID: z.number() }).passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_ =
  z
    .object({
      item: z
        .object({
          name: z.string(),
          responses: z.array(
            github_com_falqondev_cidade360_backend_service_SurveyResponseData
          ),
          submittedAt: z.string().nullish(),
          sursID: z.string(),
          survID: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseSession_ =
  z
    .object({
      item: z
        .object({
          submittedAt: z.string().nullish(),
          sursID: z.string(),
          survID: z.string(),
          userID: z.string().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponse_ =
  z
    .object({
      item: z
        .object({
          clientDevice: z.string(),
          clientIP: z.string(),
          clientUID: z.string(),
          createdAt: z.string(),
          docuID: z.string(),
          doteID: z.string(),
          metadata: z.unknown(),
          sureID: z.number(),
          sursID: z.string(),
          survID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Survey_ =
  z
    .object({
      item: z
        .object({
          activeAt: z.string().nullish(),
          allowedUsers: z.array(z.string()),
          answers: z.number(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          descriptionFinished: z.string(),
          displayOptions: z.unknown(),
          drafts: z.number(),
          slug: z.string(),
          survID: z.string(),
          surveyForms: z.array(
            github_com_falqondev_cidade360_backend_service_SurveyForm
          ),
          title: z.string(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_TOTPDisableResponse_ =
  z
    .object({
      item: z.object({ disabled: z.boolean() }).passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Term_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          slug: z.string(),
          termID: z.number(),
          title: z.string(),
          type: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          name: z.string(),
          thaxID: z.number(),
          updatedAt: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          ureqID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInfo_ =
  z
    .object({
      item: z.object({ tourCompleted: z.boolean() }).passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInformation_ =
  z
    .object({
      item: z
        .object({
          applID: z.string(),
          authenticationProvider: z.string(),
          avatar: z.string().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          email: z.string().nullish(),
          info: z.object({ tourCompleted: z.boolean() }).passthrough(),
          name: z.string(),
          phone: z.string().nullish(),
          pushTokens: z.array(z.string()).nullish(),
          roles: z.array(z.string()),
          userID: z.string(),
          userInstitutions: z.array(
            github_com_falqondev_cidade360_backend_service_UserInstitutions
          ),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserRoleView_ =
  z
    .object({
      item: z
        .object({ roles: z.array(z.string()), userID: z.string() })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserTerm_ =
  z
    .object({
      item: z
        .object({
          accepted: z.boolean(),
          termID: z.number(),
          userID: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          vupoID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          woclID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string(),
          institutionName: z.string().nullish(),
          name: z.string(),
          woprID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          worfID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          instID: z.string().nullish(),
          institutionName: z.string().nullish(),
          name: z.string(),
          wortID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          info: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          name: z.string(),
          reasons: z.array(z.string()).nullish(),
          requiredReason: z.boolean().nullish(),
          wostID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_ =
  z
    .object({
      item: z
        .object({
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          name: z.string(),
          woprID: z.number(),
          wosuID: z.number(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_ =
  z
    .object({
      item: z
        .object({
          address: z
            .object({
              city: z.string().nullable(),
              complement: z.string().nullable(),
              latitude: z.number().nullable(),
              longitude: z.number().nullable(),
              neighborhood: z.string().nullable(),
              number: z.string().nullable(),
              state: z.string().nullable(),
              street: z.string().nullable(),
              zipCode: z.string().nullable(),
            })
            .partial()
            .passthrough(),
          attachment: z.string(),
          classification: z.string().nullish(),
          createdAt: z.string(),
          deletedAt: z.string().nullish(),
          description: z.string(),
          endAt: z.string().nullish(),
          event: z.string(),
          extraordinaryEffective: z.number(),
          fieldAgents: z.array(
            github_com_falqondev_cidade360_backend_service_FieldAgentInfo
          ),
          generalEffective: z.number(),
          instID: z.string(),
          institutionName: z.string(),
          ordinaryEffective: z.number(),
          planningIdentifier: z.string(),
          programName: z.string(),
          recoID: z.number().nullish(),
          requester: z
            .object({
              documentNumber: z.string().nullable(),
              documentType: z.string().nullable(),
              name: z.string().nullable(),
              phone: z.string().nullable(),
            })
            .partial()
            .passthrough(),
          requesterCompanyName: z.string().nullish(),
          requesterRole: z.string(),
          requesterType: z.string(),
          startAt: z.string().nullish(),
          status: z.string(),
          statusInfo: z
            .object({
              displayOptions: z
                .object({ color: z.string() })
                .passthrough()
                .nullable(),
            })
            .partial()
            .passthrough(),
          statusReason: z.string().nullish(),
          subprogramName: z.string(),
          uid: z.string(),
          updatedAt: z.string(),
          urbanEquipmentName: z.string(),
          ureqID: z.number().nullish(),
          userID: z.string(),
          woclID: z.number().nullish(),
          wodoID: z.number().nullish(),
          wofaID: z.number().nullish(),
          woorID: z.string(),
          woprID: z.number().nullish(),
          worfID: z.number().nullish(),
          wortID: z.number().nullish(),
          wostID: z.number(),
          wosuID: z.number().nullish(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_ =
  z
    .object({
      item: z
        .object({
          applicationID: z.string().nullish(),
          applicationVersion: z.string().nullish(),
          attempts: z.number(),
          authenticatedUser: z.string().nullish(),
          createdAt: z.string(),
          deadline: z.string().nullish(),
          error: z.string().nullish(),
          executorID: z.string().nullish(),
          forkedFrom: z.string().nullish(),
          input: z.string().nullish(),
          output: z.string().nullish(),
          queueName: z.string().nullish(),
          startedAt: z.string().nullish(),
          status: z.string(),
          updatedAt: z.string(),
          workflowID: z.string(),
          workflowName: z.string(),
        })
        .passthrough(),
      kind: z.string(),
      lang: z.string().nullish(),
    })
    .passthrough();
const github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_string_ = z
  .object({ item: z.string(), kind: z.string(), lang: z.string().nullish() })
  .passthrough();

export const schemas = {
  github_com_falqondev_cidade360_backend_service_ActionPlanUserView,
  github_com_falqondev_cidade360_backend_service_ActionPlanView,
  github_com_falqondev_cidade360_backend_service_ActionPlanBudgetForm,
  actionPlanCreate_Body,
  github_com_falqondev_cidade360_backend_service_ActionPlanStatusView,
  actionPlanUpdate_Body,
  actionPlanBudgetApprove_Body,
  github_com_falqondev_cidade360_backend_service_ActionPlanCommentView,
  actionPlanCommentCreate_Body,
  github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory,
  github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory,
  actionPlanStatusUpdate_Body,
  actionPlanStatusApprove_Body,
  github_com_falqondev_cidade360_backend_service_ActionCommentView,
  github_com_falqondev_cidade360_backend_service_ActionView,
  actionCreate_Body,
  github_com_falqondev_cidade360_backend_service_ActionStatusView,
  actionUpdate_Body,
  github_com_falqondev_cidade360_backend_service_ActionPeriodHistory,
  actionStatusApprove_Body,
  github_com_falqondev_cidade360_backend_api_http_admin_server_aiChatMessage,
  aiChatCompletions_Body,
  aiResponses_Body,
  github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails,
  applicationRoleCreate_Body,
  github_com_falqondev_cidade360_backend_service_ArtisticContractDate,
  github_com_falqondev_cidade360_backend_service_ArtisticContractLog,
  github_com_falqondev_cidade360_backend_service_ArtisticContractView,
  github_com_falqondev_cidade360_backend_service_ArtisticContractDateForm,
  artisticContractCreate_Body,
  artisticContractCancel_Body,
  artisticContractProposalDecision_Body,
  github_com_falqondev_cidade360_backend_service_AttractionClippingLink,
  github_com_falqondev_cidade360_backend_service_AttractionDocument,
  github_com_falqondev_cidade360_backend_service_AttractionFiscalValue,
  github_com_falqondev_cidade360_backend_service_AttractionView,
  github_com_falqondev_cidade360_backend_service_AttractionDocumentView,
  attractionUpdateDocumentStatus_Body,
  attractionUpdateStatus_Body,
  github_com_falqondev_cidade360_backend_service_AuditLogView,
  github_com_falqondev_cidade360_backend_service_BudgetResourceType,
  github_com_falqondev_cidade360_backend_service_BudgetSource,
  github_com_falqondev_cidade360_backend_service_BudgetType,
  github_com_falqondev_cidade360_backend_service_BusinessMetricChild,
  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram,
  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject,
  github_com_falqondev_cidade360_backend_service_RuleCustomKPIValue,
  github_com_falqondev_cidade360_backend_service_ReferenceValue,
  github_com_falqondev_cidade360_backend_service_Rule,
  github_com_falqondev_cidade360_backend_service_BusinessMetricUserView,
  github_com_falqondev_cidade360_backend_service_BusinessMetricView,
  businessMetricCreate_Body,
  businessMetricKpiCreate_Body,
  github_com_falqondev_cidade360_backend_service_BusinessType,
  businessTypeCreate_Body,
  github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType,
  github_com_falqondev_cidade360_backend_service_CityEvent,
  cityEventCreate_Body,
  github_com_falqondev_cidade360_backend_service_ContractTerminationStatus,
  github_com_falqondev_cidade360_backend_service_ContractTerminationView,
  github_com_falqondev_cidade360_backend_service_CustomKPIView,
  customKPICreate_Body,
  github_com_falqondev_cidade360_backend_service_CustomKPIValueView,
  customKPIApprove_Body,
  customKPIValuesCreate_Body,
  github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature,
  github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood,
  github_com_falqondev_cidade360_backend_service_BudgetSummary,
  github_com_falqondev_cidade360_backend_service_PlanLatestComments,
  github_com_falqondev_cidade360_backend_service_PlanNextTask,
  github_com_falqondev_cidade360_backend_service_Resource,
  github_com_falqondev_cidade360_backend_service_ResourceCount,
  github_com_falqondev_cidade360_backend_service_DashboardSurveyResponse,
  github_com_falqondev_cidade360_backend_service_WorkOrderByProgram,
  github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram,
  github_com_falqondev_cidade360_backend_service_WorkOrderByStatus,
  github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus,
  github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView,
  defaultDescriptionTextCreate_Body,
  github_com_falqondev_cidade360_backend_service_DispatchNatureView,
  dispatchNatureCreate_Body,
  github_com_falqondev_cidade360_backend_service_DispatchStatusView,
  github_com_falqondev_cidade360_backend_service_DispatchSubnatureView,
  dispatchSubnatureCreate_Body,
  github_com_falqondev_cidade360_backend_service_DispatchUnitView,
  github_com_falqondev_cidade360_backend_service_DocumentTemplate,
  documentTemplateCreate_Body,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentType,
  documentTypeCreate_Body,
  github_com_falqondev_cidade360_backend_service_DocumentationView,
  documentationCreate_Body,
  github_com_falqondev_cidade360_backend_service_Document,
  documentCreate_Body,
  github_com_falqondev_cidade360_backend_service_EventClassification,
  github_com_falqondev_cidade360_backend_service_FleetVehicleView,
  fleetVehicleCreate_Body,
  github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView,
  formDocumentTemplateCreate_Body,
  github_com_falqondev_cidade360_backend_service_FormValidationView,
  formValidationCreate_Body,
  github_com_falqondev_cidade360_backend_service_GuicheView,
  github_com_falqondev_cidade360_backend_service_IncidentActionTypeView,
  github_com_falqondev_cidade360_backend_service_IncidentDispatcherView,
  github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView,
  github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView,
  github_com_falqondev_cidade360_backend_service_IncidentNatureView,
  github_com_falqondev_cidade360_backend_service_IncidentOriginView,
  github_com_falqondev_cidade360_backend_service_IncidentProgramView,
  incidentProgramCreate_Body,
  github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView,
  github_com_falqondev_cidade360_backend_service_IncidentStatus,
  incidentStatusCreate_Body,
  github_com_falqondev_cidade360_backend_service_IncidentSubnatureView,
  incidentSubnatureCreate_Body,
  github_com_falqondev_cidade360_backend_service_IncidentSubprogramView,
  incidentSubprogramCreate_Body,
  github_com_falqondev_cidade360_backend_service_Depredation,
  github_com_falqondev_cidade360_backend_service_IncidentVehicleView,
  github_com_falqondev_cidade360_backend_service_InvolvedPartyView,
  github_com_falqondev_cidade360_backend_service_SeizedItemView,
  github_com_falqondev_cidade360_backend_service_IncidentView,
  github_com_falqondev_cidade360_backend_service_DepredationForm,
  github_com_falqondev_cidade360_backend_service_DocumentForm,
  github_com_falqondev_cidade360_backend_service_IncidentVehicleForm,
  github_com_falqondev_cidade360_backend_service_InvolvedPartyForm,
  github_com_falqondev_cidade360_backend_service_SeizedItemForm,
  incidentCreate_Body,
  github_com_falqondev_cidade360_backend_service_IncidentDocumentView,
  github_com_falqondev_cidade360_backend_service_Institution,
  institutionCreate_Body,
  github_com_falqondev_cidade360_backend_service_BusinessUnit,
  institutionUnitCreate_Body,
  github_com_falqondev_cidade360_backend_service_InstitutionUserView,
  institutionUserCreate_Body,
  institutionUserUpdate_Body,
  github_com_falqondev_cidade360_backend_service_KanbanView,
  kanbanCreate_Body,
  kanbanLinksCreate_Body,
  github_com_falqondev_cidade360_backend_service_KanbanLinkView,
  github_com_falqondev_cidade360_backend_service_MeasurementUnit,
  measurementUnitCreate_Body,
  github_com_falqondev_cidade360_backend_service_MyTaskQueueItem,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule,
  notificationConfigUpdate_Body,
  notificationIntegrationsUpdate_Body,
  github_com_falqondev_cidade360_backend_service_NotificationView,
  notificationRead_Body,
  oneTimeLoginCreate_Body,
  github_com_falqondev_cidade360_backend_service_SupplierPenaltyView,
  github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope,
  penaltyScopeCreate_Body,
  github_com_falqondev_cidade360_backend_service_PhysicalConditionView,
  github_com_falqondev_cidade360_backend_service_ProjetcUserView,
  github_com_falqondev_cidade360_backend_service_PlanView,
  plansCreate_Body,
  github_com_falqondev_cidade360_backend_service_ProgramUserView,
  github_com_falqondev_cidade360_backend_service_ProgramView,
  programCreate_Body,
  github_com_falqondev_cidade360_backend_service_ProgramCommentView,
  github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory,
  github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory,
  github_com_falqondev_cidade360_backend_service_ProgramStatusHistory,
  programStatusUpdate_Body,
  github_com_falqondev_cidade360_backend_service_ProjectView,
  projectCreate_Body,
  github_com_falqondev_cidade360_backend_service_ProjectStatusView,
  projectUpdate_Body,
  github_com_falqondev_cidade360_backend_service_ProjectCommentView,
  github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory,
  github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory,
  projectStatusApprove_Body,
  github_com_falqondev_cidade360_backend_service_PublicEquipmentView,
  github_com_falqondev_cidade360_backend_service_RequestingCompanyView,
  github_com_falqondev_cidade360_backend_service_ServiceChannelView,
  github_com_falqondev_cidade360_backend_service_StatusView,
  statusCreate_Body,
  github_com_falqondev_cidade360_backend_service_StatusLinkView,
  github_com_falqondev_cidade360_backend_service_SupplierBank,
  supplierBankCreate_Body,
  github_com_falqondev_cidade360_backend_service_SupplierClassGroup,
  github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup,
  supplierClassSubGroupCreate_Body,
  github_com_falqondev_cidade360_backend_service_SupplierClass,
  supplierClassCreate_Body,
  github_com_falqondev_cidade360_backend_service_SupplierRegistry,
  github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentView,
  supplierHumanReviewDocument_Body,
  supplierUpdateDocumentStatus_Body,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAttempt,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvent,
  supplierReprocessDocumentVerification_Body,
  github_com_falqondev_cidade360_backend_service_SupplierPenalty,
  supplierPenaltyCreate_Body,
  supplierUpdateStatus_Body,
  github_com_falqondev_cidade360_backend_service_ManagerReviewNote,
  github_com_falqondev_cidade360_backend_service_SurveyResponseData,
  github_com_falqondev_cidade360_backend_service_SurveyResponseListing,
  surveyResponseCreate_Body,
  github_com_falqondev_cidade360_backend_service_SurveyForm,
  github_com_falqondev_cidade360_backend_service_Survey,
  github_com_falqondev_cidade360_backend_service_InputSurveyForm,
  surveyCreate_Body,
  github_com_falqondev_cidade360_backend_service_MySurvey,
  github_com_falqondev_cidade360_backend_service_PendingTerm,
  github_com_falqondev_cidade360_backend_service_Term,
  termCreate_Body,
  github_com_falqondev_cidade360_backend_service_ThematicAxis,
  thematicAxisCreate_Body,
  github_com_falqondev_cidade360_backend_service_UrbanEquipmentView,
  userRoleCreate_Body,
  github_com_falqondev_cidade360_backend_service_PermissionItem,
  github_com_falqondev_cidade360_backend_service_PermissionModule,
  github_com_falqondev_cidade360_backend_service_UserInstitutions,
  github_com_falqondev_cidade360_backend_service_UserInformation,
  github_com_falqondev_cidade360_backend_service_InstitutionUserCreateFormByUser,
  userCreate_Body,
  userUpdate_Body,
  github_com_falqondev_cidade360_backend_service_VulnerablePopulationView,
  github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView,
  github_com_falqondev_cidade360_backend_service_WorkOrderProgramView,
  github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView,
  github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView,
  github_com_falqondev_cidade360_backend_service_WorkOrderStatusView,
  workOrderStatusCreate_Body,
  github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView,
  workOrderSubprogramCreate_Body,
  github_com_falqondev_cidade360_backend_service_FieldAgentInfo,
  github_com_falqondev_cidade360_backend_service_WorkOrderView,
  github_com_falqondev_cidade360_backend_service_FieldAgentUser,
  workOrderCreate_Body,
  github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView,
  github_com_falqondev_cidade360_backend_service_WorkflowExecutionView,
  github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView,
  ApplicationPermissions,
  data,
  github_com_falqondev_cidade360_backend_api_http_admin_server_adminDocumentMediaAuthResponse,
  github_com_falqondev_cidade360_backend_api_http_admin_server_aiChatCompletionRequest,
  github_com_falqondev_cidade360_backend_api_http_admin_server_aiProxyResponse,
  github_com_falqondev_cidade360_backend_api_http_admin_server_aiResponsesRequest,
  github_com_falqondev_cidade360_backend_api_http_admin_server_attractionDocumentMediaAuthResponse,
  github_com_falqondev_cidade360_backend_api_http_admin_server_mediaAuthToken,
  github_com_falqondev_cidade360_backend_service_ActionCommentForm,
  github_com_falqondev_cidade360_backend_service_ActionCreateForm,
  github_com_falqondev_cidade360_backend_service_ActionForm,
  github_com_falqondev_cidade360_backend_service_ActionPeriodForm,
  github_com_falqondev_cidade360_backend_service_ActionPeriodView,
  github_com_falqondev_cidade360_backend_service_ActionPlan,
  github_com_falqondev_cidade360_backend_service_ActionPlanBudgetApproveForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanCommentForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanCreateForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanPeriodForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanPeriodView,
  github_com_falqondev_cidade360_backend_service_ActionPlanStatusApproveForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanStatusForm,
  github_com_falqondev_cidade360_backend_service_ActionPlanStatusInfo,
  github_com_falqondev_cidade360_backend_service_ActionStatusApproveForm,
  github_com_falqondev_cidade360_backend_service_ActionStatusForm,
  github_com_falqondev_cidade360_backend_service_ActionStatusInfo,
  github_com_falqondev_cidade360_backend_service_ApplicationRoleForm,
  github_com_falqondev_cidade360_backend_service_ArtisticContractCancelForm,
  github_com_falqondev_cidade360_backend_service_ArtisticContractForm,
  github_com_falqondev_cidade360_backend_service_ArtisticContractProposalDecisionForm,
  github_com_falqondev_cidade360_backend_service_ArtisticContractRegistrationDecisionForm,
  github_com_falqondev_cidade360_backend_service_ArtisticContractStartReviewForm,
  github_com_falqondev_cidade360_backend_service_ArtisticContractStatus,
  github_com_falqondev_cidade360_backend_service_AttractionDocumentStatus,
  github_com_falqondev_cidade360_backend_service_AttractionDocumentStatusForm,
  github_com_falqondev_cidade360_backend_service_AttractionRegistryStatus,
  github_com_falqondev_cidade360_backend_service_AttractionRegistryStatusForm,
  github_com_falqondev_cidade360_backend_service_AuditLUserInformation,
  github_com_falqondev_cidade360_backend_service_BudgetResourceTypeForm,
  github_com_falqondev_cidade360_backend_service_BudgetRevision,
  github_com_falqondev_cidade360_backend_service_BudgetSourceForm,
  github_com_falqondev_cidade360_backend_service_BudgetTypeForm,
  github_com_falqondev_cidade360_backend_service_BusinessMetric,
  github_com_falqondev_cidade360_backend_service_BusinessMetricForm,
  github_com_falqondev_cidade360_backend_service_BusinessMetricKPIView,
  github_com_falqondev_cidade360_backend_service_BusinessMetricWithCustomKPIForm,
  github_com_falqondev_cidade360_backend_service_BusinessTypeForm,
  github_com_falqondev_cidade360_backend_service_CityEventForm,
  github_com_falqondev_cidade360_backend_service_CreateUserForm,
  github_com_falqondev_cidade360_backend_service_CustomKPIFrom,
  github_com_falqondev_cidade360_backend_service_CustomKPIValueFrom,
  github_com_falqondev_cidade360_backend_service_DashboardIncidents,
  github_com_falqondev_cidade360_backend_service_DashboardSurvey,
  github_com_falqondev_cidade360_backend_service_DashboardWorkOrder,
  github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextForm,
  github_com_falqondev_cidade360_backend_service_Dimensions,
  github_com_falqondev_cidade360_backend_service_DispatchNatureForm,
  github_com_falqondev_cidade360_backend_service_DispatchStatusForm,
  github_com_falqondev_cidade360_backend_service_DispatchSubnatureForm,
  github_com_falqondev_cidade360_backend_service_DispatchSubnatureUpdateForm,
  github_com_falqondev_cidade360_backend_service_DispatchUnitForm,
  github_com_falqondev_cidade360_backend_service_DocumentTemplateForm,
  github_com_falqondev_cidade360_backend_service_Documentation,
  github_com_falqondev_cidade360_backend_service_DocumentationForm,
  github_com_falqondev_cidade360_backend_service_EmailConfig,
  github_com_falqondev_cidade360_backend_service_Engine,
  github_com_falqondev_cidade360_backend_service_EventClassificationForm,
  github_com_falqondev_cidade360_backend_service_FieldAgentContact,
  github_com_falqondev_cidade360_backend_service_FleetVehicleForm,
  github_com_falqondev_cidade360_backend_service_FormDocumentTemplateForm,
  github_com_falqondev_cidade360_backend_service_FormValidationForm,
  github_com_falqondev_cidade360_backend_service_GoogleChatConfig,
  github_com_falqondev_cidade360_backend_service_GuicheForm,
  github_com_falqondev_cidade360_backend_service_IncidentActionTypeForm,
  github_com_falqondev_cidade360_backend_service_IncidentAddress,
  github_com_falqondev_cidade360_backend_service_IncidentCount,
  github_com_falqondev_cidade360_backend_service_IncidentDetails,
  github_com_falqondev_cidade360_backend_service_IncidentDispatcherForm,
  github_com_falqondev_cidade360_backend_service_IncidentEnvironmentForm,
  github_com_falqondev_cidade360_backend_service_IncidentEstablishmentForm,
  github_com_falqondev_cidade360_backend_service_IncidentFieldContact,
  github_com_falqondev_cidade360_backend_service_IncidentForm,
  github_com_falqondev_cidade360_backend_service_IncidentNatureForm,
  github_com_falqondev_cidade360_backend_service_IncidentOriginForm,
  github_com_falqondev_cidade360_backend_service_IncidentProgramForm,
  github_com_falqondev_cidade360_backend_service_IncidentProgression,
  github_com_falqondev_cidade360_backend_service_IncidentRequester,
  github_com_falqondev_cidade360_backend_service_IncidentResponseCount,
  github_com_falqondev_cidade360_backend_service_IncidentResponseLocationForm,
  github_com_falqondev_cidade360_backend_service_IncidentStatusDisplayOptions,
  github_com_falqondev_cidade360_backend_service_IncidentStatusForm,
  github_com_falqondev_cidade360_backend_service_IncidentStatusInfo,
  github_com_falqondev_cidade360_backend_service_IncidentSubnatureForm,
  github_com_falqondev_cidade360_backend_service_IncidentSubprogramForm,
  github_com_falqondev_cidade360_backend_service_IncidentsByNature,
  github_com_falqondev_cidade360_backend_service_IncidentsInNeighborhood,
  github_com_falqondev_cidade360_backend_service_InportPlansResult,
  github_com_falqondev_cidade360_backend_service_InstitutionCreateForm,
  github_com_falqondev_cidade360_backend_service_InstitutionUnitCreateForm,
  github_com_falqondev_cidade360_backend_service_InstitutionUserCreateForm,
  github_com_falqondev_cidade360_backend_service_InstitutionUserUpdateForm,
  github_com_falqondev_cidade360_backend_service_KPIProgress,
  github_com_falqondev_cidade360_backend_service_KPIValueApproveForm,
  github_com_falqondev_cidade360_backend_service_KanbanForm,
  github_com_falqondev_cidade360_backend_service_KanbanReorderForm,
  github_com_falqondev_cidade360_backend_service_ManagerReviewNoteForm,
  github_com_falqondev_cidade360_backend_service_MeasurementUnitForm,
  github_com_falqondev_cidade360_backend_service_MeasurementUnitFormatConfig,
  github_com_falqondev_cidade360_backend_service_NotificationConfig,
  github_com_falqondev_cidade360_backend_service_NotificationConfigForm,
  github_com_falqondev_cidade360_backend_service_NotificationIntegrationConfig,
  github_com_falqondev_cidade360_backend_service_NotificationRulesRules,
  github_com_falqondev_cidade360_backend_service_OneTimeLogin,
  github_com_falqondev_cidade360_backend_service_OneTimeLoginForm,
  github_com_falqondev_cidade360_backend_service_PatchUserInformationForm,
  github_com_falqondev_cidade360_backend_service_PendingUserTerms,
  github_com_falqondev_cidade360_backend_service_PhysicalConditionForm,
  github_com_falqondev_cidade360_backend_service_PlanBudgetSummary,
  github_com_falqondev_cidade360_backend_service_PlanDashboard,
  github_com_falqondev_cidade360_backend_service_PlanForm,
  github_com_falqondev_cidade360_backend_service_PlanSummary,
  github_com_falqondev_cidade360_backend_service_PlanTaskSummary,
  github_com_falqondev_cidade360_backend_service_Program,
  github_com_falqondev_cidade360_backend_service_ProgramCommentForm,
  github_com_falqondev_cidade360_backend_service_ProgramFinalBudget,
  github_com_falqondev_cidade360_backend_service_ProgramForm,
  github_com_falqondev_cidade360_backend_service_ProgramPeriodForm,
  github_com_falqondev_cidade360_backend_service_ProgramPeriodView,
  github_com_falqondev_cidade360_backend_service_ProgramStatusForm,
  github_com_falqondev_cidade360_backend_service_ProgressLink,
  github_com_falqondev_cidade360_backend_service_ProjectCommentForm,
  github_com_falqondev_cidade360_backend_service_ProjectCreateForm,
  github_com_falqondev_cidade360_backend_service_ProjectDisplayOptions,
  github_com_falqondev_cidade360_backend_service_ProjectFinalBudget,
  github_com_falqondev_cidade360_backend_service_ProjectForm,
  github_com_falqondev_cidade360_backend_service_ProjectInfo,
  github_com_falqondev_cidade360_backend_service_ProjectInformations,
  github_com_falqondev_cidade360_backend_service_ProjectPeriodForm,
  github_com_falqondev_cidade360_backend_service_ProjectPeriodView,
  github_com_falqondev_cidade360_backend_service_ProjectStatusApproveForm,
  github_com_falqondev_cidade360_backend_service_ProjectStatusForm,
  github_com_falqondev_cidade360_backend_service_ProjectStatusInfo,
  github_com_falqondev_cidade360_backend_service_PublicEquipmentForm,
  github_com_falqondev_cidade360_backend_service_RequestingCompanyForm,
  github_com_falqondev_cidade360_backend_service_ServiceChannelForm,
  github_com_falqondev_cidade360_backend_service_Status,
  github_com_falqondev_cidade360_backend_service_StatusCreateForm,
  github_com_falqondev_cidade360_backend_service_StatusDisplayOptions,
  github_com_falqondev_cidade360_backend_service_StatusInfo,
  github_com_falqondev_cidade360_backend_service_StatusOrderForm,
  github_com_falqondev_cidade360_backend_service_SupplierBankForm,
  github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentTypeForm,
  github_com_falqondev_cidade360_backend_service_SupplierClassForm,
  github_com_falqondev_cidade360_backend_service_SupplierClassGroupForm,
  github_com_falqondev_cidade360_backend_service_SupplierClassSubGroupForm,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentHumanReviewForm,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentStatus,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentStatusForm,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentTypeForm,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAdminView,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationDiagnostic,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvidence,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationOutcome,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessForm,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessResult,
  github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationResult,
  github_com_falqondev_cidade360_backend_service_SupplierPenaltyForm,
  github_com_falqondev_cidade360_backend_service_SupplierPenaltyScopeForm,
  github_com_falqondev_cidade360_backend_service_SurveyCreateForm,
  github_com_falqondev_cidade360_backend_service_SurveyFormTemplate,
  github_com_falqondev_cidade360_backend_service_SurveyFormTemplateDocumentTemplateForm,
  github_com_falqondev_cidade360_backend_service_SurveyResponse,
  github_com_falqondev_cidade360_backend_service_SurveyResponseDocumentForm,
  github_com_falqondev_cidade360_backend_service_SurveyResponseForm,
  github_com_falqondev_cidade360_backend_service_SurveyResponseSession,
  github_com_falqondev_cidade360_backend_service_TOTPDisableResponse,
  github_com_falqondev_cidade360_backend_service_TeamsConfig,
  github_com_falqondev_cidade360_backend_service_TermForm,
  github_com_falqondev_cidade360_backend_service_ThematicAxisCreateForm,
  github_com_falqondev_cidade360_backend_service_ThematicAxisDisplayOptions,
  github_com_falqondev_cidade360_backend_service_ThematicAxisInfo,
  github_com_falqondev_cidade360_backend_service_UnitAddress,
  github_com_falqondev_cidade360_backend_service_UrbanEquipmentForm,
  github_com_falqondev_cidade360_backend_service_UserInfo,
  github_com_falqondev_cidade360_backend_service_UserRoleForm,
  github_com_falqondev_cidade360_backend_service_UserRoleView,
  github_com_falqondev_cidade360_backend_service_UserTerm,
  github_com_falqondev_cidade360_backend_service_VehicleDetails,
  github_com_falqondev_cidade360_backend_service_VulnerablePopulationForm,
  github_com_falqondev_cidade360_backend_service_Warranty,
  github_com_falqondev_cidade360_backend_service_WhatsAppConfig,
  github_com_falqondev_cidade360_backend_service_WorkOrderAddress,
  github_com_falqondev_cidade360_backend_service_WorkOrderClassificationForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderCount,
  github_com_falqondev_cidade360_backend_service_WorkOrderForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderProgramForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderRequester,
  github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderStatusDisplayOptions,
  github_com_falqondev_cidade360_backend_service_WorkOrderStatusForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderStatusInfo,
  github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramForm,
  github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramUpdateForm,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AuditLogView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetType_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessType_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CityEvent_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Document_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_EventClassification_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_GuicheView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Institution_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanLinkView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MySurvey_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MyTaskQueueItem_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_NotificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PermissionModule_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanLatestComments_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanNextTask_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramStatusHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusLinkView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Survey_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Term_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UserInformation_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView_,
  github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ActionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AttractionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_AuditLogView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BudgetType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CityEvent_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Document_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_EventClassification_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_GuicheView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_IncidentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Institution_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanLinkView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_KanbanView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MySurvey_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_MyTaskQueueItem_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_NotificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PermissionModule_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanLatestComments_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanNextTask_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramStatusHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ProjectView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusLinkView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_StatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Survey_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_Term_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_UserInformation_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_CollectionItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_bool_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_adminDocumentMediaAuthResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_aiProxyResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_attractionDocumentMediaAuthResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_mediaAuthToken_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlan_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionRegistryStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricKPIView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetric_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CityEvent_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidents_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardSurvey_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrder_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Document_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Documentation_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_EventClassification_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_GuicheView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InportPlansResult_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Institution_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_KanbanView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MySurvey_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationConfig_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationIntegrationConfig_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_OneTimeLogin_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PendingUserTerms_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanBudgetSummary_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanDashboard_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanSummary_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanTaskSummary_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramFinalBudget_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Program_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectFinalBudget_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_StatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Status_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAdminView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessResult_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyFormTemplate_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseSession_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Survey_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_TOTPDisableResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Term_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInfo_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInformation_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserRoleView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserTerm_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_interface__,
  github_com_pindamonhangaba_apiculi_endpoint_DataResponse_github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_string_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_bool_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_adminDocumentMediaAuthResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_aiProxyResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_attractionDocumentMediaAuthResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_api_http_admin_server_mediaAuthToken_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionPlan_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ActionView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ArtisticContractView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionDocumentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionRegistryStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_AttractionView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetResourceType_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetSource_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BudgetType_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricKPIView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetricView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessMetric_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessType_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_BusinessUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CityEvent_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ContractTerminationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIValueView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_CustomKPIView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardIncidents_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardSurvey_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DashboardWorkOrder_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DispatchUnitView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentTemplate_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Document_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_DocumentationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Documentation_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_EventClassification_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FleetVehicleView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_FormValidationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_GuicheView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentActionTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentDispatcherView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentNatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentOriginView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubnatureView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_IncidentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InportPlansResult_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_InstitutionUserView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Institution_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_KanbanView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ManagerReviewNote_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MeasurementUnit_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_MySurvey_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationConfig_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationIntegrationConfig_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_NotificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_OneTimeLogin_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PendingUserTerms_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PhysicalConditionView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanBudgetSummary_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanDashboard_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanSummary_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanTaskSummary_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PlanView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramFinalBudget_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Program_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectCommentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectFinalBudget_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ProjectView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_PublicEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_RequestingCompanyView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ServiceChannelView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_StatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Status_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBank_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierClass_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentStatus_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentType_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAdminView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationReprocessResult_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierPenalty_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SupplierRegistry_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyFormTemplate_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseListing_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponseSession_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_SurveyResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Survey_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_TOTPDisableResponse_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_Term_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_ThematicAxis_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UrbanEquipmentView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInfo_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserInformation_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserRoleView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_UserTerm_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_VulnerablePopulationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderProgramView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderStatusView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkOrderView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_github_com_falqondev_cidade360_backend_service_WorkflowExecutionView_,
  github_com_pindamonhangaba_apiculi_endpoint_SingleItemData_string_,
};

const endpoints = makeApi([
  {
    method: "get",
    path: "/api/action-plan",
    alias: "actionPlanList",
    description: `Lists all action plans`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inusID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "groupedLimit",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "statID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "orderDesc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inCharge",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "mostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institution",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "overdue",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "budgetApprovalPendding",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "statusState",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "nearDeadline",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "linkedUserID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "orderAsc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPlanView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/action-plan",
    alias: "actionPlanCreate",
    description: `Create new action plan`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actionCount: z.number(),
                actionPlanUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ActionPlanUserView
                ),
                attachment: z.string().nullish(),
                comments: z.number().nullish(),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doneActionCount: z.number(),
                doneMilestoneCount: z.number(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                revision: z
                  .object({
                    apbrID: z.number(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    budgets: z.array(
                      z
                        .object({
                          actual: z.string(),
                          attachments: z.array(z.string()),
                          brtyID: z.number().nullish(),
                          budgID: z.string(),
                          busoID: z.number(),
                          butyID: z.number().nullish(),
                          predicted: z.string(),
                          rationale: z.string().nullish(),
                          received: z.string(),
                          referenceYear: z.string().nullish(),
                        })
                        .passthrough()
                    ),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    reviewMessage: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                status: z
                  .object({
                    acplID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    apstID: z.number(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/action-plan/:acplID",
    alias: "actionPlanDelete",
    description: `Delete one action plan by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                attachment: z.string().nullish(),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                inusID: z.number(),
                name: z.string(),
                progID: z.string().nullish(),
                projID: z.string(),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/:acplID",
    alias: "actionPlanGet",
    description: `Get one action plan`,
    requestFormat: "json",
    parameters: [
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actionCount: z.number(),
                actionPlanUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ActionPlanUserView
                ),
                attachment: z.string().nullish(),
                comments: z.number().nullish(),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doneActionCount: z.number(),
                doneMilestoneCount: z.number(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                revision: z
                  .object({
                    apbrID: z.number(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    budgets: z.array(
                      z
                        .object({
                          actual: z.string(),
                          attachments: z.array(z.string()),
                          brtyID: z.number().nullish(),
                          budgID: z.string(),
                          busoID: z.number(),
                          butyID: z.number().nullish(),
                          predicted: z.string(),
                          rationale: z.string().nullish(),
                          received: z.string(),
                          referenceYear: z.string().nullish(),
                        })
                        .passthrough()
                    ),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    reviewMessage: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                status: z
                  .object({
                    acplID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    apstID: z.number(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/action-plan/:acplID",
    alias: "actionPlanUpdate",
    description: `Update one action plan`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanUpdate_Body,
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actionCount: z.number(),
                actionPlanUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ActionPlanUserView
                ),
                attachment: z.string().nullish(),
                comments: z.number().nullish(),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doneActionCount: z.number(),
                doneMilestoneCount: z.number(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                revision: z
                  .object({
                    apbrID: z.number(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    budgets: z.array(
                      z
                        .object({
                          actual: z.string(),
                          attachments: z.array(z.string()),
                          brtyID: z.number().nullish(),
                          budgID: z.string(),
                          busoID: z.number(),
                          butyID: z.number().nullish(),
                          predicted: z.string(),
                          rationale: z.string().nullish(),
                          received: z.string(),
                          referenceYear: z.string().nullish(),
                        })
                        .passthrough()
                    ),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    reviewMessage: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                status: z
                  .object({
                    acplID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    apstID: z.number(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/action-plan/:acplID/budget/review",
    alias: "actionPlanBudgetApprove",
    description: `Update one actionPlan budget`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanBudgetApprove_Body,
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actionCount: z.number(),
                actionPlanUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ActionPlanUserView
                ),
                attachment: z.string().nullish(),
                comments: z.number().nullish(),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doneActionCount: z.number(),
                doneMilestoneCount: z.number(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                revision: z
                  .object({
                    apbrID: z.number(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    budgets: z.array(
                      z
                        .object({
                          actual: z.string(),
                          attachments: z.array(z.string()),
                          brtyID: z.number().nullish(),
                          budgID: z.string(),
                          busoID: z.number(),
                          butyID: z.number().nullish(),
                          predicted: z.string(),
                          rationale: z.string().nullish(),
                          received: z.string(),
                          referenceYear: z.string().nullish(),
                        })
                        .passthrough()
                    ),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    reviewMessage: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                status: z
                  .object({
                    acplID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    apstID: z.number(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/:acplID/comment",
    alias: "actionPlanCommentList",
    description: `Lists all action plan comments`,
    requestFormat: "json",
    parameters: [
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "message",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "commID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPlanCommentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/action-plan/:acplID/comment",
    alias: "actionPlanCommentCreate",
    description: `Create new action plan comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanCommentCreate_Body,
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/action-plan/:acplID/comment/:commID",
    alias: "actionPlanCommentDelete",
    description: `Delete one action plan comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/:acplID/comment/:commID",
    alias: "actionPlanCommentGet",
    description: `Get one action plan comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/:acplID/history/budget",
    alias: "actionPlanBudgetHistory",
    description: `Lists all action plan budget`,
    requestFormat: "json",
    parameters: [
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPlanBudgetHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/:acplID/history/period",
    alias: "actionPlanPeriodHistory",
    description: `Lists all action plan periods`,
    requestFormat: "json",
    parameters: [
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPlanPeriodHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/:acplID/history/status",
    alias: "actionPlanStatusHistory",
    description: `Lists all action plan status`,
    requestFormat: "json",
    parameters: [
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPlanStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/action-plan/:acplID/status",
    alias: "actionPlanStatusUpdate",
    description: `Update one actionPlan status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanStatusUpdate_Body,
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actionPlanName: z.string(),
                approvedBy: z.string().nullish(),
                approverName: z.string().nullish(),
                apstID: z.number(),
                attachments: z.array(z.string()),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                message: z.string(),
                orderIndex: z.number(),
                referenceDate: z.string(),
                requestReview: z.boolean(),
                reviewMessage: z.string(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/action-plan/:acplID/status/review",
    alias: "actionPlanStatusApprove",
    description: `Update one actionPlan status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanStatusApprove_Body,
      },
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actionPlanName: z.string(),
                approvedBy: z.string().nullish(),
                approverName: z.string().nullish(),
                apstID: z.number(),
                attachments: z.array(z.string()),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                message: z.string(),
                orderIndex: z.number(),
                referenceDate: z.string(),
                requestReview: z.boolean(),
                reviewMessage: z.string(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action-plan/status/pending-approval",
    alias: "actionPlanStatusList",
    description: `Lists all actionPlan status pending`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPlanStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action/:actiID/comment",
    alias: "actionCommentList",
    description: `Lists all action plan comments`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "commID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "message",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionCommentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/action/:actiID/comment",
    alias: "actionCommentCreate",
    description: `Create new action plan comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanCommentCreate_Body,
      },
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actiID: z.string(),
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/action/:actiID/comment/:commID",
    alias: "actionCommentDelete",
    description: `Delete one action plan comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actiID: z.string(),
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/action/:actiID/comment/:commID",
    alias: "actionCommentGet",
    description: `Get one action plan comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actiID: z.string(),
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/actions",
    alias: "actionList",
    description: `Lists all actions`,
    requestFormat: "json",
    parameters: [
      {
        name: "milestone",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "statusState",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "actiID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "overdue",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "nearDeadline",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "groupedLimit",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "linkedUserID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inusID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institution",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "parentID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "mostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "orderAsc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "statID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "isSubactivity",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "orderDesc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inCharge",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/actions",
    alias: "actionCreate",
    description: `Create new action`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actiID: z.string(),
                actionPlanName: z.string(),
                comments: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                inusID: z.number(),
                milestone: z.boolean(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                parentID: z.string().nullish(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                status: z
                  .object({
                    acstID: z.number(),
                    actiID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                userAvatar: z.string().nullish(),
                userEmail: z.string().nullish(),
                userName: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/actions/:actiID",
    alias: "actionDelete",
    description: `Delete one action by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actiID: z.string(),
                actionPlanName: z.string(),
                comments: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                inusID: z.number(),
                milestone: z.boolean(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                parentID: z.string().nullish(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                status: z
                  .object({
                    acstID: z.number(),
                    actiID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                userAvatar: z.string().nullish(),
                userEmail: z.string().nullish(),
                userName: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/actions/:actiID",
    alias: "actionGet",
    description: `Get one action`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actiID: z.string(),
                actionPlanName: z.string(),
                comments: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                inusID: z.number(),
                milestone: z.boolean(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                parentID: z.string().nullish(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                status: z
                  .object({
                    acstID: z.number(),
                    actiID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                userAvatar: z.string().nullish(),
                userEmail: z.string().nullish(),
                userName: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/actions/:actiID",
    alias: "actionUpdate",
    description: `Update one action`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionUpdate_Body,
      },
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string(),
                actiID: z.string(),
                actionPlanName: z.string(),
                comments: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                inusID: z.number(),
                milestone: z.boolean(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                parentID: z.string().nullish(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullish(),
                    name: z.string(),
                    projID: z.string(),
                  })
                  .passthrough(),
                status: z
                  .object({
                    acstID: z.number(),
                    actiID: z.string(),
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                userAvatar: z.string().nullish(),
                userEmail: z.string().nullish(),
                userName: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/actions/:actiID/history/period",
    alias: "actionPeriodHistory",
    description: `Lists all action periods`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionPeriodHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/actions/:actiID/history/status",
    alias: "actionStatusHistory",
    description: `Lists all action status`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/actions/:actiID/status",
    alias: "actionStatusUpdate",
    description: `Update one action status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanStatusUpdate_Body,
      },
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.number(),
                actiID: z.string(),
                actionName: z.string(),
                approvedBy: z.string().nullish(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                message: z.string(),
                orderIndex: z.number(),
                referenceDate: z.string(),
                requestReview: z.boolean(),
                reviewMessage: z.string(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/actions/:actiID/status/review",
    alias: "actionStatusApprove",
    description: `Update one action status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionStatusApprove_Body,
      },
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.number(),
                actiID: z.string(),
                actionName: z.string(),
                approvedBy: z.string().nullish(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                message: z.string(),
                orderIndex: z.number(),
                referenceDate: z.string(),
                requestReview: z.boolean(),
                reviewMessage: z.string(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/actions/status/pending-approval",
    alias: "actionStatusList",
    description: `Lists all action status pending`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "actiID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ActionStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/ai/openai/v1/chat/completions",
    alias: "aiChatCompletions",
    description: `Proxy OpenAI-compatible Chat Completions requests through the authenticated admin API`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: aiChatCompletions_Body,
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({}).partial().passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/ai/openai/v1/responses",
    alias: "aiResponses",
    description: `Proxy OpenAI Responses requests through the authenticated admin API`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: aiResponses_Body,
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({}).partial().passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/application-roles",
    alias: "applicationRoleList",
    description: `Lists all roles available`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "aproID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ApplicationRoleDetails
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/application-roles",
    alias: "applicationRoleCreate",
    description: `Creates a new application role`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: applicationRoleCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                aproID: z.string(),
                assignmentRules: z.array(z.string()),
                description: z.string(),
                name: z.string(),
                roles: z.array(z.string()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/application-roles/:aproID",
    alias: "applicationRoleDelete",
    description: `Deletes an application role`,
    requestFormat: "json",
    parameters: [
      {
        name: "aproID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z.object({}).partial().passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/application-roles/:aproID",
    alias: "applicationRoleGet",
    description: `Gets one application role by aproID`,
    requestFormat: "json",
    parameters: [
      {
        name: "aproID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                aproID: z.string(),
                assignmentRules: z.array(z.string()),
                description: z.string(),
                name: z.string(),
                roles: z.array(z.string()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/application-roles/:aproID",
    alias: "applicationRoleUpdate",
    description: `Updates an application role`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: applicationRoleCreate_Body,
      },
      {
        name: "aproID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                aproID: z.string(),
                assignmentRules: z.array(z.string()),
                description: z.string(),
                name: z.string(),
                roles: z.array(z.string()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/artistic-contracts",
    alias: "artisticContractList",
    description: `Lists all artistic contracts`,
    requestFormat: "json",
    parameters: [
      {
        name: "cievID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "attrID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ArtisticContractView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/artistic-contracts",
    alias: "artisticContractCreate",
    description: `Create one artistic contract`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: artisticContractCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                agency: z.string(),
                arcoID: z.string(),
                attrID: z.string(),
                attractionName: z.string().nullish(),
                attractionStatus: z.string().nullish(),
                blockingItems: z.array(z.string()).nullish(),
                cievID: z.string(),
                code: z.string(),
                createdAt: z.string(),
                createdBy: z.string(),
                dates: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractDate
                  )
                  .nullish(),
                deadlineExpired: z.boolean(),
                deletedAt: z.string().nullish(),
                eventName: z.string().nullish(),
                finalizationDeadline: z.string(),
                logs: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractLog
                  )
                  .nullish(),
                requestedAmount: z.string(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                supplierStatus: z.string().nullish(),
                updatedAt: z.string(),
                venue: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/artistic-contracts/:arcoID",
    alias: "artisticContractGet",
    description: `Get one artistic contract`,
    requestFormat: "json",
    parameters: [
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                agency: z.string(),
                arcoID: z.string(),
                attrID: z.string(),
                attractionName: z.string().nullish(),
                attractionStatus: z.string().nullish(),
                blockingItems: z.array(z.string()).nullish(),
                cievID: z.string(),
                code: z.string(),
                createdAt: z.string(),
                createdBy: z.string(),
                dates: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractDate
                  )
                  .nullish(),
                deadlineExpired: z.boolean(),
                deletedAt: z.string().nullish(),
                eventName: z.string().nullish(),
                finalizationDeadline: z.string(),
                logs: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractLog
                  )
                  .nullish(),
                requestedAmount: z.string(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                supplierStatus: z.string().nullish(),
                updatedAt: z.string(),
                venue: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/artistic-contracts/:arcoID",
    alias: "artisticContractUpdate",
    description: `Update one artistic contract`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: artisticContractCreate_Body,
      },
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                agency: z.string(),
                arcoID: z.string(),
                attrID: z.string(),
                attractionName: z.string().nullish(),
                attractionStatus: z.string().nullish(),
                blockingItems: z.array(z.string()).nullish(),
                cievID: z.string(),
                code: z.string(),
                createdAt: z.string(),
                createdBy: z.string(),
                dates: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractDate
                  )
                  .nullish(),
                deadlineExpired: z.boolean(),
                deletedAt: z.string().nullish(),
                eventName: z.string().nullish(),
                finalizationDeadline: z.string(),
                logs: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ArtisticContractLog
                  )
                  .nullish(),
                requestedAmount: z.string(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                supplierStatus: z.string().nullish(),
                updatedAt: z.string(),
                venue: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/artistic-contracts/:arcoID/cancel",
    alias: "artisticContractCancel",
    description: `Cancel an artistic contract`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: artisticContractCancel_Body,
      },
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.string(),
                arcoID: z.string(),
                changedBy: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/artistic-contracts/:arcoID/proposal-decision",
    alias: "artisticContractProposalDecision",
    description: `Decide artistic contract proposal`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: artisticContractProposalDecision_Body,
      },
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.string(),
                arcoID: z.string(),
                changedBy: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/artistic-contracts/:arcoID/registration-decision",
    alias: "artisticContractRegistrationDecision",
    description: `Decide artistic contract registration`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: artisticContractProposalDecision_Body,
      },
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.string(),
                arcoID: z.string(),
                changedBy: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/artistic-contracts/:arcoID/start-review",
    alias: "artisticContractStartReview",
    description: `Start artistic contract review`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ expectedStatusID: z.string() }).passthrough(),
      },
      {
        name: "arcoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acstID: z.string(),
                arcoID: z.string(),
                changedBy: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/attractions",
    alias: "attractionList",
    description: `Lists all attractions`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "attrID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_AttractionView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/attractions/:attrID",
    alias: "attractionGet",
    description: `Get one attraction`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attrID: z.string(),
                attractionType: z.string(),
                clippingLinks: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionClippingLink
                  )
                  .nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documents: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionDocument
                  )
                  .nullish(),
                fiscalAverage: z.string(),
                fiscalValues: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_AttractionFiscalValue
                  )
                  .nullish(),
                missingDocumentTypes: z.array(z.string()).nullish(),
                name: z.string(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusID: z.string().nullish(),
                supplierDocument: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
                videoUrl: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/attractions/:attrID/documents",
    alias: "attractionListDocuments",
    description: `List documents for an attraction`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "documentType",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_AttractionDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/attractions/:attrID/documents/:atdoID/media-auth",
    alias: "attractionGetDocumentMediaAuth",
    description: `Get media auth for an attraction document`,
    requestFormat: "json",
    parameters: [
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "atdoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/attractions/:attrID/documents/:atdoID/status",
    alias: "attractionUpdateDocumentStatus",
    description: `Update an attraction document status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: attractionUpdateDocumentStatus_Body,
      },
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "atdoID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                adstID: z.string(),
                atdoID: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/attractions/:attrID/registry-status",
    alias: "attractionUpdateStatus",
    description: `Approve or reject an attraction`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: attractionUpdateStatus_Body,
      },
      {
        name: "attrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                arstID: z.string(),
                attrID: z.string(),
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/audit-logs",
    alias: "auditLogsList",
    description: `Lists all logs`,
    requestFormat: "json",
    parameters: [
      {
        name: "resource",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "userEmail",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "action",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_AuditLogView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/audit-logs/download",
    alias: "auditLogsDownload",
    description: `Get logs export file`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "action",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userEmail",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "resource",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/auth-media",
    alias: "mediaAuth",
    description: `Authenticate media server access`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z
          .object({ mediaURL: z.string().nullable() })
          .partial()
          .passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/budget-resource-type",
    alias: "budgetResourceTypeList",
    description: `Lists all budget resource types`,
    requestFormat: "json",
    parameters: [
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "brtyIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BudgetResourceType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/budget-resource-type",
    alias: "budgetResourceTypeCreate",
    description: `Create one budget resource type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                brtyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/budget-resource-type/:brtyID",
    alias: "budgetResourceTypeDelete",
    description: `Delete one budget resource type by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "brtyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                brtyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/budget-resource-type/:brtyID",
    alias: "budgetResourceTypeGet",
    description: `Get one budget resource type`,
    requestFormat: "json",
    parameters: [
      {
        name: "brtyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                brtyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/budget-resource-type/:brtyID",
    alias: "budgetResourceTypeUpdate",
    description: `Update budget resource type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "brtyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                brtyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/budget-source",
    alias: "budgetSourceList",
    description: `Lists all budget sources`,
    requestFormat: "json",
    parameters: [
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "busoIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BudgetSource
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/budget-source",
    alias: "budgetSourceCreate",
    description: `Create one budget source`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                busoID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/budget-source/:busoID",
    alias: "budgetSourceDelete",
    description: `Delete one budget source by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "busoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                busoID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/budget-source/:busoID",
    alias: "budgetSourceGet",
    description: `Get one budget source`,
    requestFormat: "json",
    parameters: [
      {
        name: "busoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                busoID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/budget-source/:busoID",
    alias: "budgetSourceUpdate",
    description: `Update budget source`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "busoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                busoID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/budget-type",
    alias: "budgetTypeList",
    description: `Lists all budget types`,
    requestFormat: "json",
    parameters: [
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "butyIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BudgetType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/budget-type",
    alias: "budgetTypeCreate",
    description: `Create one budget type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                butyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/budget-type/:butyID",
    alias: "budgetTypeDelete",
    description: `Delete one budget type by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "butyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                butyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/budget-type/:butyID",
    alias: "budgetTypeGet",
    description: `Get one budget type`,
    requestFormat: "json",
    parameters: [
      {
        name: "butyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                butyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/budget-type/:butyID",
    alias: "budgetTypeUpdate",
    description: `Update budget type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "butyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                butyID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/business-metric",
    alias: "businessMetricList",
    description: `Lists all business metrics`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "metricType",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institution",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "orderDesc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "relatedBumeID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "inusID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "inCharge",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "orderAsc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "bumeID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BusinessMetricView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/business-metric",
    alias: "businessMetricCreate",
    description: `Create one business metric`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: businessMetricCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bumeID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                kpiProgress: z
                  .object({
                    actual: z.string(),
                    baselinePeriodEnd: z.string().nullish(),
                    baselinePeriodStart: z.string().nullish(),
                    baselineValue: z.string(),
                    displayOption: z.string(),
                    offTrack: z.string(),
                    onTrack: z.string(),
                    referenceDate: z.string().nullish(),
                    referenceValue: z.string(),
                  })
                  .passthrough(),
                metricType: z.string(),
                metrics: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricChild
                ),
                name: z.string(),
                periodValueInDays: z.number().nullish(),
                planID: z.string(),
                programs: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
                ),
                progressLink: z
                  .object({
                    acplID: z.string().nullable(),
                    actiID: z.string().nullable(),
                    actionName: z.string().nullable(),
                    actionPlanName: z.string().nullable(),
                    progID: z.string().nullable(),
                    programName: z.string().nullable(),
                    projID: z.string().nullable(),
                    projectName: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                projects: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
                ),
                rule: z.array(
                  github_com_falqondev_cidade360_backend_service_Rule
                ),
                status: z.string(),
                users: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/business-metric/:bumeID",
    alias: "businessMetricDelete",
    description: `Delete one business metric by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "bumeID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bumeID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                metricType: z.string(),
                name: z.string(),
                planID: z.string(),
                rule: z.array(
                  github_com_falqondev_cidade360_backend_service_Rule
                ),
                status: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/business-metric/:bumeID",
    alias: "businessMetricGet",
    description: `Get one business metric`,
    requestFormat: "json",
    parameters: [
      {
        name: "bumeID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bumeID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                kpiProgress: z
                  .object({
                    actual: z.string(),
                    baselinePeriodEnd: z.string().nullish(),
                    baselinePeriodStart: z.string().nullish(),
                    baselineValue: z.string(),
                    displayOption: z.string(),
                    offTrack: z.string(),
                    onTrack: z.string(),
                    referenceDate: z.string().nullish(),
                    referenceValue: z.string(),
                  })
                  .passthrough(),
                metricType: z.string(),
                metrics: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricChild
                ),
                name: z.string(),
                periodValueInDays: z.number().nullish(),
                planID: z.string(),
                programs: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
                ),
                progressLink: z
                  .object({
                    acplID: z.string().nullable(),
                    actiID: z.string().nullable(),
                    actionName: z.string().nullable(),
                    actionPlanName: z.string().nullable(),
                    progID: z.string().nullable(),
                    programName: z.string().nullable(),
                    projID: z.string().nullable(),
                    projectName: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                projects: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
                ),
                rule: z.array(
                  github_com_falqondev_cidade360_backend_service_Rule
                ),
                status: z.string(),
                users: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/business-metric/:bumeID",
    alias: "businessMetricUpdate",
    description: `Update business metric`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: businessMetricCreate_Body,
      },
      {
        name: "bumeID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bumeID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                kpiProgress: z
                  .object({
                    actual: z.string(),
                    baselinePeriodEnd: z.string().nullish(),
                    baselinePeriodStart: z.string().nullish(),
                    baselineValue: z.string(),
                    displayOption: z.string(),
                    offTrack: z.string(),
                    onTrack: z.string(),
                    referenceDate: z.string().nullish(),
                    referenceValue: z.string(),
                  })
                  .passthrough(),
                metricType: z.string(),
                metrics: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricChild
                ),
                name: z.string(),
                periodValueInDays: z.number().nullish(),
                planID: z.string(),
                programs: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
                ),
                progressLink: z
                  .object({
                    acplID: z.string().nullable(),
                    actiID: z.string().nullable(),
                    actionName: z.string().nullable(),
                    actionPlanName: z.string().nullable(),
                    progID: z.string().nullable(),
                    programName: z.string().nullable(),
                    projID: z.string().nullable(),
                    projectName: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                projects: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
                ),
                rule: z.array(
                  github_com_falqondev_cidade360_backend_service_Rule
                ),
                status: z.string(),
                users: z.array(
                  github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/business-metric/:bumeID/kpi",
    alias: "businessMetricKpiUpdate",
    description: `Update business metric with custom KPI`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: businessMetricKpiCreate_Body,
      },
      {
        name: "bumeID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                businessMetric: z
                  .object({
                    bumeID: z.number(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    description: z.string(),
                    instID: z.string().nullish(),
                    institutionAbbreviation: z.string().nullish(),
                    institutionName: z.string().nullish(),
                    kpiProgress: z
                      .object({
                        actual: z.string(),
                        baselinePeriodEnd: z.string().nullish(),
                        baselinePeriodStart: z.string().nullish(),
                        baselineValue: z.string(),
                        displayOption: z.string(),
                        offTrack: z.string(),
                        onTrack: z.string(),
                        referenceDate: z.string().nullish(),
                        referenceValue: z.string(),
                      })
                      .passthrough(),
                    metricType: z.string(),
                    metrics: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricChild
                    ),
                    name: z.string(),
                    periodValueInDays: z.number().nullish(),
                    planID: z.string(),
                    programs: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
                    ),
                    progressLink: z
                      .object({
                        acplID: z.string().nullable(),
                        actiID: z.string().nullable(),
                        actionName: z.string().nullable(),
                        actionPlanName: z.string().nullable(),
                        progID: z.string().nullable(),
                        programName: z.string().nullable(),
                        projID: z.string().nullable(),
                        projectName: z.string().nullable(),
                      })
                      .partial()
                      .passthrough()
                      .nullish(),
                    projects: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
                    ),
                    rule: z.array(
                      github_com_falqondev_cidade360_backend_service_Rule
                    ),
                    status: z.string(),
                    users: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
                    ),
                  })
                  .passthrough(),
                customKPI: z
                  .object({
                    acplID: z.string().nullish(),
                    actiID: z.string().nullish(),
                    actionName: z.string().nullish(),
                    actionPlanName: z.string().nullish(),
                    createdAt: z.string(),
                    cukpID: z.number(),
                    deletedAt: z.string().nullish(),
                    description: z.string(),
                    kpiType: z.string(),
                    meunID: z.number().nullish(),
                    name: z.string(),
                    periodValueDisplay: z.string().nullish(),
                    periodValueInDays: z.number().nullish(),
                    progID: z.string().nullish(),
                    programName: z.string().nullish(),
                    projID: z.string().nullish(),
                    projectName: z.string().nullish(),
                    updatedAt: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/business-metric/kpi",
    alias: "businessMetricKpiCreate",
    description: `Create one business metric with custom KPI`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: businessMetricKpiCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                businessMetric: z
                  .object({
                    bumeID: z.number(),
                    createdAt: z.string(),
                    deletedAt: z.string().nullish(),
                    description: z.string(),
                    instID: z.string().nullish(),
                    institutionAbbreviation: z.string().nullish(),
                    institutionName: z.string().nullish(),
                    kpiProgress: z
                      .object({
                        actual: z.string(),
                        baselinePeriodEnd: z.string().nullish(),
                        baselinePeriodStart: z.string().nullish(),
                        baselineValue: z.string(),
                        displayOption: z.string(),
                        offTrack: z.string(),
                        onTrack: z.string(),
                        referenceDate: z.string().nullish(),
                        referenceValue: z.string(),
                      })
                      .passthrough(),
                    metricType: z.string(),
                    metrics: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricChild
                    ),
                    name: z.string(),
                    periodValueInDays: z.number().nullish(),
                    planID: z.string(),
                    programs: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProgram
                    ),
                    progressLink: z
                      .object({
                        acplID: z.string().nullable(),
                        actiID: z.string().nullable(),
                        actionName: z.string().nullable(),
                        actionPlanName: z.string().nullable(),
                        progID: z.string().nullable(),
                        programName: z.string().nullable(),
                        projID: z.string().nullable(),
                        projectName: z.string().nullable(),
                      })
                      .partial()
                      .passthrough()
                      .nullish(),
                    projects: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricRelatedProject
                    ),
                    rule: z.array(
                      github_com_falqondev_cidade360_backend_service_Rule
                    ),
                    status: z.string(),
                    users: z.array(
                      github_com_falqondev_cidade360_backend_service_BusinessMetricUserView
                    ),
                  })
                  .passthrough(),
                customKPI: z
                  .object({
                    acplID: z.string().nullish(),
                    actiID: z.string().nullish(),
                    actionName: z.string().nullish(),
                    actionPlanName: z.string().nullish(),
                    createdAt: z.string(),
                    cukpID: z.number(),
                    deletedAt: z.string().nullish(),
                    description: z.string(),
                    kpiType: z.string(),
                    meunID: z.number().nullish(),
                    name: z.string(),
                    periodValueDisplay: z.string().nullish(),
                    periodValueInDays: z.number().nullish(),
                    progID: z.string().nullish(),
                    programName: z.string().nullish(),
                    projID: z.string().nullish(),
                    projectName: z.string().nullish(),
                    updatedAt: z.string(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/business-types",
    alias: "businessTypeList",
    description: `Lists all business types`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "bstpID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BusinessType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/business-types",
    alias: "businessTypeCreate",
    description: `Create one business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: businessTypeCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bstpID: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                isFisicaDefault: z.boolean(),
                label: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/business-types/:bstpID",
    alias: "businessTypeDelete",
    description: `Delete one business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "bstpID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bstpID: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                isFisicaDefault: z.boolean(),
                label: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/business-types/:bstpID",
    alias: "businessTypeUpdate",
    description: `Update one business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: businessTypeCreate_Body,
      },
      {
        name: "bstpID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bstpID: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                isFisicaDefault: z.boolean(),
                label: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/business-types/:bstpID/document-types",
    alias: "businessTypeDocumentTypeList",
    description: `List document types linked to a supplier business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "bstpID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "doctID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierBusinessTypeDocumentType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/business-types/:bstpID/document-types",
    alias: "businessTypeDocumentTypeCreate",
    description: `Link a document type to a supplier business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ doctID: z.string() }).passthrough(),
      },
      {
        name: "bstpID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bstpID: z.string(),
                doctID: z.string(),
                sbtdID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/business-types/:bstpID/document-types/:sbtdID",
    alias: "businessTypeDocumentTypeDelete",
    description: `Unlink a document type from a supplier business type`,
    requestFormat: "json",
    parameters: [
      {
        name: "sbtdID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "bstpID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                bstpID: z.string(),
                doctID: z.string(),
                sbtdID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/city-events",
    alias: "cityEventList",
    description: `Lists all city events`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "cievID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "evclID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "eventYear",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_CityEvent
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/city-events",
    alias: "cityEventCreate",
    description: `Create one city event`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: cityEventCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                cievID: z.string(),
                contractingMethods: z.array(z.string()),
                createdAt: z.string(),
                createdBy: z.string(),
                deletedAt: z.string().nullish(),
                endsAt: z.string(),
                evclID: z.string(),
                eventYear: z.number(),
                name: z.string(),
                parentCievID: z.string().nullish(),
                participatesInRegistration: z.boolean(),
                startsAt: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/city-events/:cievID",
    alias: "cityEventDelete",
    description: `Delete one city event`,
    requestFormat: "json",
    parameters: [
      {
        name: "cievID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                cievID: z.string(),
                contractingMethods: z.array(z.string()),
                createdAt: z.string(),
                createdBy: z.string(),
                deletedAt: z.string().nullish(),
                endsAt: z.string(),
                evclID: z.string(),
                eventYear: z.number(),
                name: z.string(),
                parentCievID: z.string().nullish(),
                participatesInRegistration: z.boolean(),
                startsAt: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/city-events/:cievID",
    alias: "cityEventGet",
    description: `Gets one city event`,
    requestFormat: "json",
    parameters: [
      {
        name: "cievID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                cievID: z.string(),
                contractingMethods: z.array(z.string()),
                createdAt: z.string(),
                createdBy: z.string(),
                deletedAt: z.string().nullish(),
                endsAt: z.string(),
                evclID: z.string(),
                eventYear: z.number(),
                name: z.string(),
                parentCievID: z.string().nullish(),
                participatesInRegistration: z.boolean(),
                startsAt: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/city-events/:cievID",
    alias: "cityEventUpdate",
    description: `Update one city event`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: cityEventCreate_Body,
      },
      {
        name: "cievID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                cievID: z.string(),
                contractingMethods: z.array(z.string()),
                createdAt: z.string(),
                createdBy: z.string(),
                deletedAt: z.string().nullish(),
                endsAt: z.string(),
                evclID: z.string(),
                eventYear: z.number(),
                name: z.string(),
                parentCievID: z.string().nullish(),
                participatesInRegistration: z.boolean(),
                startsAt: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/contract-terminations",
    alias: "contractTerminationList",
    description: `Lists all contract terminations`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "coteID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "arcoID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ContractTerminationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/contract-terminations/:coteID",
    alias: "contractTerminationGet",
    description: `Get one contract termination`,
    requestFormat: "json",
    parameters: [
      {
        name: "coteID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                arcoID: z.string(),
                attractionName: z.string().nullish(),
                code: z.string(),
                contractCode: z.string(),
                coteID: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                eventName: z.string().nullish(),
                requestedBy: z.string(),
                requesterName: z.string().nullish(),
                status: z.string().nullish(),
                statusAt: z.string().nullish(),
                statusDetail: z.string().nullish(),
                statusHistory: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_ContractTerminationStatus
                  )
                  .nullish(),
                statusID: z.string().nullish(),
                supplierName: z.string().nullish(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/custom-kpi",
    alias: "customKPIList",
    description: `Lists all custom KPI`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "kpiType",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "cukpID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_CustomKPIView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/custom-kpi",
    alias: "customKPICreate",
    description: `Create new custom KPI`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: customKPICreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string().nullish(),
                actiID: z.string().nullish(),
                actionName: z.string().nullish(),
                actionPlanName: z.string().nullish(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                kpiType: z.string(),
                meunID: z.number().nullish(),
                name: z.string(),
                periodValueDisplay: z.string().nullish(),
                periodValueInDays: z.number().nullish(),
                progID: z.string().nullish(),
                programName: z.string().nullish(),
                projID: z.string().nullish(),
                projectName: z.string().nullish(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/custom-kpi/:cukpID",
    alias: "customKPIDelete",
    description: `Delete one program by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string().nullish(),
                actiID: z.string().nullish(),
                actionName: z.string().nullish(),
                actionPlanName: z.string().nullish(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                kpiType: z.string(),
                meunID: z.number().nullish(),
                name: z.string(),
                periodValueDisplay: z.string().nullish(),
                periodValueInDays: z.number().nullish(),
                progID: z.string().nullish(),
                programName: z.string().nullish(),
                projID: z.string().nullish(),
                projectName: z.string().nullish(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/custom-kpi/:cukpID",
    alias: "customKPIGet",
    description: `Get one custom KPI`,
    requestFormat: "json",
    parameters: [
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string().nullish(),
                actiID: z.string().nullish(),
                actionName: z.string().nullish(),
                actionPlanName: z.string().nullish(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                kpiType: z.string(),
                meunID: z.number().nullish(),
                name: z.string(),
                periodValueDisplay: z.string().nullish(),
                periodValueInDays: z.number().nullish(),
                progID: z.string().nullish(),
                programName: z.string().nullish(),
                projID: z.string().nullish(),
                projectName: z.string().nullish(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/custom-kpi/:cukpID",
    alias: "customKPIUpdate",
    description: `Update one custom KPI`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: customKPICreate_Body,
      },
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                acplID: z.string().nullish(),
                actiID: z.string().nullish(),
                actionName: z.string().nullish(),
                actionPlanName: z.string().nullish(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                kpiType: z.string(),
                meunID: z.number().nullish(),
                name: z.string(),
                periodValueDisplay: z.string().nullish(),
                periodValueInDays: z.number().nullish(),
                progID: z.string().nullish(),
                programName: z.string().nullish(),
                projID: z.string().nullish(),
                projectName: z.string().nullish(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/custom-kpi/:cukpID/review",
    alias: "customKPIApprove",
    description: `Update custom kpi values`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: customKPIApprove_Body,
      },
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                approved: z.boolean(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                ckreID: z.number().nullish(),
                cpvaID: z.number(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                message: z.string().nullish(),
                reviewedAt: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                targetAt: z.string(),
                userID: z.string(),
                userName: z.string(),
                value: z.string(),
                valueOmitted: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/custom-kpi/:cukpID/values",
    alias: "customKPIValuesList",
    description: `Lists all custom KPI values`,
    requestFormat: "json",
    parameters: [
      {
        name: "cukpID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "cpvaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_CustomKPIValueView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/custom-kpi/:cukpID/values",
    alias: "customKPIValuesCreate",
    description: `Create new custom KPI value`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: customKPIValuesCreate_Body,
      },
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                approved: z.boolean(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                ckreID: z.number().nullish(),
                cpvaID: z.number(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                message: z.string().nullish(),
                reviewedAt: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                targetAt: z.string(),
                userID: z.string(),
                userName: z.string(),
                value: z.string(),
                valueOmitted: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/custom-kpi/:cukpID/values/:cpvaID",
    alias: "customKPIValuesDelete",
    description: `Delete one custom KPI value`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "cpvaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                approved: z.boolean(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                ckreID: z.number().nullish(),
                cpvaID: z.number(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                message: z.string().nullish(),
                reviewedAt: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                targetAt: z.string(),
                userID: z.string(),
                userName: z.string(),
                value: z.string(),
                valueOmitted: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/custom-kpi/:cukpID/values/:cpvaID",
    alias: "customKPIValuesGet",
    description: `Get one custom KPI values`,
    requestFormat: "json",
    parameters: [
      {
        name: "cpvaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "cukpID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                approved: z.boolean(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                ckreID: z.number().nullish(),
                cpvaID: z.number(),
                createdAt: z.string(),
                cukpID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                message: z.string().nullish(),
                reviewedAt: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                targetAt: z.string(),
                userID: z.string(),
                userName: z.string(),
                value: z.string(),
                valueOmitted: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/custom-kpi/pending-approval",
    alias: "customKPIPendingApprovalList",
    description: `Lists all project status pending`,
    requestFormat: "json",
    parameters: [
      {
        name: "cukpID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "cpvaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_CustomKPIValueView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/incident/nature",
    alias: "dashboardIncidentNature",
    description: `Lists incidents by nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "innaID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "natureName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "InciID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DashboardIncidentsByNature
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/incident/neighborhood",
    alias: "dashboardIncidentNeighborhood",
    description: `Lists incidents in neighborhood`,
    requestFormat: "json",
    parameters: [
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "InciID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "neighborhood",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DashboardIncidentNeighborhood
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/incident/period",
    alias: "dashboardIncidentPeriod",
    description: `Get incidents by period`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inciID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdDate[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdDate[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                averageResponseTime: z
                  .object({
                    average: z.string(),
                    comparativePercentageLastMonth: z.number(),
                    comparativePercentageLastYear: z.number(),
                  })
                  .passthrough(),
                incidentProgression: z
                  .object({
                    comparativePercentageLastMonth: z.number(),
                    comparativePercentageLastYear: z.number(),
                    percentage: z.number(),
                  })
                  .passthrough(),
                securityIncidents: z
                  .object({
                    comparativePercentageLastMonth: z.number(),
                    comparativePercentageLastYear: z.number(),
                    total: z.number(),
                  })
                  .passthrough(),
                serviceIncidents: z
                  .object({
                    comparativePercentageLastMonth: z.number(),
                    comparativePercentageLastYear: z.number(),
                    total: z.number(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/plans/:planID",
    alias: "plansDashboard",
    description: `Get plan dashboard`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "budgetSourceName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                budgetSourceName: z.array(z.string()),
                planID: z.string(),
                resourceTimeline: z.array(
                  github_com_falqondev_cidade360_backend_service_ResourceCount
                ),
                totalActual: z.number(),
                totalPredicted: z.number(),
                totalReceived: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/plans/budget-summary/:planID",
    alias: "plansBudgetSummary",
    description: `Get plan budget summary`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "period[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "period[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                budgetSummary: z.array(
                  github_com_falqondev_cidade360_backend_service_BudgetSummary
                ),
                percentageUsage: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/plans/comments/:planID",
    alias: "plansLatestComments",
    description: `Get plan next tasks`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_PlanLatestComments
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/plans/next-task/:planID",
    alias: "plansNextTasks",
    description: `Get plan next tasks`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_PlanNextTask
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/plans/summary/:planID",
    alias: "plansSummary",
    description: `Get plan summary`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                resourceSummary: z.array(
                  github_com_falqondev_cidade360_backend_service_Resource
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/plans/task-summary/:planID",
    alias: "plansTaskSummary",
    description: `Get plan task summary`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                finishedPercentage: z.number(),
                finishedTasks: z.number(),
                openTasks: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/programs/:progID/final-budget",
    alias: "programFinalBudgetGet",
    description: `Get one program final budget`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ progID: z.string(), totalActual: z.number() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/projects/:projID/final-budget",
    alias: "projectFinalBudgetGet",
    description: `Get one project final budget`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ projID: z.string(), totalActual: z.number() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/survey/period",
    alias: "dashboardSurveyPeriod",
    description: `Get poll data by period`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "survID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "responseDate[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "responseDate[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                pools: z.number(),
                responses: z.array(
                  github_com_falqondev_cidade360_backend_service_DashboardSurveyResponse
                ),
                survIDs: z.array(z.string()),
                totalAnswers: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/work-order",
    alias: "dashboardWorkOrder",
    description: `Get work order count`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                MonthTotal: z
                  .object({
                    comparativePercentageLastYear: z.number(),
                    total: z.number(),
                  })
                  .passthrough(),
                YearTotal: z
                  .object({
                    comparativePercentageLastYear: z.number(),
                    total: z.number(),
                  })
                  .passthrough(),
                averagePerYear: z.number(),
                total: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/work-order/program",
    alias: "dashboardWorkOrderByProgram",
    description: `Lists work order by program`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "programName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "woorID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "wostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "woprID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByProgram
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dashboard/work-order/status",
    alias: "dashboardWorkOrderByStatus",
    description: `Lists work order by status`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "woorID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "range",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "startDate",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "endDate",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "wostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DashboardWorkOrderByStatus
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/default-description-texts",
    alias: "defaultDescriptionTextList",
    description: `Lists all default description texts`,
    requestFormat: "json",
    parameters: [
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "ddteID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "formName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DefaultDescriptionTextView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/default-description-texts",
    alias: "defaultDescriptionTextCreate",
    description: `Create one default description text`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: defaultDescriptionTextCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                ddteID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                formField: z.string(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                name: z.string(),
                placeholder: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/default-description-texts/:ddteID",
    alias: "defaultDescriptionTextDelete",
    description: `Delete one default description text by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "ddteID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                ddteID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                formField: z.string(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                name: z.string(),
                placeholder: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/default-description-texts/:ddteID",
    alias: "defaultDescriptionTextGet",
    description: `Get one default description text`,
    requestFormat: "json",
    parameters: [
      {
        name: "ddteID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                ddteID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                formField: z.string(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                name: z.string(),
                placeholder: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/default-description-texts/:ddteID",
    alias: "defaultDescriptionTextUpdate",
    description: `Update default description text`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: defaultDescriptionTextCreate_Body,
      },
      {
        name: "ddteID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                ddteID: z.number(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                formField: z.string(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                name: z.string(),
                placeholder: z.boolean(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-natures",
    alias: "dispatchNatureList",
    description: `Lists all dispatch_natures`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "dinaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DispatchNatureView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/dispatch-natures",
    alias: "dispatchNatureCreate",
    description: `Create one dispatch_nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/dispatch-natures/:dinaID",
    alias: "dispatchNatureDelete",
    description: `Delete one dispatch_nature by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "dinaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-natures/:dinaID",
    alias: "dispatchNatureGet",
    description: `Get one dispatch_nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "dinaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/dispatch-natures/:dinaID",
    alias: "dispatchNatureUpdate",
    description: `Update dispatch_nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "dinaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-status",
    alias: "dispatchStatusList",
    description: `Lists all dispatch_statuss`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "distID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DispatchStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/dispatch-status",
    alias: "dispatchStatusCreate",
    description: `Create one dispatch_status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                distID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/dispatch-status/:distID",
    alias: "dispatchStatusDelete",
    description: `Delete one dispatch_status by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "distID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                distID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-status/:distID",
    alias: "dispatchStatusGet",
    description: `Get one dispatch_status`,
    requestFormat: "json",
    parameters: [
      {
        name: "distID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                distID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/dispatch-status/:distID",
    alias: "dispatchStatusUpdate",
    description: `Update dispatch_status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "distID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                distID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-subnatures",
    alias: "dispatchSubnatureList",
    description: `Lists all dispatch_subnatures`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "disuID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "dinaID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DispatchSubnatureView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/dispatch-subnatures",
    alias: "dispatchSubnatureCreate",
    description: `Create one dispatch_subnature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchSubnatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                disuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/dispatch-subnatures/:disuID",
    alias: "dispatchSubnatureDelete",
    description: `Delete one dispatch_subnature by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "disuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                disuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-subnatures/:disuID",
    alias: "dispatchSubnatureGet",
    description: `Get one dispatch_subnature`,
    requestFormat: "json",
    parameters: [
      {
        name: "disuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                disuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/dispatch-subnatures/:disuID",
    alias: "dispatchSubnatureUpdate",
    description: `Update dispatch_subnature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "disuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                dinaID: z.number(),
                disuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-units",
    alias: "dispatchUnitList",
    description: `Lists all dispatch_units`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "diunID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DispatchUnitView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/dispatch-units",
    alias: "dispatchUnitCreate",
    description: `Create one dispatch_unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                diunID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/dispatch-units/:diunID",
    alias: "dispatchUnitDelete",
    description: `Delete one dispatch_unit by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "diunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                diunID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/dispatch-units/:diunID",
    alias: "dispatchUnitGet",
    description: `Get one dispatch_unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "diunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                diunID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/dispatch-units/:diunID",
    alias: "dispatchUnitUpdate",
    description: `Update dispatch_unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "diunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                diunID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/document-templates",
    alias: "documentTemplateList",
    description: `Lists all document template`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "isTemplate",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "isFormTemplate",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "survID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "doteID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "title",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DocumentTemplate
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/document-templates",
    alias: "documentTemplateCreate",
    description: `Create one document template`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentTemplateCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultData: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/document-templates/:doteID",
    alias: "documentTemplateDelete",
    description: `Delete one document template by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "doteID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultData: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/document-templates/:doteID",
    alias: "documentTemplateGet",
    description: `Get one document template`,
    requestFormat: "json",
    parameters: [
      {
        name: "doteID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultData: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/document-templates/:doteID",
    alias: "documentTemplateUpdate",
    description: `Update document template`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentTemplateCreate_Body,
      },
      {
        name: "doteID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultData: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/document-types",
    alias: "documentTypeList",
    description: `List all document types`,
    requestFormat: "json",
    parameters: [
      {
        name: "doctID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierDocumentType
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/document-types",
    alias: "documentTypeCreate",
    description: `Create one document type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentTypeCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                deletedAt: z.string().nullish(),
                doctID: z.string(),
                extractionFields: z.array(
                  github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
                ),
                label: z.string(),
                validationPrompt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/document-types/:doctID",
    alias: "documentTypeDelete",
    description: `Delete one document type`,
    requestFormat: "json",
    parameters: [
      {
        name: "doctID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                deletedAt: z.string().nullish(),
                doctID: z.string(),
                extractionFields: z.array(
                  github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
                ),
                label: z.string(),
                validationPrompt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/document-types/:doctID",
    alias: "documentTypeUpdate",
    description: `Update one document type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentTypeCreate_Body,
      },
      {
        name: "doctID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                deletedAt: z.string().nullish(),
                doctID: z.string(),
                extractionFields: z.array(
                  github_com_falqondev_cidade360_backend_service_SupplierDocumentExtractionField
                ),
                label: z.string(),
                validationPrompt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/documentations",
    alias: "documentationList",
    description: `Lists all documentations`,
    requestFormat: "json",
    parameters: [
      {
        name: "tags",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "title",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "docuIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_DocumentationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/documentations",
    alias: "documentationCreate",
    description: `Create one documentation`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentationCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                content: z.string(),
                createdAt: z.string(),
                docuID: z.number(),
                tags: z.array(z.string()),
                title: z.string(),
                videoURL: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/documentations/:docuID",
    alias: "documentationDelete",
    description: `Delete one documentation by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "docuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                content: z.string(),
                createdAt: z.string(),
                docuID: z.number(),
                tags: z.array(z.string()),
                title: z.string(),
                videoURL: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/documentations/:docuID",
    alias: "documentationGet",
    description: `Get one documentation`,
    requestFormat: "json",
    parameters: [
      {
        name: "docuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                content: z.string(),
                createdAt: z.string(),
                docuID: z.number(),
                tags: z.array(z.string()),
                title: z.string(),
                videoURL: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/documentations/:docuID",
    alias: "documentationUpdate",
    description: `Update documentation`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentationCreate_Body,
      },
      {
        name: "docuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                content: z.string(),
                createdAt: z.string(),
                docuID: z.number(),
                tags: z.array(z.string()),
                title: z.string(),
                videoURL: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/documents",
    alias: "documentList",
    description: `Lists all document`,
    requestFormat: "json",
    parameters: [
      {
        name: "Limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "Offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_Document
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/documents",
    alias: "documentCreate",
    description: `Create one document`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                data: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/documents/:docuID",
    alias: "documentDelete",
    description: `Delete one document by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "docuID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                data: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/documents/:docuID",
    alias: "documentGet",
    description: `Get one document`,
    requestFormat: "json",
    parameters: [
      {
        name: "docuID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                data: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/documents/:docuID",
    alias: "documentUpdate",
    description: `Update document`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentCreate_Body,
      },
      {
        name: "docuID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                data: z.unknown(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                formSchema: z.unknown(),
                permissionMode: z.string(),
                printSchema: z.unknown(),
                title: z.string(),
                uiSchema: z.unknown(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/event-classifications",
    alias: "eventClassificationList",
    description: `Lists all event classifications`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "evclID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_EventClassification
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/event-classifications",
    alias: "eventClassificationCreate",
    description: `Create one event classification`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                evclID: z.string(),
                name: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/fleet-vehicles",
    alias: "fleetVehicleList",
    description: `Lists all fleet vehicles`,
    requestFormat: "json",
    parameters: [
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "licensePlate",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "flveID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_FleetVehicleView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/fleet-vehicles",
    alias: "fleetVehicleCreate",
    description: `Create one fleet vehicle`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: fleetVehicleCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                details: z
                  .object({
                    carrying_capacity: z.string(),
                    color: z.string(),
                    dimensions: z
                      .object({
                        height: z.number(),
                        length: z.number(),
                        width: z.number(),
                      })
                      .passthrough(),
                    engine: z
                      .object({ capacity: z.string(), type: z.string() })
                      .passthrough(),
                    features: z.array(z.string()),
                    mileage_km: z.number(),
                    purchase_date: z.string(),
                    seat_numbers: z.number(),
                    serial_number: z.string(),
                    type: z.string(),
                    warranty: z
                      .object({
                        details: z.string().nullish(),
                        expiry_date: z.string(),
                      })
                      .passthrough(),
                  })
                  .passthrough(),
                flveID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                licensePlate: z.string(),
                make: z.string(),
                model: z.string(),
                registrationNumber: z.string(),
                updatedAt: z.string(),
                year: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/fleet-vehicles/:flveID",
    alias: "fleetVehicleDelete",
    description: `Delete one fleet vehicle by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "flveID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                details: z
                  .object({
                    carrying_capacity: z.string(),
                    color: z.string(),
                    dimensions: z
                      .object({
                        height: z.number(),
                        length: z.number(),
                        width: z.number(),
                      })
                      .passthrough(),
                    engine: z
                      .object({ capacity: z.string(), type: z.string() })
                      .passthrough(),
                    features: z.array(z.string()),
                    mileage_km: z.number(),
                    purchase_date: z.string(),
                    seat_numbers: z.number(),
                    serial_number: z.string(),
                    type: z.string(),
                    warranty: z
                      .object({
                        details: z.string().nullish(),
                        expiry_date: z.string(),
                      })
                      .passthrough(),
                  })
                  .passthrough(),
                flveID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                licensePlate: z.string(),
                make: z.string(),
                model: z.string(),
                registrationNumber: z.string(),
                updatedAt: z.string(),
                year: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/fleet-vehicles/:flveID",
    alias: "fleetVehicleGet",
    description: `Get one fleet vehicle`,
    requestFormat: "json",
    parameters: [
      {
        name: "flveID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                details: z
                  .object({
                    carrying_capacity: z.string(),
                    color: z.string(),
                    dimensions: z
                      .object({
                        height: z.number(),
                        length: z.number(),
                        width: z.number(),
                      })
                      .passthrough(),
                    engine: z
                      .object({ capacity: z.string(), type: z.string() })
                      .passthrough(),
                    features: z.array(z.string()),
                    mileage_km: z.number(),
                    purchase_date: z.string(),
                    seat_numbers: z.number(),
                    serial_number: z.string(),
                    type: z.string(),
                    warranty: z
                      .object({
                        details: z.string().nullish(),
                        expiry_date: z.string(),
                      })
                      .passthrough(),
                  })
                  .passthrough(),
                flveID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                licensePlate: z.string(),
                make: z.string(),
                model: z.string(),
                registrationNumber: z.string(),
                updatedAt: z.string(),
                year: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/fleet-vehicles/:flveID",
    alias: "fleetVehicleUpdate",
    description: `Update fleet vehicle`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: fleetVehicleCreate_Body,
      },
      {
        name: "flveID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                details: z
                  .object({
                    carrying_capacity: z.string(),
                    color: z.string(),
                    dimensions: z
                      .object({
                        height: z.number(),
                        length: z.number(),
                        width: z.number(),
                      })
                      .passthrough(),
                    engine: z
                      .object({ capacity: z.string(), type: z.string() })
                      .passthrough(),
                    features: z.array(z.string()),
                    mileage_km: z.number(),
                    purchase_date: z.string(),
                    seat_numbers: z.number(),
                    serial_number: z.string(),
                    type: z.string(),
                    warranty: z
                      .object({
                        details: z.string().nullish(),
                        expiry_date: z.string(),
                      })
                      .passthrough(),
                  })
                  .passthrough(),
                flveID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                licensePlate: z.string(),
                make: z.string(),
                model: z.string(),
                registrationNumber: z.string(),
                updatedAt: z.string(),
                year: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/form-document-templates",
    alias: "formDocumentTemplateList",
    description: `Lists all form_document_templates`,
    requestFormat: "json",
    parameters: [
      {
        name: "formName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "fodtID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_FormDocumentTemplateView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/form-document-templates",
    alias: "formDocumentTemplateCreate",
    description: `Create one form_document_template`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: formDocumentTemplateCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                doteID: z.string(),
                fodtID: z.number(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/form-document-templates/:fodtID",
    alias: "formDocumentTemplateDelete",
    description: `Delete one form_document_template by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "fodtID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                doteID: z.string(),
                fodtID: z.number(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/form-document-templates/:fodtID",
    alias: "formDocumentTemplateGet",
    description: `Get one form_document_template`,
    requestFormat: "json",
    parameters: [
      {
        name: "fodtID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                doteID: z.string(),
                fodtID: z.number(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/form-document-templates/:fodtID",
    alias: "formDocumentTemplateUpdate",
    description: `Update form_document_template`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: formDocumentTemplateCreate_Body,
      },
      {
        name: "fodtID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                doteID: z.string(),
                fodtID: z.number(),
                formName: z.string(),
                instID: z.string(),
                institutionName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/form-validations",
    alias: "formValidationList",
    description: `Lists all form_validations`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "formName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_FormValidationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/form-validations",
    alias: "formValidationCreate",
    description: `Create one form_validation`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: formValidationCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formName: z.string(),
                fovaID: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                validationSchema: z.unknown(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/form-validations/:fovaID",
    alias: "formValidationDelete",
    description: `Delete one form_validation by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "fovaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formName: z.string(),
                fovaID: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                validationSchema: z.unknown(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/form-validations/:fovaID",
    alias: "formValidationGet",
    description: `Get one form_validation`,
    requestFormat: "json",
    parameters: [
      {
        name: "fovaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formName: z.string(),
                fovaID: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                validationSchema: z.unknown(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/form-validations/:fovaID",
    alias: "formValidationUpdate",
    description: `Update form_validation`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: formValidationCreate_Body,
      },
      {
        name: "fovaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formName: z.string(),
                fovaID: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                validationSchema: z.unknown(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/guiche",
    alias: "guicheList",
    description: `Lists all guiches`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "guicID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_GuicheView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/guiche",
    alias: "guicheCreate",
    description: `Create one guiche`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                guicID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/guiche/:guicID",
    alias: "guicheDelete",
    description: `Delete one guiche by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "guicID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                guicID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/guiche/:guicID",
    alias: "guicheGet",
    description: `Get one guiche`,
    requestFormat: "json",
    parameters: [
      {
        name: "guicID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                guicID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/guiche/:guicID",
    alias: "guicheUpdate",
    description: `Update guiche`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "guicID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                guicID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-action-types",
    alias: "incidentActionTypeList",
    description: `Lists all incident_action_types`,
    requestFormat: "json",
    parameters: [
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "iatyID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentActionTypeView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-action-types",
    alias: "incidentActionTypeCreate",
    description: `Create one incident_action_type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                iatyID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-action-types/:iatyID",
    alias: "incidentActionTypeDelete",
    description: `Delete one incident_action_type by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "iatyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                iatyID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-action-types/:iatyID",
    alias: "incidentActionTypeGet",
    description: `Get one incident_action_type`,
    requestFormat: "json",
    parameters: [
      {
        name: "iatyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                iatyID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-action-types/:iatyID",
    alias: "incidentActionTypeUpdate",
    description: `Update incident_action_type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "iatyID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                iatyID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-dispatchers",
    alias: "incidentDispatcherList",
    description: `Lists all incident_dispatchers`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "indiID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentDispatcherView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-dispatchers",
    alias: "incidentDispatcherCreate",
    description: `Create one incident_dispatcher`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                indiID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-dispatchers/:indiID",
    alias: "incidentDispatcherDelete",
    description: `Delete one incident_dispatcher by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "indiID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                indiID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-dispatchers/:indiID",
    alias: "incidentDispatcherGet",
    description: `Get one incident_dispatcher`,
    requestFormat: "json",
    parameters: [
      {
        name: "indiID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                indiID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-dispatchers/:indiID",
    alias: "incidentDispatcherUpdate",
    description: `Update incident_dispatcher`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "indiID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                indiID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-environments",
    alias: "incidentEnvironmentList",
    description: `Lists all incident_environments`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inenID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentEnvironmentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-environments",
    alias: "incidentEnvironmentCreate",
    description: `Create one incident_environment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inenID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-environments/:inenID",
    alias: "incidentEnvironmentDelete",
    description: `Delete one incident_environment by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inenID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inenID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-environments/:inenID",
    alias: "incidentEnvironmentGet",
    description: `Get one incident_environment`,
    requestFormat: "json",
    parameters: [
      {
        name: "inenID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inenID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-environments/:inenID",
    alias: "incidentEnvironmentUpdate",
    description: `Update incident_environment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "inenID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inenID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-establishments",
    alias: "incidentEstablishmentList",
    description: `Lists all incident_establishments`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inesID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentEstablishmentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-establishments",
    alias: "incidentEstablishmentCreate",
    description: `Create one incident_establishment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inesID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-establishments/:inesID",
    alias: "incidentEstablishmentDelete",
    description: `Delete one incident_establishment by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inesID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inesID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-establishments/:inesID",
    alias: "incidentEstablishmentGet",
    description: `Get one incident_establishment`,
    requestFormat: "json",
    parameters: [
      {
        name: "inesID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inesID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-establishments/:inesID",
    alias: "incidentEstablishmentUpdate",
    description: `Update incident_establishment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "inesID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inesID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-natures",
    alias: "incidentNatureList",
    description: `Lists all thematic axes`,
    requestFormat: "json",
    parameters: [
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "innaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentNatureView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-natures",
    alias: "incidentNatureCreate",
    description: `Create one incident nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                innaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-natures/:innaID",
    alias: "incidentNatureDelete",
    description: `Delete one incident nature by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "innaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                innaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-natures/:innaID",
    alias: "incidentNatureGet",
    description: `Get one incident nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "innaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                innaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-natures/:innaID",
    alias: "incidentNatureUpdate",
    description: `Update incident nature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "innaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                innaID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-origins",
    alias: "incidentOriginList",
    description: `Lists all incident_origins`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inorID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentOriginView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-origins",
    alias: "incidentOriginCreate",
    description: `Create one incident_origin`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inorID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-origins/:inorID",
    alias: "incidentOriginDelete",
    description: `Delete one incident_origin by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inorID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inorID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-origins/:inorID",
    alias: "incidentOriginGet",
    description: `Get one incident_origin`,
    requestFormat: "json",
    parameters: [
      {
        name: "inorID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inorID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-origins/:inorID",
    alias: "incidentOriginUpdate",
    description: `Update incident_origin`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "inorID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inorID: z.number(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-programs",
    alias: "incidentProgramList",
    description: `Lists all incident_programs`,
    requestFormat: "json",
    parameters: [
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inprID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentProgramView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-programs",
    alias: "incidentProgramCreate",
    description: `Create one incident_program`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentProgramCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-programs/:inprID",
    alias: "incidentProgramDelete",
    description: `Delete one incident_program by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inprID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-programs/:inprID",
    alias: "incidentProgramGet",
    description: `Get one incident_program`,
    requestFormat: "json",
    parameters: [
      {
        name: "inprID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-programs/:inprID",
    alias: "incidentProgramUpdate",
    description: `Update incident_program`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentProgramCreate_Body,
      },
      {
        name: "inprID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-response-locations",
    alias: "incidentResponseLocationList",
    description: `Lists all incident_response_locations`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "irloID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentResponseLocationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-response-locations",
    alias: "incidentResponseLocationCreate",
    description: `Create one incident_response_location`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                irloID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-response-locations/:irloID",
    alias: "incidentResponseLocationDelete",
    description: `Delete one incident_response_location by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "irloID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                irloID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-response-locations/:irloID",
    alias: "incidentResponseLocationGet",
    description: `Get one incident_response_location`,
    requestFormat: "json",
    parameters: [
      {
        name: "irloID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                irloID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-response-locations/:irloID",
    alias: "incidentResponseLocationUpdate",
    description: `Update incident_response_location`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "irloID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                irloID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-status",
    alias: "incidentStatusList",
    description: `Lists all incident statuss`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "istaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentStatus
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-status",
    alias: "incidentStatusCreate",
    description: `Create one incident status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentStatusCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                istaID: z.number(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-status/:istaID",
    alias: "incidentStatusDelete",
    description: `Delete one incident status by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "istaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                istaID: z.number(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-status/:istaID",
    alias: "incidentStatusGet",
    description: `Get one incident status`,
    requestFormat: "json",
    parameters: [
      {
        name: "istaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                istaID: z.number(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-status/:istaID",
    alias: "incidentStatusUpdate",
    description: `Update incident status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentStatusCreate_Body,
      },
      {
        name: "istaID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                istaID: z.number(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-subnatures",
    alias: "incidentSubnatureList",
    description: `Lists all incident_subnatures`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inbnID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "innaID",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentSubnatureView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-subnatures",
    alias: "incidentSubnatureCreate",
    description: `Create one incident_subnature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentSubnatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inbnID: z.number(),
                innaID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-subnatures/:inbnID",
    alias: "incidentSubnatureDelete",
    description: `Delete one incident_subnature by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inbnID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inbnID: z.number(),
                innaID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-subnatures/:inbnID",
    alias: "incidentSubnatureGet",
    description: `Get one incident_subnature`,
    requestFormat: "json",
    parameters: [
      {
        name: "inbnID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inbnID: z.number(),
                innaID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-subnatures/:inbnID",
    alias: "incidentSubnatureUpdate",
    description: `Update incident_subnature`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentSubnatureCreate_Body,
      },
      {
        name: "inbnID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inbnID: z.number(),
                innaID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-subprograms",
    alias: "incidentSubprogramList",
    description: `Lists all incident_subprograms`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "insuID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inprID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentSubprogramView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incident-subprograms",
    alias: "incidentSubprogramCreate",
    description: `Create one incident_subprogram`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentSubprogramCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                insuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incident-subprograms/:insuID",
    alias: "incidentSubprogramDelete",
    description: `Delete one incident_subprogram by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "insuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                insuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incident-subprograms/:insuID",
    alias: "incidentSubprogramGet",
    description: `Get one incident_subprogram`,
    requestFormat: "json",
    parameters: [
      {
        name: "insuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                insuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incident-subprograms/:insuID",
    alias: "incidentSubprogramUpdate",
    description: `Update incident_subprogram`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentSubprogramCreate_Body,
      },
      {
        name: "insuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                inprID: z.number(),
                insuID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incidents",
    alias: "incidentList",
    description: `Lists all incidents`,
    requestFormat: "json",
    parameters: [
      {
        name: "inciID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "programName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "establishmentName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "servicedAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "originName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "uid",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "statusName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "environmentName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "actionTypeName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subnatureName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "servicedAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "incidentType",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "dispatcherName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "natureName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subprogramName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/incidents",
    alias: "incidentCreate",
    description: `Create one incident`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionTypeName: z.string(),
                address: z
                  .object({
                    city: z.string().nullish(),
                    complement: z.string().nullish(),
                    isVillage: z.boolean(),
                    latitude: z.number().nullish(),
                    longitude: z.number().nullish(),
                    neighborhood: z.string().nullish(),
                    number: z.string().nullish(),
                    state: z.string().nullish(),
                    street: z.string().nullish(),
                    zipCode: z.string().nullish(),
                  })
                  .passthrough()
                  .nullish(),
                agentID: z.string().nullish(),
                agentName: z.string(),
                agentRole: z.string().nullish(),
                arrivalAt: z.string().nullish(),
                buunID: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                depredations: z.array(
                  github_com_falqondev_cidade360_backend_service_Depredation
                ),
                description: z.string(),
                details: z
                  .object({
                    confidential: z.boolean().nullable(),
                    protocolNumber: z.string().nullable(),
                    relatorAttachment: z.string().nullable(),
                    relatorDescription: z.string().nullable(),
                    solution: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                dinaID: z.number().nullish(),
                dispatchNature: z.string(),
                dispatchStatus: z.string(),
                dispatchSubnature: z.string(),
                dispatchUnit: z.string(),
                dispatcherName: z.string(),
                distID: z.number().nullish(),
                disuID: z.number().nullish(),
                diunID: z.number().nullish(),
                environmentName: z.string().nullish(),
                establishmentName: z.string().nullish(),
                fieldContact: z
                  .object({
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                guicID: z.number().nullish(),
                guicheName: z.string(),
                iatyID: z.number().nullish(),
                ifdiID: z.number().nullish(),
                inbnID: z.number().nullish(),
                inciID: z.string(),
                incidentType: z.string(),
                incidentVehicles: z.array(
                  github_com_falqondev_cidade360_backend_service_IncidentVehicleView
                ),
                indeID: z.number().nullish(),
                indiID: z.number().nullish(),
                inenID: z.number().nullish(),
                inesID: z.number().nullish(),
                infdID: z.number().nullish(),
                ininID: z.number().nullish(),
                innaID: z.number().nullish(),
                inorID: z.number().nullish(),
                inprID: z.number().nullish(),
                inseID: z.number().nullish(),
                instID: z.string(),
                institutionName: z.string(),
                insuID: z.number().nullish(),
                involvedParties: z.array(
                  github_com_falqondev_cidade360_backend_service_InvolvedPartyView
                ),
                istaID: z.number(),
                natureName: z.string(),
                originName: z.string(),
                partnerInstID: z.string().nullish(),
                partnerInstitutionName: z.string(),
                programName: z.string(),
                progressionFromUid: z.string().nullish(),
                publicEquipmentName: z.string(),
                pueqID: z.number().nullish(),
                relatorCode: z.string().nullish(),
                relatorID: z.string().nullish(),
                relatorName: z.string(),
                relatorRole: z.string().nullish(),
                requester: z
                  .object({
                    email: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                    sex: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                sechID: z.number().nullish(),
                seizedItems: z.array(
                  github_com_falqondev_cidade360_backend_service_SeizedItemView
                ),
                serviceChannelName: z.string(),
                servicedAt: z.string().nullish(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusName: z.string(),
                statusReason: z.string().nullish(),
                subnatureName: z.string(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
                workOrderUid: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/incidents/:inciID",
    alias: "incidentDelete",
    description: `Delete one incident by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inciID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionTypeName: z.string(),
                address: z
                  .object({
                    city: z.string().nullish(),
                    complement: z.string().nullish(),
                    isVillage: z.boolean(),
                    latitude: z.number().nullish(),
                    longitude: z.number().nullish(),
                    neighborhood: z.string().nullish(),
                    number: z.string().nullish(),
                    state: z.string().nullish(),
                    street: z.string().nullish(),
                    zipCode: z.string().nullish(),
                  })
                  .passthrough()
                  .nullish(),
                agentID: z.string().nullish(),
                agentName: z.string(),
                agentRole: z.string().nullish(),
                arrivalAt: z.string().nullish(),
                buunID: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                depredations: z.array(
                  github_com_falqondev_cidade360_backend_service_Depredation
                ),
                description: z.string(),
                details: z
                  .object({
                    confidential: z.boolean().nullable(),
                    protocolNumber: z.string().nullable(),
                    relatorAttachment: z.string().nullable(),
                    relatorDescription: z.string().nullable(),
                    solution: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                dinaID: z.number().nullish(),
                dispatchNature: z.string(),
                dispatchStatus: z.string(),
                dispatchSubnature: z.string(),
                dispatchUnit: z.string(),
                dispatcherName: z.string(),
                distID: z.number().nullish(),
                disuID: z.number().nullish(),
                diunID: z.number().nullish(),
                environmentName: z.string().nullish(),
                establishmentName: z.string().nullish(),
                fieldContact: z
                  .object({
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                guicID: z.number().nullish(),
                guicheName: z.string(),
                iatyID: z.number().nullish(),
                ifdiID: z.number().nullish(),
                inbnID: z.number().nullish(),
                inciID: z.string(),
                incidentType: z.string(),
                incidentVehicles: z.array(
                  github_com_falqondev_cidade360_backend_service_IncidentVehicleView
                ),
                indeID: z.number().nullish(),
                indiID: z.number().nullish(),
                inenID: z.number().nullish(),
                inesID: z.number().nullish(),
                infdID: z.number().nullish(),
                ininID: z.number().nullish(),
                innaID: z.number().nullish(),
                inorID: z.number().nullish(),
                inprID: z.number().nullish(),
                inseID: z.number().nullish(),
                instID: z.string(),
                institutionName: z.string(),
                insuID: z.number().nullish(),
                involvedParties: z.array(
                  github_com_falqondev_cidade360_backend_service_InvolvedPartyView
                ),
                istaID: z.number(),
                natureName: z.string(),
                originName: z.string(),
                partnerInstID: z.string().nullish(),
                partnerInstitutionName: z.string(),
                programName: z.string(),
                progressionFromUid: z.string().nullish(),
                publicEquipmentName: z.string(),
                pueqID: z.number().nullish(),
                relatorCode: z.string().nullish(),
                relatorID: z.string().nullish(),
                relatorName: z.string(),
                relatorRole: z.string().nullish(),
                requester: z
                  .object({
                    email: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                    sex: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                sechID: z.number().nullish(),
                seizedItems: z.array(
                  github_com_falqondev_cidade360_backend_service_SeizedItemView
                ),
                serviceChannelName: z.string(),
                servicedAt: z.string().nullish(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusName: z.string(),
                statusReason: z.string().nullish(),
                subnatureName: z.string(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
                workOrderUid: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incidents/:inciID",
    alias: "incidentGet",
    description: `Get one incident`,
    requestFormat: "json",
    parameters: [
      {
        name: "inciID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionTypeName: z.string(),
                address: z
                  .object({
                    city: z.string().nullish(),
                    complement: z.string().nullish(),
                    isVillage: z.boolean(),
                    latitude: z.number().nullish(),
                    longitude: z.number().nullish(),
                    neighborhood: z.string().nullish(),
                    number: z.string().nullish(),
                    state: z.string().nullish(),
                    street: z.string().nullish(),
                    zipCode: z.string().nullish(),
                  })
                  .passthrough()
                  .nullish(),
                agentID: z.string().nullish(),
                agentName: z.string(),
                agentRole: z.string().nullish(),
                arrivalAt: z.string().nullish(),
                buunID: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                depredations: z.array(
                  github_com_falqondev_cidade360_backend_service_Depredation
                ),
                description: z.string(),
                details: z
                  .object({
                    confidential: z.boolean().nullable(),
                    protocolNumber: z.string().nullable(),
                    relatorAttachment: z.string().nullable(),
                    relatorDescription: z.string().nullable(),
                    solution: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                dinaID: z.number().nullish(),
                dispatchNature: z.string(),
                dispatchStatus: z.string(),
                dispatchSubnature: z.string(),
                dispatchUnit: z.string(),
                dispatcherName: z.string(),
                distID: z.number().nullish(),
                disuID: z.number().nullish(),
                diunID: z.number().nullish(),
                environmentName: z.string().nullish(),
                establishmentName: z.string().nullish(),
                fieldContact: z
                  .object({
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                guicID: z.number().nullish(),
                guicheName: z.string(),
                iatyID: z.number().nullish(),
                ifdiID: z.number().nullish(),
                inbnID: z.number().nullish(),
                inciID: z.string(),
                incidentType: z.string(),
                incidentVehicles: z.array(
                  github_com_falqondev_cidade360_backend_service_IncidentVehicleView
                ),
                indeID: z.number().nullish(),
                indiID: z.number().nullish(),
                inenID: z.number().nullish(),
                inesID: z.number().nullish(),
                infdID: z.number().nullish(),
                ininID: z.number().nullish(),
                innaID: z.number().nullish(),
                inorID: z.number().nullish(),
                inprID: z.number().nullish(),
                inseID: z.number().nullish(),
                instID: z.string(),
                institutionName: z.string(),
                insuID: z.number().nullish(),
                involvedParties: z.array(
                  github_com_falqondev_cidade360_backend_service_InvolvedPartyView
                ),
                istaID: z.number(),
                natureName: z.string(),
                originName: z.string(),
                partnerInstID: z.string().nullish(),
                partnerInstitutionName: z.string(),
                programName: z.string(),
                progressionFromUid: z.string().nullish(),
                publicEquipmentName: z.string(),
                pueqID: z.number().nullish(),
                relatorCode: z.string().nullish(),
                relatorID: z.string().nullish(),
                relatorName: z.string(),
                relatorRole: z.string().nullish(),
                requester: z
                  .object({
                    email: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                    sex: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                sechID: z.number().nullish(),
                seizedItems: z.array(
                  github_com_falqondev_cidade360_backend_service_SeizedItemView
                ),
                serviceChannelName: z.string(),
                servicedAt: z.string().nullish(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusName: z.string(),
                statusReason: z.string().nullish(),
                subnatureName: z.string(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
                workOrderUid: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/incidents/:inciID",
    alias: "incidentUpdate",
    description: `Update incident`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentCreate_Body,
      },
      {
        name: "inciID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionTypeName: z.string(),
                address: z
                  .object({
                    city: z.string().nullish(),
                    complement: z.string().nullish(),
                    isVillage: z.boolean(),
                    latitude: z.number().nullish(),
                    longitude: z.number().nullish(),
                    neighborhood: z.string().nullish(),
                    number: z.string().nullish(),
                    state: z.string().nullish(),
                    street: z.string().nullish(),
                    zipCode: z.string().nullish(),
                  })
                  .passthrough()
                  .nullish(),
                agentID: z.string().nullish(),
                agentName: z.string(),
                agentRole: z.string().nullish(),
                arrivalAt: z.string().nullish(),
                buunID: z.number().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                depredations: z.array(
                  github_com_falqondev_cidade360_backend_service_Depredation
                ),
                description: z.string(),
                details: z
                  .object({
                    confidential: z.boolean().nullable(),
                    protocolNumber: z.string().nullable(),
                    relatorAttachment: z.string().nullable(),
                    relatorDescription: z.string().nullable(),
                    solution: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                dinaID: z.number().nullish(),
                dispatchNature: z.string(),
                dispatchStatus: z.string(),
                dispatchSubnature: z.string(),
                dispatchUnit: z.string(),
                dispatcherName: z.string(),
                distID: z.number().nullish(),
                disuID: z.number().nullish(),
                diunID: z.number().nullish(),
                environmentName: z.string().nullish(),
                establishmentName: z.string().nullish(),
                fieldContact: z
                  .object({
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                guicID: z.number().nullish(),
                guicheName: z.string(),
                iatyID: z.number().nullish(),
                ifdiID: z.number().nullish(),
                inbnID: z.number().nullish(),
                inciID: z.string(),
                incidentType: z.string(),
                incidentVehicles: z.array(
                  github_com_falqondev_cidade360_backend_service_IncidentVehicleView
                ),
                indeID: z.number().nullish(),
                indiID: z.number().nullish(),
                inenID: z.number().nullish(),
                inesID: z.number().nullish(),
                infdID: z.number().nullish(),
                ininID: z.number().nullish(),
                innaID: z.number().nullish(),
                inorID: z.number().nullish(),
                inprID: z.number().nullish(),
                inseID: z.number().nullish(),
                instID: z.string(),
                institutionName: z.string(),
                insuID: z.number().nullish(),
                involvedParties: z.array(
                  github_com_falqondev_cidade360_backend_service_InvolvedPartyView
                ),
                istaID: z.number(),
                natureName: z.string(),
                originName: z.string(),
                partnerInstID: z.string().nullish(),
                partnerInstitutionName: z.string(),
                programName: z.string(),
                progressionFromUid: z.string().nullish(),
                publicEquipmentName: z.string(),
                pueqID: z.number().nullish(),
                relatorCode: z.string().nullish(),
                relatorID: z.string().nullish(),
                relatorName: z.string(),
                relatorRole: z.string().nullish(),
                requester: z
                  .object({
                    email: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                    sex: z.string().nullable(),
                  })
                  .partial()
                  .passthrough()
                  .nullish(),
                sechID: z.number().nullish(),
                seizedItems: z.array(
                  github_com_falqondev_cidade360_backend_service_SeizedItemView
                ),
                serviceChannelName: z.string(),
                servicedAt: z.string().nullish(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string().nullable() })
                      .partial()
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusName: z.string(),
                statusReason: z.string().nullish(),
                subnatureName: z.string(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
                workOrderUid: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incidents/:inciID/documents",
    alias: "incidentDocumentList",
    description: `Lists all incident documents`,
    requestFormat: "json",
    parameters: [
      {
        name: "inciID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "docuID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "infdID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "doteID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_IncidentDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/incidents/download",
    alias: "incidentDownload",
    description: `Get incident export file`,
    requestFormat: "json",
    parameters: [
      {
        name: "inciID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "incidentType",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "uid",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subnatureName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "actionTypeName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "servicedAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "dispatcherName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "natureName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "environmentName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "servicedAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "programName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "statusName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "originName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subprogramName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "establishmentName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/institutions",
    alias: "institutionList",
    description: `Lists all institutions`,
    requestFormat: "json",
    parameters: [
      {
        name: "abbreviation",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_Institution
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/institutions",
    alias: "institutionCreate",
    description: `Create one institution`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: institutionCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documentNumber: z.string(),
                documentType: z.string(),
                instID: z.string(),
                name: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/institutions/:instID",
    alias: "institutionDelete",
    description: `Delete one institution by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documentNumber: z.string(),
                documentType: z.string(),
                instID: z.string(),
                name: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/institutions/:instID",
    alias: "institutionGet",
    description: `Get one institution`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documentNumber: z.string(),
                documentType: z.string(),
                instID: z.string(),
                name: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/institutions/:instID",
    alias: "institutionUpdate",
    description: `Update institution`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: institutionCreate_Body,
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                documentNumber: z.string(),
                documentType: z.string(),
                instID: z.string(),
                name: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/institutions/:instID/business-units",
    alias: "institutionUnitList",
    description: `Lists all business units for institution`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "buunID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_BusinessUnit
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/institutions/:instID/business-units",
    alias: "institutionUnitCreate",
    description: `Create one institution business unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: institutionUnitCreate_Body,
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                address: z
                  .object({
                    city: z.string(),
                    country: z.string(),
                    neighborhood: z.string(),
                    number: z.string(),
                    state: z.string(),
                    street: z.string(),
                    zipCode: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                buunID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number().nullish(),
                name: z.string(),
                phone: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/institutions/:instID/business-units/:buunID",
    alias: "institutionUnitDelete",
    description: `Delete one business unit by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "buunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                address: z
                  .object({
                    city: z.string(),
                    country: z.string(),
                    neighborhood: z.string(),
                    number: z.string(),
                    state: z.string(),
                    street: z.string(),
                    zipCode: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                buunID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number().nullish(),
                name: z.string(),
                phone: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/institutions/:instID/business-units/:buunID",
    alias: "institutionUnitGet",
    description: `Get one business unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "buunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                address: z
                  .object({
                    city: z.string(),
                    country: z.string(),
                    neighborhood: z.string(),
                    number: z.string(),
                    state: z.string(),
                    street: z.string(),
                    zipCode: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                buunID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number().nullish(),
                name: z.string(),
                phone: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/institutions/:instID/business-units/:buunID",
    alias: "institutionUnitUpdate",
    description: `Update business unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: institutionUnitCreate_Body,
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "buunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                abbreviation: z.string(),
                address: z
                  .object({
                    city: z.string(),
                    country: z.string(),
                    neighborhood: z.string(),
                    number: z.string(),
                    state: z.string(),
                    street: z.string(),
                    zipCode: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                buunID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number().nullish(),
                name: z.string(),
                phone: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/institutions/:instID/users",
    alias: "institutionUserList",
    description: `Lists all institutions`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inusID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "keywords",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_InstitutionUserView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/institutions/:instID/users",
    alias: "institutionUserCreate",
    description: `Create one institution user`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: institutionUserCreate_Body,
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                admittedAt: z.string().nullish(),
                buunID: z.number().nullish(),
                code: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number(),
                name: z.string(),
                operationalCode: z.string().nullish(),
                phone: z.string(),
                sex: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/institutions/:instID/users/:inusID",
    alias: "institutionUserDelete",
    description: `Delete one institution user by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "inusID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                admittedAt: z.string().nullish(),
                buunID: z.number().nullish(),
                code: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number(),
                name: z.string(),
                operationalCode: z.string().nullish(),
                phone: z.string(),
                sex: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/institutions/:instID/users/:inusID",
    alias: "institutionUserGet",
    description: `Get one institution user`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "inusID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                admittedAt: z.string().nullish(),
                buunID: z.number().nullish(),
                code: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number(),
                name: z.string(),
                operationalCode: z.string().nullish(),
                phone: z.string(),
                sex: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/institutions/:instID/users/:inusID",
    alias: "institutionUserUpdate",
    description: `Update institution`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: institutionUserUpdate_Body,
      },
      {
        name: "instID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "inusID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                admittedAt: z.string().nullish(),
                buunID: z.number().nullish(),
                code: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                inusID: z.number(),
                name: z.string(),
                operationalCode: z.string().nullish(),
                phone: z.string(),
                sex: z.string(),
                updatedAt: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/kanban",
    alias: "kanbanList",
    description: `Lists all kanban columns`,
    requestFormat: "json",
    parameters: [
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "mostIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_KanbanView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/kanban",
    alias: "kanbanCreate",
    description: `Create one kanban column`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: kanbanCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultStatus: z.boolean(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                mostID: z.number(),
                name: z.string(),
                orderIndex: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/kanban/:mostID",
    alias: "kanbanDelete",
    description: `Delete one kanban column by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "mostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultStatus: z.boolean(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                mostID: z.number(),
                name: z.string(),
                orderIndex: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/kanban/:mostID",
    alias: "kanbanGet",
    description: `Get one kanban column`,
    requestFormat: "json",
    parameters: [
      {
        name: "mostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultStatus: z.boolean(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                mostID: z.number(),
                name: z.string(),
                orderIndex: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/kanban/:mostID",
    alias: "kanbanUpdate",
    description: `Update kanban column`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: kanbanCreate_Body,
      },
      {
        name: "mostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultStatus: z.boolean(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                mostID: z.number(),
                name: z.string(),
                orderIndex: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/kanban/:mostID/reorder",
    alias: "kanbanLinksCreate",
    description: `Create kanban links`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: kanbanLinksCreate_Body,
      },
      {
        name: "mostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_KanbanLinkView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/measurement-unit",
    alias: "measurementUnitList",
    description: `Lists all measurement units`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "meunIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_MeasurementUnit
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/measurement-unit",
    alias: "measurementUnitCreate",
    description: `Create one measurement unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: measurementUnitCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formatConfig: z
                  .object({
                    decimalPlaces: z.number(),
                    decimalSep: z.string(),
                    prefix: z.string(),
                    suffix: z.string(),
                    thousandsSep: z.string(),
                  })
                  .passthrough(),
                meunID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/measurement-unit/:meunID",
    alias: "measurementUnitDelete",
    description: `Delete one measurement unit by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "meunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formatConfig: z
                  .object({
                    decimalPlaces: z.number(),
                    decimalSep: z.string(),
                    prefix: z.string(),
                    suffix: z.string(),
                    thousandsSep: z.string(),
                  })
                  .passthrough(),
                meunID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/measurement-unit/:meunID",
    alias: "measurementUnitGet",
    description: `Get one measurement unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "meunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formatConfig: z
                  .object({
                    decimalPlaces: z.number(),
                    decimalSep: z.string(),
                    prefix: z.string(),
                    suffix: z.string(),
                    thousandsSep: z.string(),
                  })
                  .passthrough(),
                meunID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/measurement-unit/:meunID",
    alias: "measurementUnitUpdate",
    description: `Update measurement unit`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: measurementUnitCreate_Body,
      },
      {
        name: "meunID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                formatConfig: z
                  .object({
                    decimalPlaces: z.number(),
                    decimalSep: z.string(),
                    prefix: z.string(),
                    suffix: z.string(),
                    thousandsSep: z.string(),
                  })
                  .passthrough(),
                meunID: z.number(),
                name: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/my-task-queue",
    alias: "myTaskQueueList",
    description: `Lists my task queue items`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "actiID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "taskType",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_MyTaskQueueItem
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/notification-config",
    alias: "notificationConfigUpdate",
    description: `Update notification configuration`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: notificationConfigUpdate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                module: z.string(),
                noruID: z.string(),
                notificationIntegrations: z
                  .object({
                    email: z
                      .object({
                        active: z.boolean(),
                        password: z.string(),
                        port: z.number(),
                        server: z.string(),
                        user: z.string(),
                      })
                      .passthrough()
                      .nullable(),
                    googleChat: z
                      .object({
                        accessToken: z.string().nullish(),
                        active: z.boolean(),
                        clientID: z.string(),
                        clientSecret: z.string(),
                        expiresAt: z.string().nullish(),
                        name: z.string(),
                        refreshToken: z.string().nullish(),
                      })
                      .passthrough()
                      .nullable(),
                    teams: z
                      .object({
                        accessToken: z.string().nullish(),
                        active: z.boolean(),
                        chatID: z.string(),
                        clientID: z.string(),
                        clientSecret: z.string(),
                        expiresAt: z.string().nullish(),
                        graphUserID: z.string().nullish(),
                        refreshToken: z.string().nullish(),
                        tenantID: z.string(),
                      })
                      .passthrough()
                      .nullable(),
                    whatsapp: z
                      .object({
                        active: z.boolean(),
                        phoneID: z.string(),
                        token: z.string(),
                        wabaID: z.string(),
                      })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                rules: z
                  .object({
                    notifySupplierDocumentExpiring: z.boolean(),
                    notifySupplierDocumentStatusChange: z.boolean(),
                    notifySupplierPenaltyCreated: z.boolean(),
                    notifySupplierRegistryStatusChange: z.boolean(),
                    supplierDocumentExpiryRules: z
                      .array(
                        github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
                      )
                      .nullish(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-config/:module",
    alias: "notificationConfigGet",
    description: `Get notification configuration`,
    requestFormat: "json",
    parameters: [
      {
        name: "module",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                module: z.string(),
                noruID: z.string(),
                notificationIntegrations: z
                  .object({
                    email: z
                      .object({
                        active: z.boolean(),
                        password: z.string(),
                        port: z.number(),
                        server: z.string(),
                        user: z.string(),
                      })
                      .passthrough()
                      .nullable(),
                    googleChat: z
                      .object({
                        accessToken: z.string().nullish(),
                        active: z.boolean(),
                        clientID: z.string(),
                        clientSecret: z.string(),
                        expiresAt: z.string().nullish(),
                        name: z.string(),
                        refreshToken: z.string().nullish(),
                      })
                      .passthrough()
                      .nullable(),
                    teams: z
                      .object({
                        accessToken: z.string().nullish(),
                        active: z.boolean(),
                        chatID: z.string(),
                        clientID: z.string(),
                        clientSecret: z.string(),
                        expiresAt: z.string().nullish(),
                        graphUserID: z.string().nullish(),
                        refreshToken: z.string().nullish(),
                        tenantID: z.string(),
                      })
                      .passthrough()
                      .nullable(),
                    whatsapp: z
                      .object({
                        active: z.boolean(),
                        phoneID: z.string(),
                        token: z.string(),
                        wabaID: z.string(),
                      })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                rules: z
                  .object({
                    notifySupplierDocumentExpiring: z.boolean(),
                    notifySupplierDocumentStatusChange: z.boolean(),
                    notifySupplierPenaltyCreated: z.boolean(),
                    notifySupplierRegistryStatusChange: z.boolean(),
                    supplierDocumentExpiryRules: z
                      .array(
                        github_com_falqondev_cidade360_backend_service_SupplierDocumentExpiryRule
                      )
                      .nullish(),
                  })
                  .passthrough(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-config/:module/google-auth",
    alias: "notificationConfigAuthGoogleChat",
    description: `Get Google Chat auth URL for module`,
    requestFormat: "json",
    parameters: [
      {
        name: "module",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-config/:module/teams-auth",
    alias: "notificationConfigAuthTeams",
    description: `Get Microsoft Teams auth URL for module`,
    requestFormat: "json",
    parameters: [
      {
        name: "module",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-config/google-callback",
    alias: "notificationConfigCallbackGoogleChat",
    description: `Callback from Google Chat auth`,
    requestFormat: "json",
    parameters: [
      {
        name: "code",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "state",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-config/teams-callback",
    alias: "notificationConfigCallbackTeams",
    description: `Callback from Microsoft Teams auth`,
    requestFormat: "json",
    parameters: [
      {
        name: "code",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "state",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-integrations",
    alias: "notificationIntegrationsGet",
    description: `Get global notification integrations`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                email: z
                  .object({
                    active: z.boolean(),
                    password: z.string(),
                    port: z.number(),
                    server: z.string(),
                    user: z.string(),
                  })
                  .passthrough()
                  .nullable(),
                googleChat: z
                  .object({
                    accessToken: z.string().nullish(),
                    active: z.boolean(),
                    clientID: z.string(),
                    clientSecret: z.string(),
                    expiresAt: z.string().nullish(),
                    name: z.string(),
                    refreshToken: z.string().nullish(),
                  })
                  .passthrough()
                  .nullable(),
                teams: z
                  .object({
                    accessToken: z.string().nullish(),
                    active: z.boolean(),
                    chatID: z.string(),
                    clientID: z.string(),
                    clientSecret: z.string(),
                    expiresAt: z.string().nullish(),
                    graphUserID: z.string().nullish(),
                    refreshToken: z.string().nullish(),
                    tenantID: z.string(),
                  })
                  .passthrough()
                  .nullable(),
                whatsapp: z
                  .object({
                    active: z.boolean(),
                    phoneID: z.string(),
                    token: z.string(),
                    wabaID: z.string(),
                  })
                  .passthrough()
                  .nullable(),
              })
              .partial()
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/notification-integrations",
    alias: "notificationIntegrationsUpdate",
    description: `Update global notification integrations`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: notificationIntegrationsUpdate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                email: z
                  .object({
                    active: z.boolean(),
                    password: z.string(),
                    port: z.number(),
                    server: z.string(),
                    user: z.string(),
                  })
                  .passthrough()
                  .nullable(),
                googleChat: z
                  .object({
                    accessToken: z.string().nullish(),
                    active: z.boolean(),
                    clientID: z.string(),
                    clientSecret: z.string(),
                    expiresAt: z.string().nullish(),
                    name: z.string(),
                    refreshToken: z.string().nullish(),
                  })
                  .passthrough()
                  .nullable(),
                teams: z
                  .object({
                    accessToken: z.string().nullish(),
                    active: z.boolean(),
                    chatID: z.string(),
                    clientID: z.string(),
                    clientSecret: z.string(),
                    expiresAt: z.string().nullish(),
                    graphUserID: z.string().nullish(),
                    refreshToken: z.string().nullish(),
                    tenantID: z.string(),
                  })
                  .passthrough()
                  .nullable(),
                whatsapp: z
                  .object({
                    active: z.boolean(),
                    phoneID: z.string(),
                    token: z.string(),
                    wabaID: z.string(),
                  })
                  .passthrough()
                  .nullable(),
              })
              .partial()
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-integrations/google-auth",
    alias: "notificationIntegrationsAuthGoogleChat",
    description: `Get Google Chat auth URL`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notification-integrations/teams-auth",
    alias: "notificationIntegrationsAuthTeams",
    description: `Get Microsoft Teams auth URL`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notifications",
    alias: "notificationList",
    description: `Lists all notifications`,
    requestFormat: "json",
    parameters: [
      {
        name: "notiID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "path",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "read",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_NotificationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/notifications/:notiID",
    alias: "notificationGet",
    description: `Get one event alert`,
    requestFormat: "json",
    parameters: [
      {
        name: "notiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                data: z.unknown(),
                notiID: z.string(),
                path: z.string(),
                readAt: z.string().nullish(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/notifications/read",
    alias: "notificationRead",
    description: `Mark notifications as read`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: notificationRead_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_NotificationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/one-time-login",
    alias: "oneTimeLoginCreate",
    description: `Create new oneTimeLogin`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: oneTimeLoginCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                otloID: z.number(),
                token: z.string(),
                userID: z.string(),
                validUntil: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/penalties",
    alias: "penaltyListAll",
    description: `List all penalties across all suppliers`,
    requestFormat: "json",
    parameters: [
      {
        name: "process",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "legalName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "document",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "pennID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierPenaltyView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/penalty-scopes",
    alias: "penaltyScopeList",
    description: `List all penalty scopes`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "scopID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierPenaltyScope
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/penalty-scopes",
    alias: "penaltyScopeCreate",
    description: `Create one penalty scope`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: penaltyScopeCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                label: z.string(),
                scopID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/penalty-scopes/:scopID",
    alias: "penaltyScopeDelete",
    description: `Delete one penalty scope`,
    requestFormat: "json",
    parameters: [
      {
        name: "scopID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                label: z.string(),
                scopID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/penalty-scopes/:scopID",
    alias: "penaltyScopeGet",
    description: `Get one penalty scope`,
    requestFormat: "json",
    parameters: [
      {
        name: "scopID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                label: z.string(),
                scopID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/penalty-scopes/:scopID",
    alias: "penaltyScopeUpdate",
    description: `Update one penalty scope`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: penaltyScopeCreate_Body,
      },
      {
        name: "scopID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                label: z.string(),
                scopID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/permission/:acplID/action-plan",
    alias: "actionPlanPermissionGet",
    description: `Get action plan permission`,
    requestFormat: "json",
    parameters: [
      {
        name: "acplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "readonly",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.boolean(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/permission/:actiID/action",
    alias: "actionPermissionGet",
    description: `Get action permission`,
    requestFormat: "json",
    parameters: [
      {
        name: "actiID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "readonly",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.boolean(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/permission/:bumeID/business-metric",
    alias: "businessMetricPermissionGet",
    description: `Get business metric permission`,
    requestFormat: "json",
    parameters: [
      {
        name: "bumeID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "readonly",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.boolean(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/permission/:progID/programs",
    alias: "programPermissionGet",
    description: `Get program permission`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "readonly",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.boolean(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/permission/:projID/projects",
    alias: "projectPermissionGet",
    description: `Get project permission`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "readonly",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.boolean(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/physical-conditions",
    alias: "physicalConditionList",
    description: `Lists all physical_conditions`,
    requestFormat: "json",
    parameters: [
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "phcoID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_PhysicalConditionView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/physical-conditions",
    alias: "physicalConditionCreate",
    description: `Create one physical_condition`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                phcoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/physical-conditions/:phcoID",
    alias: "physicalConditionDelete",
    description: `Delete one physical_condition by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "phcoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                phcoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/physical-conditions/:phcoID",
    alias: "physicalConditionGet",
    description: `Get one physical_condition`,
    requestFormat: "json",
    parameters: [
      {
        name: "phcoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                phcoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/physical-conditions/:phcoID",
    alias: "physicalConditionUpdate",
    description: `Update physical_condition`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "phcoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                phcoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/plans",
    alias: "plansList",
    description: `Lists all plans`,
    requestFormat: "json",
    parameters: [
      {
        name: "isDefault",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "IncludeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_PlanView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/plans",
    alias: "plansCreate",
    description: `Create one plan`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: plansCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                endAt: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                institutionUserName: z.string(),
                inusID: z.number(),
                isDefault: z.boolean(),
                name: z.string(),
                planID: z.string(),
                planUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                startAt: z.string(),
                thaxID: z.array(z.number()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/plans/:planID",
    alias: "plansDelete",
    description: `Delete one plan by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                endAt: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                institutionUserName: z.string(),
                inusID: z.number(),
                isDefault: z.boolean(),
                name: z.string(),
                planID: z.string(),
                planUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                startAt: z.string(),
                thaxID: z.array(z.number()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/plans/:planID",
    alias: "plansGet",
    description: `Get one plan`,
    requestFormat: "json",
    parameters: [
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                endAt: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                institutionUserName: z.string(),
                inusID: z.number(),
                isDefault: z.boolean(),
                name: z.string(),
                planID: z.string(),
                planUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                startAt: z.string(),
                thaxID: z.array(z.number()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/plans/:planID",
    alias: "plansUpdate",
    description: `Update one plan`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: plansCreate_Body,
      },
      {
        name: "planID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                endAt: z.string(),
                instID: z.string(),
                institutionName: z.string(),
                institutionUserName: z.string(),
                inusID: z.number(),
                isDefault: z.boolean(),
                name: z.string(),
                planID: z.string(),
                planUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                startAt: z.string(),
                thaxID: z.array(z.number()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/plans/import",
    alias: "plansImport",
    description: `Import and update plans and their children.`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                importedActionPlans: z.array(z.string()),
                importedActions: z.array(z.string()),
                importedBusinessMetric: z.array(z.number()),
                importedPlans: z.array(z.string()),
                importedPrograms: z.array(z.string()),
                importedProjects: z.array(z.string()),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs",
    alias: "programList",
    description: `Lists all programs`,
    requestFormat: "json",
    parameters: [
      {
        name: "statusState",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "orderAsc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "nearDeadline",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "inusID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "mostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "groupedLimit",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "linkedUserID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institution",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "periodStart[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "statID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "periodEnd[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "periodEnd[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "periodStart[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "orderDesc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "content",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inCharge",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "overdue",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProgramView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/programs",
    alias: "programCreate",
    description: `Create new program`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: programCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string().nullish(),
                institutions: z.array(z.string()),
                inusID: z.number().nullish(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string(),
                programUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProgramUserView
                ),
                projectCount: z.number(),
                projectDoneCount: z.number(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusMessage: z.string(),
                statusOrderIndex: z.number(),
                statusReferenceDate: z.string(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/programs/:progID",
    alias: "programDelete",
    description: `Delete one program by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                inusID: z.number().nullish(),
                name: z.string(),
                planID: z.string(),
                progID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs/:progID",
    alias: "programGet",
    description: `Get one program`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string().nullish(),
                institutions: z.array(z.string()),
                inusID: z.number().nullish(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string(),
                programUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProgramUserView
                ),
                projectCount: z.number(),
                projectDoneCount: z.number(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusMessage: z.string(),
                statusOrderIndex: z.number(),
                statusReferenceDate: z.string(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/programs/:progID",
    alias: "programUpdate",
    description: `Update one program`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: programCreate_Body,
      },
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string().nullish(),
                institutions: z.array(z.string()),
                inusID: z.number().nullish(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string(),
                programUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProgramUserView
                ),
                projectCount: z.number(),
                projectDoneCount: z.number(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusMessage: z.string(),
                statusOrderIndex: z.number(),
                statusReferenceDate: z.string(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs/:progID/comment",
    alias: "programCommentList",
    description: `Lists all program comments`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "commID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "message",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProgramCommentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/programs/:progID/comment",
    alias: "programCommentCreate",
    description: `Create new program comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanCommentCreate_Body,
      },
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                progID: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/programs/:progID/comment/:commID",
    alias: "programCommentDelete",
    description: `Delete one program comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                progID: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs/:progID/comment/:commID",
    alias: "programCommentGet",
    description: `Get one program comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                progID: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs/:progID/history/budget",
    alias: "programBudgetHistory",
    description: `Lists all program budget`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProgramBudgetHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs/:progID/history/period",
    alias: "programPeriodHistory",
    description: `Lists all program periods`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProgramPeriodHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/programs/:progID/history/status",
    alias: "programStatusHistory",
    description: `Lists all program status`,
    requestFormat: "json",
    parameters: [
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProgramStatusHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "patch",
    path: "/api/programs/:progID/status",
    alias: "programStatusUpdate",
    description: `Update only program status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: programStatusUpdate_Body,
      },
      {
        name: "progID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                instID: z.string().nullish(),
                institutionAbbreviation: z.string().nullish(),
                institutionName: z.string().nullish(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string().nullish(),
                institutions: z.array(z.string()),
                inusID: z.number().nullish(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string(),
                programUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProgramUserView
                ),
                projectCount: z.number(),
                projectDoneCount: z.number(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusMessage: z.string(),
                statusOrderIndex: z.number(),
                statusReferenceDate: z.string(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects",
    alias: "projectList",
    description: `Lists all projects`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "content",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "groupedLimit",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "inusID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "nearDeadline",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "orderDesc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "progID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "inCharge",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "overdue",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "statID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "userName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institution",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "acplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "mostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "orderAsc",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "statusState",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "searchText",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "linkedUserID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProjectView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/projects",
    alias: "projectCreate",
    description: `Create new project`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: projectCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionPlanCount: z.number(),
                actionPlanDoneCount: z.number(),
                attachment: z.string().nullish(),
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                status: z
                  .object({
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    projID: z.string(),
                    prstID: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/projects/:projID",
    alias: "projectDelete",
    description: `Delete one project by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionPlanCount: z.number(),
                actionPlanDoneCount: z.number(),
                attachment: z.string().nullish(),
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                status: z
                  .object({
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    projID: z.string(),
                    prstID: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/:projID",
    alias: "projectGet",
    description: `Get one project`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionPlanCount: z.number(),
                actionPlanDoneCount: z.number(),
                attachment: z.string().nullish(),
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                status: z
                  .object({
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    projID: z.string(),
                    prstID: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/projects/:projID",
    alias: "projectUpdate",
    description: `Update one project`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: projectUpdate_Body,
      },
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                actionPlanCount: z.number(),
                actionPlanDoneCount: z.number(),
                attachment: z.string().nullish(),
                axes: z.array(z.number()),
                budgets: z.array(
                  z
                    .object({
                      actual: z.string(),
                      attachments: z.array(z.string()),
                      brtyID: z.number().nullish(),
                      budgID: z.string(),
                      busoID: z.number(),
                      butyID: z.number().nullish(),
                      predicted: z.string(),
                      rationale: z.string().nullish(),
                      received: z.string(),
                      referenceYear: z.string().nullish(),
                    })
                    .passthrough()
                ),
                content: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                instID: z.string(),
                institutionAbbreviation: z.string(),
                institutionName: z.string(),
                institutionUserAvatar: z.string().nullish(),
                institutionUserEmail: z.string().nullish(),
                institutionUserName: z.string(),
                institutions: z.array(z.string()),
                inusID: z.number(),
                milestoneCount: z.number(),
                milestoneDoneCount: z.number(),
                mostID: z.number().nullish(),
                mostOrderIndex: z.number(),
                name: z.string(),
                period: z
                  .object({
                    endAt: z.string(),
                    oppeID: z.number(),
                    startAt: z.string(),
                  })
                  .passthrough(),
                planID: z.string(),
                progID: z.string().nullish(),
                projID: z.string(),
                projectUsers: z.array(
                  github_com_falqondev_cidade360_backend_service_ProjetcUserView
                ),
                status: z
                  .object({
                    approvedBy: z.string().nullish(),
                    approverName: z.string().nullish(),
                    attachments: z.array(z.string()),
                    deletedAt: z.string().nullish(),
                    info: z
                      .object({
                        displayOptions: z
                          .object({ color: z.string() })
                          .passthrough()
                          .nullable(),
                      })
                      .partial()
                      .passthrough(),
                    message: z.string(),
                    orderIndex: z.number(),
                    projID: z.string(),
                    prstID: z.number(),
                    referenceDate: z.string(),
                    requestReview: z.boolean(),
                    reviewMessage: z.string(),
                    statID: z.number(),
                    state: z.string(),
                    status: z.string(),
                    userID: z.string(),
                    userName: z.string(),
                  })
                  .passthrough(),
                thematicAxisInfo: z.array(
                  z
                    .object({
                      displayOptions: z
                        .object({ color: z.string() })
                        .passthrough()
                        .nullish(),
                      thaxID: z.number(),
                    })
                    .passthrough()
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/:projID/comment",
    alias: "projectCommentList",
    description: `Lists all project comments`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "message",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "commID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProjectCommentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/projects/:projID/comment",
    alias: "projectCommentCreate",
    description: `Create new project comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanCommentCreate_Body,
      },
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                projID: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/projects/:projID/comment/:commID",
    alias: "projectCommentDelete",
    description: `Delete one project comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                projID: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/:projID/comment/:commID",
    alias: "projectCommentGet",
    description: `Get one project comment`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "commID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                attachment: z.string().nullish(),
                commID: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                message: z.string(),
                projID: z.string(),
                userAvatar: z.string().nullish(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/:projID/history/budget",
    alias: "projectBudgetHistory",
    description: `Lists all project budget`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProjectBudgetHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/:projID/history/period",
    alias: "projectPeriodHistory",
    description: `Lists all project periods`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProjectPeriodHistory
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/:projID/history/status",
    alias: "projectStatusHistory",
    description: `Lists all project status`,
    requestFormat: "json",
    parameters: [
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProjectStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/projects/:projID/status",
    alias: "projectStatusUpdate",
    description: `Update one project status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: actionPlanStatusUpdate_Body,
      },
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                approvedBy: z.string().nullish(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                message: z.string(),
                orderIndex: z.number(),
                projID: z.string(),
                projectName: z.string(),
                prstID: z.number(),
                referenceDate: z.string(),
                requestReview: z.boolean(),
                reviewMessage: z.string(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/projects/:projID/status/review",
    alias: "projectStatusApprove",
    description: `Update one project status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: projectStatusApprove_Body,
      },
      {
        name: "projID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                approvedBy: z.string().nullish(),
                approverName: z.string().nullish(),
                attachments: z.array(z.string()),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                message: z.string(),
                orderIndex: z.number(),
                projID: z.string(),
                projectName: z.string(),
                prstID: z.number(),
                referenceDate: z.string(),
                requestReview: z.boolean(),
                reviewMessage: z.string(),
                statID: z.number(),
                state: z.string(),
                status: z.string(),
                userID: z.string(),
                userName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/projects/status/pending-approval",
    alias: "projectStatusPendingApprovalList",
    description: `Lists all project status pending`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "projID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ProjectStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/public-equipments",
    alias: "publicEquipmentList",
    description: `Lists all public_equipments`,
    requestFormat: "json",
    parameters: [
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "pueqID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_PublicEquipmentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/public-equipments",
    alias: "publicEquipmentCreate",
    description: `Create one public_equipment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                pueqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/public-equipments/:pueqID",
    alias: "publicEquipmentDelete",
    description: `Delete one public_equipment by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "pueqID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                pueqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/public-equipments/:pueqID",
    alias: "publicEquipmentGet",
    description: `Get one public_equipment`,
    requestFormat: "json",
    parameters: [
      {
        name: "pueqID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                pueqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/public-equipments/:pueqID",
    alias: "publicEquipmentUpdate",
    description: `Update public_equipment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "pueqID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                pueqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/requesting-company",
    alias: "requestingCompanyList",
    description: `Lists all requesting_companys`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "recoID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_RequestingCompanyView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/requesting-company",
    alias: "requestingCompanyCreate",
    description: `Create one requesting_company`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                recoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/requesting-company/:recoID",
    alias: "requestingCompanyDelete",
    description: `Delete one requesting_company by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "recoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                recoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/requesting-company/:recoID",
    alias: "requestingCompanyGet",
    description: `Get one requesting_company`,
    requestFormat: "json",
    parameters: [
      {
        name: "recoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                recoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/requesting-company/:recoID",
    alias: "requestingCompanyUpdate",
    description: `Update requesting_company`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "recoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                recoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/service-channel",
    alias: "serviceChannelList",
    description: `Lists all service_channels`,
    requestFormat: "json",
    parameters: [
      {
        name: "sechID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ServiceChannelView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/service-channel",
    alias: "serviceChannelCreate",
    description: `Create one service_channel`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                sechID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/service-channel/:sechID",
    alias: "serviceChannelDelete",
    description: `Delete one service_channel by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "sechID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                sechID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/service-channel/:sechID",
    alias: "serviceChannelGet",
    description: `Get one service_channel`,
    requestFormat: "json",
    parameters: [
      {
        name: "sechID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                sechID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/service-channel/:sechID",
    alias: "serviceChannelUpdate",
    description: `Update service_channel`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "sechID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                sechID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/status",
    alias: "statusList",
    description: `Lists all status`,
    requestFormat: "json",
    parameters: [
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "statID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "defaultStatus",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_StatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/status",
    alias: "statusCreate",
    description: `Create one status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: statusCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                orderIndex: z.number(),
                requestReview: z.boolean(),
                slug: z.string(),
                statID: z.number(),
                state: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/status/:statID",
    alias: "statusDelete",
    description: `Delete one status by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "statID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                orderIndex: z.number(),
                requestReview: z.boolean(),
                slug: z.string(),
                statID: z.number(),
                state: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/status/:statID",
    alias: "statusGet",
    description: `Get one status`,
    requestFormat: "json",
    parameters: [
      {
        name: "statID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                defaultStatus: z.boolean(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                orderIndex: z.number(),
                requestReview: z.boolean(),
                slug: z.string(),
                statID: z.number(),
                state: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/status/:statID",
    alias: "statusUpdate",
    description: `Update status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: statusCreate_Body,
      },
      {
        name: "statID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                orderIndex: z.number(),
                requestReview: z.boolean(),
                slug: z.string(),
                statID: z.number(),
                state: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/status/:statID/reorder",
    alias: "statusReorder",
    description: `reorder status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: kanbanLinksCreate_Body,
      },
      {
        name: "statID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_StatusLinkView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-banks",
    alias: "supplierBankList",
    description: `List all supplier banks`,
    requestFormat: "json",
    parameters: [
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "code",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subaID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierBank
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier-banks",
    alias: "supplierBankCreate",
    description: `Create one supplier bank`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierBankCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                code: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                subaID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/supplier-banks/:subaID",
    alias: "supplierBankDelete",
    description: `Delete one supplier bank`,
    requestFormat: "json",
    parameters: [
      {
        name: "subaID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                code: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                subaID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-banks/:subaID",
    alias: "supplierBankGet",
    description: `Get one supplier bank`,
    requestFormat: "json",
    parameters: [
      {
        name: "subaID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                code: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                subaID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/supplier-banks/:subaID",
    alias: "supplierBankUpdate",
    description: `Update one supplier bank`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierBankCreate_Body,
      },
      {
        name: "subaID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                code: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                subaID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-class-groups",
    alias: "supplierClassGroupList",
    description: `List all supplier class groups`,
    requestFormat: "json",
    parameters: [
      {
        name: "clgrID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierClassGroup
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier-class-groups",
    alias: "supplierClassGroupCreate",
    description: `Create one supplier class group`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ label: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                label: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/supplier-class-groups/:clgrID",
    alias: "supplierClassGroupDelete",
    description: `Delete one supplier class group`,
    requestFormat: "json",
    parameters: [
      {
        name: "clgrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                label: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-class-groups/:clgrID",
    alias: "supplierClassGroupGet",
    description: `Get one supplier class group`,
    requestFormat: "json",
    parameters: [
      {
        name: "clgrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                label: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/supplier-class-groups/:clgrID",
    alias: "supplierClassGroupUpdate",
    description: `Update one supplier class group`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ label: z.string() }).passthrough(),
      },
      {
        name: "clgrID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                label: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-class-sub-groups",
    alias: "supplierClassSubGroupList",
    description: `List all supplier class sub groups`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "clgrID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "scsgID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierClassSubGroup
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier-class-sub-groups",
    alias: "supplierClassSubGroupCreate",
    description: `Create one supplier class sub group`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierClassSubGroupCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/supplier-class-sub-groups/:scsgID",
    alias: "supplierClassSubGroupDelete",
    description: `Delete one supplier class sub group`,
    requestFormat: "json",
    parameters: [
      {
        name: "scsgID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-class-sub-groups/:scsgID",
    alias: "supplierClassSubGroupGet",
    description: `Get one supplier class sub group`,
    requestFormat: "json",
    parameters: [
      {
        name: "scsgID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/supplier-class-sub-groups/:scsgID",
    alias: "supplierClassSubGroupUpdate",
    description: `Update one supplier class sub group`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierClassSubGroupCreate_Body,
      },
      {
        name: "scsgID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clgrID: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-classes",
    alias: "supplierClassList",
    description: `List all supplier classes`,
    requestFormat: "json",
    parameters: [
      {
        name: "scsgID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "clasID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierClass
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/supplier-classes",
    alias: "supplierClassCreate",
    description: `Create one supplier class`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierClassCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clasID: z.string(),
                code: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/supplier-classes/:clasID",
    alias: "supplierClassDelete",
    description: `Delete one supplier class`,
    requestFormat: "json",
    parameters: [
      {
        name: "clasID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clasID: z.string(),
                code: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/supplier-classes/:clasID",
    alias: "supplierClassGet",
    description: `Get one supplier class`,
    requestFormat: "json",
    parameters: [
      {
        name: "clasID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clasID: z.string(),
                code: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/supplier-classes/:clasID",
    alias: "supplierClassUpdate",
    description: `Update one supplier class`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierClassCreate_Body,
      },
      {
        name: "clasID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clasID: z.string(),
                code: z.string(),
                label: z.string(),
                scsgID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers",
    alias: "supplierList",
    description: `Lists all supplier registries`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "bstpID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "hasActivePenalty",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "document",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "personType",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "businessTypeName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierRegistry
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID",
    alias: "supplierGet",
    description: `Get one supplier registry`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                additionalAddressInfo: z.string().nullish(),
                address: z.string().nullish(),
                addressNumber: z.number().nullish(),
                bankName: z.string().nullish(),
                branch: z.string().nullish(),
                bstpID: z.string().nullish(),
                businessTypeName: z.string().nullish(),
                checkingAccount: z.string().nullish(),
                city: z.string().nullish(),
                cnpj: z.string().nullish(),
                country: z.string().nullish(),
                cpf: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                firstName: z.string().nullish(),
                lastName: z.string().nullish(),
                legalName: z.string().nullish(),
                municipalRegistration: z.string().nullish(),
                neighborhood: z.string().nullish(),
                personType: z.string(),
                phone: z.string().nullish(),
                postalCode: z.string().nullish(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                state: z.string().nullish(),
                stateRegistration: z.string().nullish(),
                status: z.string(),
                subaID: z.string().nullish(),
                tradeName: z.string().nullish(),
                updatedAt: z.string(),
                userID: z.string().nullish(),
                verifiedEmail: z.boolean().nullish(),
                verifiedPhone: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID/documents",
    alias: "supplierListDocuments",
    description: `List documents for a supplier`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "doctID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/suppliers/:spplID/documents/:spdcID/human-review",
    alias: "supplierHumanReviewDocument",
    description: `Finalize a supplier document review`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierHumanReviewDocument_Body,
      },
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                spdcID: z.string(),
                spdsID: z.string(),
                status: z.string(),
                validationResult: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID/documents/:spdcID/media-auth",
    alias: "supplierGetDocumentMediaAuth",
    description: `Get media auth for a supplier document`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/suppliers/:spplID/documents/:spdcID/status",
    alias: "supplierUpdateDocumentStatus",
    description: `Update a non-final supplier document status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierUpdateDocumentStatus_Body,
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                current: z.boolean(),
                detail: z.string().nullish(),
                reviewedBy: z.string().nullish(),
                spdcID: z.string(),
                spdsID: z.string(),
                status: z.string(),
                validationResult: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID/documents/:spdcID/verification",
    alias: "supplierGetDocumentVerification",
    description: `Get supplier document verification evidence`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAttemptID: z.string().nullish(),
                aiResult: z
                  .object({
                    fields: z.array(
                      github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationFieldResult
                    ),
                    reason: z.string(),
                    status: z.string(),
                  })
                  .passthrough()
                  .nullish(),
                attempts: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationAttempt
                  )
                  .nullish(),
                completedAt: z.string().nullish(),
                createdAt: z.string(),
                currentStage: z.string().nullish(),
                currentStatus: z.string(),
                currentStatusID: z.string(),
                cycleNumber: z.number(),
                documentID: z.string(),
                enqueuedAt: z.string().nullish(),
                errorCode: z.string().nullish(),
                events: z
                  .array(
                    github_com_falqondev_cidade360_backend_service_SupplierDocumentVerificationEvent
                  )
                  .nullish(),
                executionState: z.string(),
                extractedTextBytes: z.number().nullish(),
                failureCount: z.number(),
                lastDiagnostic: z
                  .object({
                    causes: z.array(z.string()),
                    code: z.string(),
                    createdAt: z.string(),
                    message: z.string(),
                    stage: z.string(),
                    version: z.number(),
                  })
                  .passthrough()
                  .nullish(),
                model: z.string().nullish(),
                provider: z.string().nullish(),
                resultSource: z.string().nullish(),
                scheduledAt: z.string(),
                startedAt: z.string().nullish(),
                updatedAt: z.string(),
                verificationID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/suppliers/:spplID/documents/:spdcID/verification/reprocess",
    alias: "supplierReprocessDocumentVerification",
    description: `Start a new supplier document verification cycle`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierReprocessDocumentVerification_Body,
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "spdcID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                alreadyExists: z.boolean(),
                attemptID: z.string(),
                cycle: z.number(),
                verificationID: z.string(),
                workflowID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID/penalties",
    alias: "supplierPenaltyList",
    description: `List penalties for a supplier`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "legalName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "document",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "pennID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "process",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierPenalty
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/suppliers/:spplID/penalties",
    alias: "supplierPenaltyCreate",
    description: `Create a penalty for a supplier`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierPenaltyCreate_Body,
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                complement: z.string().nullish(),
                contractNumber: z.string().nullish(),
                createdAt: z.string(),
                decisionType: z.string().nullish(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                dom: z.string(),
                endDate: z.string(),
                legalBasis: z.string(),
                legalBasisDescription: z.string().nullish(),
                pennID: z.string(),
                process: z.string(),
                publishingDate: z.string(),
                sanctionType: z.string(),
                scopID: z.string(),
                spplID: z.string(),
                startDate: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/suppliers/:spplID/penalties/:pennID",
    alias: "supplierPenaltyDelete",
    description: `Delete a supplier penalty`,
    requestFormat: "json",
    parameters: [
      {
        name: "pennID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                complement: z.string().nullish(),
                contractNumber: z.string().nullish(),
                createdAt: z.string(),
                decisionType: z.string().nullish(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                dom: z.string(),
                endDate: z.string(),
                legalBasis: z.string(),
                legalBasisDescription: z.string().nullish(),
                pennID: z.string(),
                process: z.string(),
                publishingDate: z.string(),
                sanctionType: z.string(),
                scopID: z.string(),
                spplID: z.string(),
                startDate: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/suppliers/:spplID/penalties/:pennID",
    alias: "supplierPenaltyUpdate",
    description: `Update a supplier penalty`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierPenaltyCreate_Body,
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "pennID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                complement: z.string().nullish(),
                contractNumber: z.string().nullish(),
                createdAt: z.string(),
                decisionType: z.string().nullish(),
                deletedAt: z.string().nullish(),
                description: z.string().nullish(),
                dom: z.string(),
                endDate: z.string(),
                legalBasis: z.string(),
                legalBasisDescription: z.string().nullish(),
                pennID: z.string(),
                process: z.string(),
                publishingDate: z.string(),
                sanctionType: z.string(),
                scopID: z.string(),
                spplID: z.string(),
                startDate: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/suppliers/:spplID/penalties/:pennID/attachment/media-auth",
    alias: "supplierPenaltyGetAttachmentUploadMediaAuth",
    description: `Get media auth to upload a supplier penalty attachment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "pennID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID/penalties/:pennID/media-auth",
    alias: "supplierPenaltyGetAttachmentMediaAuth",
    description: `Get media auth for a supplier penalty attachment`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "pennID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ file: z.string(), jwt: z.string() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/suppliers/:spplID/registry-status",
    alias: "supplierUpdateStatus",
    description: `Approve or reject a supplier registry`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: supplierUpdateStatus_Body,
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                additionalAddressInfo: z.string().nullish(),
                address: z.string().nullish(),
                addressNumber: z.number().nullish(),
                bankName: z.string().nullish(),
                branch: z.string().nullish(),
                bstpID: z.string().nullish(),
                businessTypeName: z.string().nullish(),
                checkingAccount: z.string().nullish(),
                city: z.string().nullish(),
                cnpj: z.string().nullish(),
                country: z.string().nullish(),
                cpf: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                firstName: z.string().nullish(),
                lastName: z.string().nullish(),
                legalName: z.string().nullish(),
                municipalRegistration: z.string().nullish(),
                neighborhood: z.string().nullish(),
                personType: z.string(),
                phone: z.string().nullish(),
                postalCode: z.string().nullish(),
                registryStatus: z.string().nullish(),
                spplID: z.string(),
                state: z.string().nullish(),
                stateRegistration: z.string().nullish(),
                status: z.string(),
                subaID: z.string().nullish(),
                tradeName: z.string().nullish(),
                updatedAt: z.string(),
                userID: z.string().nullish(),
                verifiedEmail: z.boolean().nullish(),
                verifiedPhone: z.boolean().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/:spplID/review-notes",
    alias: "reviewNoteList",
    description: `List review notes for a supplier`,
    requestFormat: "json",
    parameters: [
      {
        name: "spplID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ManagerReviewNote
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/suppliers/:spplID/review-notes",
    alias: "reviewNoteCreate",
    description: `Create a review note for a supplier`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ note: z.string() }).passthrough(),
      },
      {
        name: "spplID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                mrvnID: z.string(),
                note: z.string().nullish(),
                spplID: z.string(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/suppliers/documents/expiring",
    alias: "supplierListExpiringDocuments",
    description: `List approved supplier documents expiring within 90 days`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SupplierExpiringDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey-form-templates",
    alias: "surveyTemplatesCreate",
    description: `Create one survey form template`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: documentTemplateCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ doteID: z.string(), suftID: z.number() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/survey-responses",
    alias: "surveyResponseList",
    description: `List survey response`,
    requestFormat: "json",
    parameters: [
      {
        name: "submitted",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "survID",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SurveyResponseListing
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey-responses",
    alias: "surveyResponseCreate",
    description: `Create one survey response`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: surveyResponseCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                clientDevice: z.string(),
                clientIP: z.string(),
                clientUID: z.string(),
                createdAt: z.string(),
                docuID: z.string(),
                doteID: z.string(),
                metadata: z.unknown(),
                sureID: z.number(),
                sursID: z.string(),
                survID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/survey-responses/download/:survID",
    alias: "surveyResponseDownload",
    description: `Get answer export file`,
    requestFormat: "json",
    parameters: [
      {
        name: "survID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "submitted",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "fileName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/survey-responses/my",
    alias: "surveyMyResponseList",
    description: `List survey response`,
    requestFormat: "json",
    parameters: [
      {
        name: "survID",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "submitted",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_SurveyResponseListing
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/survey-responses/my/:sursID",
    alias: "surveyMyResponseGet",
    description: `Get one survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "sursID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                name: z.string(),
                responses: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyResponseData
                ),
                submittedAt: z.string().nullish(),
                sursID: z.string(),
                survID: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey/session",
    alias: "surveyCreateSession",
    description: `Create new survey session`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ survID: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                submittedAt: z.string().nullish(),
                sursID: z.string(),
                survID: z.string(),
                userID: z.string().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/survey/submit",
    alias: "surveySubmit",
    description: `submit response`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ sursID: z.string() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/surveys",
    alias: "surveyList",
    description: `Lists all surveys`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "survID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "slug",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "title",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_Survey
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/surveys",
    alias: "surveyCreate",
    description: `Create one survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: surveyCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAt: z.string().nullish(),
                allowedUsers: z.array(z.string()),
                answers: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                descriptionFinished: z.string(),
                displayOptions: z.unknown(),
                drafts: z.number(),
                slug: z.string(),
                survID: z.string(),
                surveyForms: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyForm
                ),
                title: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/surveys/:survID",
    alias: "surveyDelete",
    description: `Delete one survey by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "survID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAt: z.string().nullish(),
                allowedUsers: z.array(z.string()),
                answers: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                descriptionFinished: z.string(),
                displayOptions: z.unknown(),
                drafts: z.number(),
                slug: z.string(),
                survID: z.string(),
                surveyForms: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyForm
                ),
                title: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/surveys/:survID",
    alias: "surveyGet",
    description: `Get one survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "survID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAt: z.string().nullish(),
                allowedUsers: z.array(z.string()),
                answers: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                descriptionFinished: z.string(),
                displayOptions: z.unknown(),
                drafts: z.number(),
                slug: z.string(),
                survID: z.string(),
                surveyForms: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyForm
                ),
                title: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/surveys/:survID",
    alias: "surveyUpdate",
    description: `Update survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: surveyCreate_Body,
      },
      {
        name: "survID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAt: z.string().nullish(),
                allowedUsers: z.array(z.string()),
                answers: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                descriptionFinished: z.string(),
                displayOptions: z.unknown(),
                drafts: z.number(),
                slug: z.string(),
                survID: z.string(),
                surveyForms: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyForm
                ),
                title: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/surveys/my",
    alias: "surveyMyList",
    description: `List my polls`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "survID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "slug",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "title",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_MySurvey
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/surveys/my/:survID",
    alias: "surveyMyGet",
    description: `Get one survey`,
    requestFormat: "json",
    parameters: [
      {
        name: "survID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                activeAt: z.string().nullish(),
                answers: z.number(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                descriptionFinished: z.string(),
                displayOptions: z.unknown(),
                drafts: z.number(),
                slug: z.string(),
                survID: z.string(),
                surveyForms: z.array(
                  github_com_falqondev_cidade360_backend_service_SurveyForm
                ),
                title: z.string(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/term/accept",
    alias: "termAccept",
    description: `Accept a term`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ termID: z.number() }).passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                accepted: z.boolean(),
                termID: z.number(),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/term/pending",
    alias: "termGetPending",
    description: `get all pending terms`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                terms: z.array(
                  github_com_falqondev_cidade360_backend_service_PendingTerm
                ),
                userID: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/terms",
    alias: "termList",
    description: `Lists all terms`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "slug",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "title",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "active",
        type: "Query",
        schema: z.boolean().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(github_com_falqondev_cidade360_backend_service_Term),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/terms",
    alias: "termCreate",
    description: `Create one term`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: termCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                slug: z.string(),
                termID: z.number(),
                title: z.string(),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/terms/:termID",
    alias: "termDelete",
    description: `Delete one term by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "termID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                slug: z.string(),
                termID: z.number(),
                title: z.string(),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/terms/:termID",
    alias: "termGet",
    description: `Get one term`,
    requestFormat: "json",
    parameters: [
      {
        name: "termID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                slug: z.string(),
                termID: z.number(),
                title: z.string(),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/terms/:termID",
    alias: "termUpdate",
    description: `Update term`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: termCreate_Body,
      },
      {
        name: "termID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                slug: z.string(),
                termID: z.number(),
                title: z.string(),
                type: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/thematic-axes",
    alias: "thematicAxisList",
    description: `Lists all thematic axes`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "planID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "thaxID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_ThematicAxis
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/thematic-axes",
    alias: "thematicAxisCreate",
    description: `Create one thematic axis`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: thematicAxisCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                thaxID: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/thematic-axes/:thaxID",
    alias: "thematicAxisDelete",
    description: `Delete one thematic axis by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "thaxID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                thaxID: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/thematic-axes/:thaxID",
    alias: "thematicAxisGet",
    description: `Get one thematic axis`,
    requestFormat: "json",
    parameters: [
      {
        name: "thaxID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                thaxID: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/thematic-axes/:thaxID",
    alias: "thematicAxisUpdate",
    description: `Update thematic axis`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: thematicAxisCreate_Body,
      },
      {
        name: "thaxID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                thaxID: z.number(),
                updatedAt: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/tour-completed",
    alias: "userSetTourCompleted",
    description: `Update user&#x27;s tour completed status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ tourCompleted: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/urban-equipments",
    alias: "urbanEquipmentList",
    description: `Lists all urban_equipments`,
    requestFormat: "json",
    parameters: [
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "ureqID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_UrbanEquipmentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/urban-equipments",
    alias: "urbanEquipmentCreate",
    description: `Create one urban_equipment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                ureqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/urban-equipments/:ureqID",
    alias: "urbanEquipmentDelete",
    description: `Delete one urban_equipment by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "ureqID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                ureqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/urban-equipments/:ureqID",
    alias: "urbanEquipmentGet",
    description: `Get one urban_equipment`,
    requestFormat: "json",
    parameters: [
      {
        name: "ureqID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                ureqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/urban-equipments/:ureqID",
    alias: "urbanEquipmentUpdate",
    description: `Update urban_equipment`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "ureqID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                ureqID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/user-roles",
    alias: "userRoleCreate",
    description: `Create new user userRole`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: userRoleCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ roles: z.array(z.string()), userID: z.string() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/user-roles",
    alias: "userRoleUpdate",
    description: `Update one userRole`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: userRoleCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({ roles: z.array(z.string()), userID: z.string() })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/user-roles/permissions",
    alias: "userRoleGetPermissions",
    description: `Lists all available permissions grouped by module`,
    requestFormat: "json",
    parameters: [
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_PermissionModule
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/users",
    alias: "userList",
    description: `Lists all users`,
    requestFormat: "json",
    parameters: [
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "email",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "applID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "keywords",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "userID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "deleted",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "aproID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_UserInformation
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/users",
    alias: "userCreate",
    description: `Create new user`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: userCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                authenticationProvider: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                name: z.string(),
                phone: z.string().nullish(),
                pushTokens: z.array(z.string()).nullish(),
                roles: z.array(z.string()),
                userID: z.string(),
                userInstitutions: z.array(
                  github_com_falqondev_cidade360_backend_service_UserInstitutions
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/users/:userID",
    alias: "userDelete",
    description: `Delete one user`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                authenticationProvider: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                name: z.string(),
                phone: z.string().nullish(),
                pushTokens: z.array(z.string()).nullish(),
                roles: z.array(z.string()),
                userID: z.string(),
                userInstitutions: z.array(
                  github_com_falqondev_cidade360_backend_service_UserInstitutions
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/users/:userID",
    alias: "userGet",
    description: `Get one user by userID`,
    requestFormat: "json",
    parameters: [
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                authenticationProvider: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                name: z.string(),
                phone: z.string().nullish(),
                pushTokens: z.array(z.string()).nullish(),
                roles: z.array(z.string()),
                userID: z.string(),
                userInstitutions: z.array(
                  github_com_falqondev_cidade360_backend_service_UserInstitutions
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "patch",
    path: "/api/users/:userID",
    alias: "userUpdate",
    description: `Update one user`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: userUpdate_Body,
      },
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                authenticationProvider: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                name: z.string(),
                phone: z.string().nullish(),
                pushTokens: z.array(z.string()).nullish(),
                roles: z.array(z.string()),
                userID: z.string(),
                userInstitutions: z.array(
                  github_com_falqondev_cidade360_backend_service_UserInstitutions
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/users/:userID/2fa",
    alias: "twofactorAdminReset",
    description: `Reset (disable) 2FA for a specific user`,
    requestFormat: "json",
    parameters: [
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.object({ disabled: z.boolean() }).passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/users/:userID/enable",
    alias: "userEnable",
    description: `Enable a deleted user`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "userID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applID: z.string(),
                authenticationProvider: z.string(),
                avatar: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                email: z.string().nullish(),
                info: z.object({ tourCompleted: z.boolean() }).passthrough(),
                name: z.string(),
                phone: z.string().nullish(),
                pushTokens: z.array(z.string()).nullish(),
                roles: z.array(z.string()),
                userID: z.string(),
                userInstitutions: z.array(
                  github_com_falqondev_cidade360_backend_service_UserInstitutions
                ),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/vulnerable-populations",
    alias: "vulnerablePopulationList",
    description: `Lists all vulnerable_populations`,
    requestFormat: "json",
    parameters: [
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "vupoID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_VulnerablePopulationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/vulnerable-populations",
    alias: "vulnerablePopulationCreate",
    description: `Create one vulnerable_population`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                vupoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/vulnerable-populations/:vupoID",
    alias: "vulnerablePopulationDelete",
    description: `Delete one vulnerable_population by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "vupoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                vupoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/vulnerable-populations/:vupoID",
    alias: "vulnerablePopulationGet",
    description: `Get one vulnerable_population`,
    requestFormat: "json",
    parameters: [
      {
        name: "vupoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                vupoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/vulnerable-populations/:vupoID",
    alias: "vulnerablePopulationUpdate",
    description: `Update vulnerable_population`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "vupoID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                vupoID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-classifications",
    alias: "workOrderClassificationList",
    description: `Lists all work_order_classifications`,
    requestFormat: "json",
    parameters: [
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "woclID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderClassificationView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-order-classifications",
    alias: "workOrderClassificationCreate",
    description: `Create one work_order_classification`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woclID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-order-classifications/:woclID",
    alias: "workOrderClassificationDelete",
    description: `Delete one work_order_classification by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "woclID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woclID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-classifications/:woclID",
    alias: "workOrderClassificationGet",
    description: `Get one work_order_classification`,
    requestFormat: "json",
    parameters: [
      {
        name: "woclID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woclID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-order-classifications/:woclID",
    alias: "workOrderClassificationUpdate",
    description: `Update work_order_classification`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "woclID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woclID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-programs",
    alias: "workOrderProgramList",
    description: `Lists all work_order_programs`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "woprID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderProgramView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-order-programs",
    alias: "workOrderProgramCreate",
    description: `Create one work_order_program`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentProgramCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-order-programs/:woprID",
    alias: "workOrderProgramDelete",
    description: `Delete one work_order_program by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "woprID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-programs/:woprID",
    alias: "workOrderProgramGet",
    description: `Get one work_order_program`,
    requestFormat: "json",
    parameters: [
      {
        name: "woprID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-order-programs/:woprID",
    alias: "workOrderProgramUpdate",
    description: `Update work_order_program`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: incidentProgramCreate_Body,
      },
      {
        name: "woprID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string(),
                institutionName: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-requester-functions",
    alias: "workOrderRequesterFunctionList",
    description: `Lists all work_order_requester_functions`,
    requestFormat: "json",
    parameters: [
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "worfID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderRequesterFunctionView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-order-requester-functions",
    alias: "workOrderRequesterFunctionCreate",
    description: `Create one work_order_requester_function`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                worfID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-order-requester-functions/:worfID",
    alias: "workOrderRequesterFunctionDelete",
    description: `Delete one work_order_requester_function by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "worfID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                worfID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-requester-functions/:worfID",
    alias: "workOrderRequesterFunctionGet",
    description: `Get one work_order_requester_function`,
    requestFormat: "json",
    parameters: [
      {
        name: "worfID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                worfID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-order-requester-functions/:worfID",
    alias: "workOrderRequesterFunctionUpdate",
    description: `Update work_order_requester_function`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "worfID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                worfID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-requester-types",
    alias: "workOrderRequesterTypeList",
    description: `Lists all work_order_requester_types`,
    requestFormat: "json",
    parameters: [
      {
        name: "wortID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "includeRemoved",
        type: "Query",
        schema: z.boolean().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderRequesterTypeView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-order-requester-types",
    alias: "workOrderRequesterTypeCreate",
    description: `Create one work_order_requester_type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                wortID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-order-requester-types/:wortID",
    alias: "workOrderRequesterTypeDelete",
    description: `Delete one work_order_requester_type by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "wortID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                wortID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-requester-types/:wortID",
    alias: "workOrderRequesterTypeGet",
    description: `Get one work_order_requester_type`,
    requestFormat: "json",
    parameters: [
      {
        name: "wortID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                wortID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-order-requester-types/:wortID",
    alias: "workOrderRequesterTypeUpdate",
    description: `Update work_order_requester_type`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: dispatchNatureCreate_Body,
      },
      {
        name: "wortID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                instID: z.string().nullish(),
                institutionName: z.string().nullish(),
                name: z.string(),
                wortID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-status",
    alias: "workOrderStatusList",
    description: `Lists all work_order_statuss`,
    requestFormat: "json",
    parameters: [
      {
        name: "wostID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderStatusView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-order-status",
    alias: "workOrderStatusCreate",
    description: `Create one work_order_status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: workOrderStatusCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
                wostID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-order-status/:wostID",
    alias: "workOrderStatusDelete",
    description: `Delete one work_order_status by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "wostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
                wostID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-status/:wostID",
    alias: "workOrderStatusGet",
    description: `Get one work_order_status`,
    requestFormat: "json",
    parameters: [
      {
        name: "wostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
                wostID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-order-status/:wostID",
    alias: "workOrderStatusUpdate",
    description: `Update work_order_status`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: workOrderStatusCreate_Body,
      },
      {
        name: "wostID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                info: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                name: z.string(),
                reasons: z.array(z.string()).nullish(),
                requiredReason: z.boolean().nullish(),
                wostID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-subprograms",
    alias: "workOrderSubprogramList",
    description: `Lists all work_order_subprograms`,
    requestFormat: "json",
    parameters: [
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "name",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "wosuID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "woprID",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderSubprogramView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-order-subprograms",
    alias: "workOrderSubprogramCreate",
    description: `Create one work_order_subprogram`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: workOrderSubprogramCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
                wosuID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-order-subprograms/:wosuID",
    alias: "workOrderSubprogramDelete",
    description: `Delete one work_order_subprogram by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "wosuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
                wosuID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-order-subprograms/:wosuID",
    alias: "workOrderSubprogramGet",
    description: `Get one work_order_subprogram`,
    requestFormat: "json",
    parameters: [
      {
        name: "wosuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
                wosuID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-order-subprograms/:wosuID",
    alias: "workOrderSubprogramUpdate",
    description: `Update work_order_subprogram`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({ name: z.string() }).passthrough(),
      },
      {
        name: "wosuID",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                name: z.string(),
                woprID: z.number(),
                wosuID: z.number(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-orders",
    alias: "workOrderList",
    description: `Lists all work_orders`,
    requestFormat: "json",
    parameters: [
      {
        name: "classification",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "uIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterType",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "urbanEquipmentName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "startAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterCompanyName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "startAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subprogramName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "woorID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterRole",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "programName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "endAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "endAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "uid",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/work-orders",
    alias: "workOrderCreate",
    description: `Create one work_order`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: workOrderCreate_Body,
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                address: z
                  .object({
                    city: z.string().nullable(),
                    complement: z.string().nullable(),
                    latitude: z.number().nullable(),
                    longitude: z.number().nullable(),
                    neighborhood: z.string().nullable(),
                    number: z.string().nullable(),
                    state: z.string().nullable(),
                    street: z.string().nullable(),
                    zipCode: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                attachment: z.string(),
                classification: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                endAt: z.string().nullish(),
                event: z.string(),
                extraordinaryEffective: z.number(),
                fieldAgents: z.array(
                  github_com_falqondev_cidade360_backend_service_FieldAgentInfo
                ),
                generalEffective: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                ordinaryEffective: z.number(),
                planningIdentifier: z.string(),
                programName: z.string(),
                recoID: z.number().nullish(),
                requester: z
                  .object({
                    documentNumber: z.string().nullable(),
                    documentType: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                requesterCompanyName: z.string().nullish(),
                requesterRole: z.string(),
                requesterType: z.string(),
                startAt: z.string().nullish(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusReason: z.string().nullish(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                urbanEquipmentName: z.string(),
                ureqID: z.number().nullish(),
                userID: z.string(),
                woclID: z.number().nullish(),
                wodoID: z.number().nullish(),
                wofaID: z.number().nullish(),
                woorID: z.string(),
                woprID: z.number().nullish(),
                worfID: z.number().nullish(),
                wortID: z.number().nullish(),
                wostID: z.number(),
                wosuID: z.number().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "delete",
    path: "/api/work-orders/:woorID",
    alias: "workOrderDelete",
    description: `Delete one work_order by id`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "woorID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                address: z
                  .object({
                    city: z.string().nullable(),
                    complement: z.string().nullable(),
                    latitude: z.number().nullable(),
                    longitude: z.number().nullable(),
                    neighborhood: z.string().nullable(),
                    number: z.string().nullable(),
                    state: z.string().nullable(),
                    street: z.string().nullable(),
                    zipCode: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                attachment: z.string(),
                classification: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                endAt: z.string().nullish(),
                event: z.string(),
                extraordinaryEffective: z.number(),
                fieldAgents: z.array(
                  github_com_falqondev_cidade360_backend_service_FieldAgentInfo
                ),
                generalEffective: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                ordinaryEffective: z.number(),
                planningIdentifier: z.string(),
                programName: z.string(),
                recoID: z.number().nullish(),
                requester: z
                  .object({
                    documentNumber: z.string().nullable(),
                    documentType: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                requesterCompanyName: z.string().nullish(),
                requesterRole: z.string(),
                requesterType: z.string(),
                startAt: z.string().nullish(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusReason: z.string().nullish(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                urbanEquipmentName: z.string(),
                ureqID: z.number().nullish(),
                userID: z.string(),
                woclID: z.number().nullish(),
                wodoID: z.number().nullish(),
                wofaID: z.number().nullish(),
                woorID: z.string(),
                woprID: z.number().nullish(),
                worfID: z.number().nullish(),
                wortID: z.number().nullish(),
                wostID: z.number(),
                wosuID: z.number().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-orders/:woorID",
    alias: "workOrderGet",
    description: `Get one work_order`,
    requestFormat: "json",
    parameters: [
      {
        name: "woorID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                address: z
                  .object({
                    city: z.string().nullable(),
                    complement: z.string().nullable(),
                    latitude: z.number().nullable(),
                    longitude: z.number().nullable(),
                    neighborhood: z.string().nullable(),
                    number: z.string().nullable(),
                    state: z.string().nullable(),
                    street: z.string().nullable(),
                    zipCode: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                attachment: z.string(),
                classification: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                endAt: z.string().nullish(),
                event: z.string(),
                extraordinaryEffective: z.number(),
                fieldAgents: z.array(
                  github_com_falqondev_cidade360_backend_service_FieldAgentInfo
                ),
                generalEffective: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                ordinaryEffective: z.number(),
                planningIdentifier: z.string(),
                programName: z.string(),
                recoID: z.number().nullish(),
                requester: z
                  .object({
                    documentNumber: z.string().nullable(),
                    documentType: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                requesterCompanyName: z.string().nullish(),
                requesterRole: z.string(),
                requesterType: z.string(),
                startAt: z.string().nullish(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusReason: z.string().nullish(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                urbanEquipmentName: z.string(),
                ureqID: z.number().nullish(),
                userID: z.string(),
                woclID: z.number().nullish(),
                wodoID: z.number().nullish(),
                wofaID: z.number().nullish(),
                woorID: z.string(),
                woprID: z.number().nullish(),
                worfID: z.number().nullish(),
                wortID: z.number().nullish(),
                wostID: z.number(),
                wosuID: z.number().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "put",
    path: "/api/work-orders/:woorID",
    alias: "workOrderUpdate",
    description: `Update work_order`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: workOrderCreate_Body,
      },
      {
        name: "woorID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                address: z
                  .object({
                    city: z.string().nullable(),
                    complement: z.string().nullable(),
                    latitude: z.number().nullable(),
                    longitude: z.number().nullable(),
                    neighborhood: z.string().nullable(),
                    number: z.string().nullable(),
                    state: z.string().nullable(),
                    street: z.string().nullable(),
                    zipCode: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                attachment: z.string(),
                classification: z.string().nullish(),
                createdAt: z.string(),
                deletedAt: z.string().nullish(),
                description: z.string(),
                endAt: z.string().nullish(),
                event: z.string(),
                extraordinaryEffective: z.number(),
                fieldAgents: z.array(
                  github_com_falqondev_cidade360_backend_service_FieldAgentInfo
                ),
                generalEffective: z.number(),
                instID: z.string(),
                institutionName: z.string(),
                ordinaryEffective: z.number(),
                planningIdentifier: z.string(),
                programName: z.string(),
                recoID: z.number().nullish(),
                requester: z
                  .object({
                    documentNumber: z.string().nullable(),
                    documentType: z.string().nullable(),
                    name: z.string().nullable(),
                    phone: z.string().nullable(),
                  })
                  .partial()
                  .passthrough(),
                requesterCompanyName: z.string().nullish(),
                requesterRole: z.string(),
                requesterType: z.string(),
                startAt: z.string().nullish(),
                status: z.string(),
                statusInfo: z
                  .object({
                    displayOptions: z
                      .object({ color: z.string() })
                      .passthrough()
                      .nullable(),
                  })
                  .partial()
                  .passthrough(),
                statusReason: z.string().nullish(),
                subprogramName: z.string(),
                uid: z.string(),
                updatedAt: z.string(),
                urbanEquipmentName: z.string(),
                ureqID: z.number().nullish(),
                userID: z.string(),
                woclID: z.number().nullish(),
                wodoID: z.number().nullish(),
                wofaID: z.number().nullish(),
                woorID: z.string(),
                woprID: z.number().nullish(),
                worfID: z.number().nullish(),
                wortID: z.number().nullish(),
                wostID: z.number(),
                wosuID: z.number().nullish(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-orders/:woorID/documents",
    alias: "workOrderDocumentList",
    description: `Lists all work_order documents`,
    requestFormat: "json",
    parameters: [
      {
        name: "woorID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "wodoID",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "doteID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "docuID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkOrderDocumentView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/work-orders/download",
    alias: "workOrderDownload",
    description: `Get work order export file`,
    requestFormat: "json",
    parameters: [
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "requesterName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterRole",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "urbanEquipmentName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "programName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterType",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "instID",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "startAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "startAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "endAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "uid",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "uIDs",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "woorID",
        type: "Query",
        schema: z.array(z.string()).nullish(),
      },
      {
        name: "institutionName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "classification",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "createdAt[gte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "createdAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "requesterCompanyName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "subprogramName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "endAt[lte]",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z.string(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/workflow-executions",
    alias: "workflowExecutionsList",
    description: `Lists DBOS workflow executions`,
    requestFormat: "json",
    parameters: [
      {
        name: "authenticatedUser",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "workflowName",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "offset",
        type: "Query",
        schema: z.number().nullish(),
      },
      {
        name: "status",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "workflowIDPrefix",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "endTime",
        type: "Query",
        schema: z.string().nullish(),
      },
      {
        name: "startTime",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkflowExecutionView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/workflow-executions/:workflowID",
    alias: "workflowExecutionsGet",
    description: `Gets a DBOS workflow execution`,
    requestFormat: "json",
    parameters: [
      {
        name: "workflowID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applicationID: z.string().nullish(),
                applicationVersion: z.string().nullish(),
                attempts: z.number(),
                authenticatedUser: z.string().nullish(),
                createdAt: z.string(),
                deadline: z.string().nullish(),
                error: z.string().nullish(),
                executorID: z.string().nullish(),
                forkedFrom: z.string().nullish(),
                input: z.string().nullish(),
                output: z.string().nullish(),
                queueName: z.string().nullish(),
                startedAt: z.string().nullish(),
                status: z.string(),
                updatedAt: z.string(),
                workflowID: z.string(),
                workflowName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "post",
    path: "/api/workflow-executions/:workflowID/cancel",
    alias: "workflowExecutionsCancel",
    description: `Cancels a DBOS workflow execution`,
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        description: `Request data`,
        type: "Body",
        schema: z.object({}).partial().passthrough(),
      },
      {
        name: "workflowID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            item: z
              .object({
                applicationID: z.string().nullish(),
                applicationVersion: z.string().nullish(),
                attempts: z.number(),
                authenticatedUser: z.string().nullish(),
                createdAt: z.string(),
                deadline: z.string().nullish(),
                error: z.string().nullish(),
                executorID: z.string().nullish(),
                forkedFrom: z.string().nullish(),
                input: z.string().nullish(),
                output: z.string().nullish(),
                queueName: z.string().nullish(),
                startedAt: z.string().nullish(),
                status: z.string(),
                updatedAt: z.string(),
                workflowID: z.string(),
                workflowName: z.string(),
              })
              .passthrough(),
            kind: z.string(),
            lang: z.string().nullish(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
  {
    method: "get",
    path: "/api/workflow-executions/:workflowID/steps",
    alias: "workflowExecutionsSteps",
    description: `Lists the durable steps of a DBOS workflow execution`,
    requestFormat: "json",
    parameters: [
      {
        name: "workflowID",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "context",
        type: "Query",
        schema: z.string().nullish(),
      },
    ],
    response: z
      .object({
        context: z.string().nullish(),
        data: z
          .object({
            currentItemCount: z.number(),
            items: z.array(
              github_com_falqondev_cidade360_backend_service_WorkflowExecutionStepView
            ),
            itemsPerPage: z.number(),
            kind: z.string(),
            lang: z.string().nullish(),
            pageIndex: z.number(),
            startIndex: z.number(),
            totalItems: z.number(),
            totalPages: z.number(),
          })
          .passthrough(),
      })
      .passthrough(),
  },
]);

export const api = new Zodios(endpoints);

export function createApiClient(baseUrl: string, options?: ZodiosOptions) {
  return new Zodios(baseUrl, endpoints, options);
}
